webpackJsonp([0],{

/***/ 1042:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FAMILY_EXTENDED = exports.FAMILY_EXTENDED = "\"GT America Extended Regular\", \"Arial\", sans-serif"; // 27 instances
var FAMILY_STANDARD = exports.FAMILY_STANDARD = "\"GT America Standard Regular\", \"Arial\", sans-serif"; // 29 instances
var FAMILY_STANDARD_BOLD = exports.FAMILY_STANDARD_BOLD = "\"GT America Standard Bold\", \"Arial Black\", \"Arial\", sans-serif"; // 12 instances
var FAMILY_EXTENDED_BOLD = exports.FAMILY_EXTENDED_BOLD = "\"GT America Extended Bold\", \"Arial Black\", \"Arial\", sans-serif"; // 25 instances

/***/ }),

/***/ 1043:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RED = exports.RED = '#ff2300';
var BLUE = exports.BLUE = '#3d37bd';
var YELLOW = exports.YELLOW = '#ffff47';
var GREEN = exports.GREEN = '#266e1c';
var BLACK = exports.BLACK = '#000';
var WHITE = exports.WHITE = '#fff';

var DARK_RED = exports.DARK_RED = '#ef2200';

var LESS_BLACK = exports.LESS_BLACK = '#262626';
var GREY_C = exports.GREY_C = '#ccc';
var GREY_E = exports.GREY_E = '#eee';
var GREY_A = exports.GREY_A = '#aaa';
var GREY_6 = exports.GREY_6 = '#666';
var GREY_9 = exports.GREY_9 = '#999';
var GREY_3 = exports.GREY_3 = '#333';

/***/ }),

/***/ 1044:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEagerElement", function() { return createEagerElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEagerFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_symbol_observable__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component$$1 = type;

  if (children) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Component$$1,
      props,
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component$$1, props);
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && _typeof(Component$$1.prototype.isReactComponent) === 'object');
};

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component$$1) {
  return Boolean(typeof Component$$1 === 'function' && !isClassComponent(Component$$1) && !Component$$1.defaultProps && !Component$$1.contextTypes && ("production" === 'production' || !Component$$1.propTypes));
};

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = isReferentiallyTransparentFunctionComponent(type);
  return function (p, c) {
    return createEagerElementUtil(false, isReferentiallyTransparent, type, p, c);
  };
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

/* eslint-disable no-console */
var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || createFactory(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || createFactory(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = createFactory(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Nothing.displayName = 'Nothing';

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".')
      /* eslint-enable */
      );
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createEagerElement = function createEagerElement(type, props, children) {
  var isReferentiallyTransparent = isReferentiallyTransparentFunctionComponent(type
  /* eslint-disable */
  );var hasKey = props && props.hasOwnProperty('key'
  /* eslint-enable */
  );return createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children);
};

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return createEagerElement(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(createFactory);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])

        // Stream of props
        (), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit

        // Clean-up subscription before un-mounting
        ();this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = createFactory(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),

/***/ 1046:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouter = __webpack_require__(64);

var _recompose = __webpack_require__(1044);

exports.default = (0, _recompose.pure)(_reactRouter.Link);

/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(1141);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(448);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(1247);

var _HelmetConstants = __webpack_require__(1189);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),

/***/ 1050:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactHelmet = __webpack_require__(1049);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _NestedStatus = __webpack_require__(1191);

var _NestedStatus2 = _interopRequireDefault(_NestedStatus);

var _NotificationsProvider = __webpack_require__(1142);

var _NotificationsProvider2 = _interopRequireDefault(_NotificationsProvider);

var _reactIntl = __webpack_require__(192);

var _applyRootStyles = __webpack_require__(1193);

var _applyRootStyles2 = _interopRequireDefault(_applyRootStyles);

var _initImageAssets = __webpack_require__(1256);

var _initImageAssets2 = _interopRequireDefault(_initImageAssets);

var _getCurrentUser = __webpack_require__(432);

var _Shell = __webpack_require__(1257);

var _Shell2 = _interopRequireDefault(_Shell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'Depop';
var IOS_ID = '518684914';
var ANDROID_ID = 'com.depop';
var TWITTER_ID = '380944344';
var FB_APP_ID = '127876583993492';

(0, _applyRootStyles2.default)();

var messages = (0, _reactIntl.defineMessages)({
  description: {
    'id': 'Application.defaultDescription',
    'defaultMessage': 'Depop is where the world\'s creatives come to buy, sell and discover the most inspiring and unique things.'
  },
  title: {
    'id': 'Application.defaultTitle',
    'defaultMessage': 'Depop - The creative community\'s mobile marketplace'
  }
});

var _ref = (0, _jsx3.default)(_NestedStatus2.default, {
  code: 200
});

var Application = function (_React$PureComponent) {
  (0, _inherits3.default)(Application, _React$PureComponent);

  function Application() {
    (0, _classCallCheck3.default)(this, Application);
    return (0, _possibleConstructorReturn3.default)(this, (Application.__proto__ || (0, _getPrototypeOf2.default)(Application)).apply(this, arguments));
  }

  (0, _createClass3.default)(Application, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          viewer = _props.viewer,
          hideFooter = _props.hideFooter,
          hideHeader = _props.hideHeader,
          hideAppBanner = _props.hideAppBanner,
          hideCookieBanner = _props.hideCookieBanner,
          intl = _props.intl;


      return (0, _jsx3.default)(_NotificationsProvider2.default, {}, void 0, (0, _jsx3.default)('div', {}, void 0, _ref, (0, _jsx3.default)(_reactHelmet2.default, {
        titleTemplate: '%s - Depop',
        defaultTitle: intl.formatMessage(messages.title),
        htmlAttributes: { lang: intl.locale },
        link: [{
          rel: 'canonical',
          href: 'https://www.depop.com/'
        }],
        meta: [{ name: 'charset', content: 'utf-8' }, { name: 'description', content: intl.formatMessage(messages.description) }, { name: 'viewport', content: 'width=device-width, initial-scale=1' }, { name: 'twitter:card', content: 'app' }, { name: 'twitter:site', content: '@depop' }, { name: 'twitter:creator:id', content: TWITTER_ID }, { name: 'twitter:description', content: intl.formatMessage(messages.description) }, { name: 'twitter:app:id:iphone', content: IOS_ID }, { name: 'twitter:app:id:ipad', content: IOS_ID }, { name: 'twitter:app:id:googleplay', content: ANDROID_ID }, { name: 'twitter:app:name:iphone', content: NAME }, { name: 'twitter:app:name:ipad', content: NAME }, { name: 'twitter:app:name:googleplay', content: NAME }, { name: 'twitter:app:url:iphone', content: 'depop://' }, { name: 'twitter:app:url:ipad', content: 'depop://' }, { name: 'twitter:app:url:googleplay', content: 'https://play.google.com/store/apps/details?id=' + ANDROID_ID }, { property: 'fb:app_id', content: FB_APP_ID }, { property: 'og:title', content: intl.formatMessage(messages.title) }, { property: 'og:description', content: intl.formatMessage(messages.description) }, { property: 'og:url', content: 'https://www.depop.com' }]
      }), (0, _jsx3.default)(_Shell2.default, {
        viewer: viewer,
        hideHeader: hideHeader,
        hideFooter: hideFooter,
        hideAppBanner: hideAppBanner,
        hideCookieBanner: hideCookieBanner
      }, void 0, children)));
    }
  }]);
  return Application;
}(_react2.default.PureComponent);

exports.default = _reactRelay2.default.createContainer((0, _reactIntl.injectIntl)(Application), {
  fragments: {
    viewer: function viewer() {
      return function (RQL_0, RQL_1) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0), _reactRelay2.default.QL.__frag(RQL_1)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Application_ViewerRelayQL',
          type: 'Viewer'
        };
      }(_getCurrentUser.currentUserFragment, _Shell2.default.getFragment('viewer'));
    }
  }
});

/***/ }),

/***/ 1052:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollTop = undefined;

var _ScrollTop2 = __webpack_require__(1248);

var _ScrollTop3 = _interopRequireDefault(_ScrollTop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ScrollTop = _ScrollTop3.default;

/***/ }),

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(146),
    isObjectLike = __webpack_require__(147);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(287);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticPicture = undefined;

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(65);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _debounce2 = __webpack_require__(1249);

var _debounce3 = _interopRequireDefault(_debounce2);

var _isEqual2 = __webpack_require__(431);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _class, _temp;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _glamor = __webpack_require__(415);

var _colors = __webpack_require__(1043);

var _Linear = __webpack_require__(1251);

var _Linear2 = _interopRequireDefault(_Linear);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cleanFormats(formats) {
  return formats.map(function (format) {
    return {
      size: format.width,
      url: format.url
    };
  });
}

var _ref = (0, _jsx3.default)(_Linear2.default, {});

var Picture = (_temp = _class = function (_React$PureComponent) {
  (0, _inherits3.default)(Picture, _React$PureComponent);

  function Picture(props) {
    (0, _classCallCheck3.default)(this, Picture);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Picture.__proto__ || (0, _getPrototypeOf2.default)(Picture)).call(this, props));

    _this.loadImage = function () {
      window.loadImage(_this._imgContainer);
    };

    _this.loadImage = (0, _debounce3.default)(_this.loadImage, 250, { leading: true });
    _this.state = { mounted: false };
    return _this;
  }

  (0, _createClass3.default)(Picture, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var cleanedFormats = cleanFormats(this.props.picture.formats);
      var nextCleanedFormats = cleanFormats(nextProps.picture.formats);

      if (!(0, _isEqual3.default)(cleanedFormats, nextCleanedFormats)) {
        if (this && this._imgContainer) {
          this._imgContainer.innerHTML = '';
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      window.loadImage(this._imgContainer);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ mounted: true });
      this.loadImage();
      window.addEventListener('resize', this.loadImage);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.loadImage);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$picture = _props.picture,
          picture = _props$picture === undefined ? {} : _props$picture,
          rounded = _props.rounded,
          useLoader = _props.useLoader;
      // const ratio = picture.width / picture.height;

      var ratio = picture.height / picture.width;
      var heightPercentage = 100 * ratio;

      var baseWrapperStyles = (0, _glamor.css)({
        backgroundColor: _colors.GREY_E,
        width: '100%',
        position: 'relative',
        overflow: 'hidden'
      });

      var wrapperStyles = rounded ? (0, _glamor.merge)(baseWrapperStyles, (0, _glamor.css)({ borderRadius: '50%' })) : baseWrapperStyles;

      var baseImageStyles = (0, _glamor.css)({
        '> img': {
          position: 'absolute',
          width: '100%',
          height: '100%',
          verticalAlign: 'bottom',
          display: 'block',
          zIndex: 50
        }
      });

      var imageStyles = rounded ? (0, _glamor.merge)(baseImageStyles, (0, _glamor.css)({
        '> img': { borderRadius: '50%' }
      })) : baseImageStyles;

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, wrapperStyles, { style: { paddingBottom: heightPercentage + '%' } }),
        useLoader && this.state.mounted && _react2.default.createElement(
          'div',
          (0, _glamor.css)({
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10
          }),
          _ref
        ),
        _react2.default.createElement('div', (0, _extends3.default)({}, imageStyles, {
          ref: function ref(element) {
            return _this2._imgContainer = element;
          },
          'data-picture': true,
          'data-formats': (0, _stringify2.default)(cleanFormats(picture.formats))
        }))
      );
    }
  }]);
  return Picture;
}(_react2.default.PureComponent), _class.defaultProps = {
  rounded: false,
  useLoader: false,
  lazyloadOffset: 0,
  scrollDelay: 250
}, _temp);

var StaticPicture = exports.StaticPicture = function (_Picture) {
  (0, _inherits3.default)(StaticPicture, _Picture);

  function StaticPicture() {
    (0, _classCallCheck3.default)(this, StaticPicture);
    return (0, _possibleConstructorReturn3.default)(this, (StaticPicture.__proto__ || (0, _getPrototypeOf2.default)(StaticPicture)).apply(this, arguments));
  }

  return StaticPicture;
}(Picture);

;

exports.default = _reactRelay2.default.createContainer(Picture, {
  fragments: {
    picture: function picture() {
      return function () {
        return {
          children: [{
            fieldName: 'url',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'width',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'height',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            children: [{
              fieldName: 'url',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'width',
              kind: 'Field',
              metadata: {},
              type: 'Int'
            }, {
              fieldName: 'height',
              kind: 'Field',
              metadata: {},
              type: 'Int'
            }],
            fieldName: 'formats',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              isPlural: true
            },
            type: 'PictureFormat'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Picture_PictureRelayQL',
          type: 'Picture'
        };
      }();
    }
  }
});

/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ZINDEX_NAVIGATION = exports.ZINDEX_NAVIGATION = 1500;
var ZINDEX_DEEPLINKS = exports.ZINDEX_DEEPLINKS = 2000;
var ZINDEX_OVERLAY_BG = exports.ZINDEX_OVERLAY_BG = 3000;
var ZINDEX_MODAL = exports.ZINDEX_MODAL = 4000;
var ZINDEX_LOGO = exports.ZINDEX_LOGO = 5000;
var ZINDEX_COOKIE_BANNER = exports.ZINDEX_COOKIE_BANNER = 5000;
var ZINDEX_PAGE_BOTTOM_WRAP = exports.ZINDEX_PAGE_BOTTOM_WRAP = 1000;

/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _InfiniteScroll = __webpack_require__(1397);

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _Ball = __webpack_require__(1398);

var _Ball2 = _interopRequireDefault(_Ball);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = (0, _jsx3.default)(_Ball2.default, {});

var SimpleInfiniteScroll = function SimpleInfiniteScroll(_ref) {
  var children = _ref.children,
      hasMore = _ref.hasMore,
      loadMore = _ref.loadMore,
      disablePaging = _ref.disablePaging,
      _ref$useWindow = _ref.useWindow,
      useWindow = _ref$useWindow === undefined ? true : _ref$useWindow;
  return (0, _jsx3.default)(_InfiniteScroll2.default, {
    style: { width: '100%' },
    pageStart: 0,
    loadMore: loadMore,
    disablePaging: disablePaging,
    hasMore: hasMore,
    loader: _ref2,
    useWindow: useWindow,
    threshold: 500
  }, void 0, children);
};

exports.default = SimpleInfiniteScroll;

/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$rotate = _ref.rotate,
      rotate = _ref$rotate === undefined ? 0 : _ref$rotate,
      _ref$scale = _ref.scale,
      scale = _ref$scale === undefined ? 1 : _ref$scale;
  return (0, _jsx3.default)('div', {
    style: { transform: 'rotate(' + rotate + 'deg) scale(' + scale + ')' }
  }, void 0, (0, _jsx3.default)('svg', {
    viewBox: '0 0 40 40'
  }, void 0, (0, _jsx3.default)('polygon', {
    fill: fill,
    points: '25.0007575 20.0007575 40 5.00265103 35 3.55271368e-15 20 15 5 3.55271368e-15 -1.42108547e-14 5.00265103 14.9992425 20.0007575 0 35 5 40 20 25.0011362 35 40 40 35 25.0007575 20.0007575'
  })));
};

/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadConnector = exports.loginConnector = undefined;

var _reactRedux = __webpack_require__(416);

var _navigation = __webpack_require__(424);

var loginConnector = exports.loginConnector = (0, _reactRedux.connect)(null, function (dispatch) {
  return {
    openLogin: function openLogin() {
      return dispatch((0, _navigation.openLogin)());
    }
  };
});

var downloadConnector = exports.downloadConnector = (0, _reactRedux.connect)(null, function (dispatch) {
  return {
    openDownload: function openDownload() {
      return dispatch((0, _navigation.openDownload)());
    }
  };
});

/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(26);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(124);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(416);

var _reactSideEffect = __webpack_require__(1141);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _overlays = __webpack_require__(426);

var _deeplinks = __webpack_require__(1085);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Noop = function () {
  function Noop(props) {
    return null;
  }

  return Noop;
}();

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];

  if (innermostProps) {
    return innermostProps;
  }
  return {};
}

function handleStateChangeOnClient(props) {
  var update = props.update,
      config = (0, _objectWithoutProperties3.default)(props, ['update']);


  if (!update) {
    return;
  }

  if ((0, _keys2.default)(config).length <= 0) {
    update(null);
    return;
  }

  var path = config.path,
      referer = config.referer,
      canonicalUrl = config.canonicalUrl,
      position = config.position;

  var pathNotSet = path === null || path === undefined;
  var urlNotSet = canonicalUrl === null || canonicalUrl === undefined;

  if (pathNotSet || urlNotSet) {
    update(null);
    return false;
  }

  (0, _deeplinks.createLink)(path, referer, {
    '$canonical_url': canonicalUrl
  }, function (link) {
    update({
      path: path,
      referer: referer,
      canonicalUrl: canonicalUrl,
      link: link
    });
  });
}

var Wrapped = (0, _reactSideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(Noop);

var mapStateToProps = function mapStateToProps() {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    update: function update(value, position) {
      return dispatch((0, _overlays.updateDeepLink)(value));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Wrapped);

/***/ }),

/***/ 1085:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stopExpectingJourney = exports.expectJourney = exports.createLink = exports.sendSMS = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(417);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(418);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(145);

var _promise2 = _interopRequireDefault(_promise);

exports.isClient = isClient;
exports.isBannerPlatform = isBannerPlatform;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isClient() {
  if (typeof window !== 'undefined') {
    return true;
  }
  return false;
}

function isBannerPlatform(platform) {
  var bannerPlatforms = ['iPhone', 'iPod', 'iPad', 'Android'];
  if (bannerPlatforms.indexOf(platform) !== -1) {
    return true;
  }
  return false;
}

var initBranch = function initBranch() {
  return new _promise2.default(function (resolve, reject) {
    __webpack_require__(1284).default;
    var configData = JSON.parse(document.getElementById('configData').textContent);
    var branchKey = configData.analytics.branch;
    window.branch.init(branchKey, {
      no_journeys: false ? true : false
    }, function (err, data) {
      if (err) {
        reject(err);
        return;
      }
      resolve(window.branch);
    });
  });
};

var getBranch = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isClient()) {
              _context.next = 6;
              break;
            }

            if (!(typeof window.branch !== 'undefined')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return', window.branch);

          case 3:
            _context.next = 5;
            return initBranch();

          case 5:
            return _context.abrupt('return', _context.sent);

          case 6:
            return _context.abrupt('return', false);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getBranch() {
    return _ref.apply(this, arguments);
  };
}();

var expectJourney = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(callback) {
    var branch;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getBranch();

          case 2:
            branch = _context2.sent;

            if (branch) {
              branch.addListener('willShowJourney', function (resp) {
                return callback(true);
              });
              branch.addListener('willNotShowJourney', function (resp) {
                return callback(false);
              });
            }

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function expectJourney(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var stopExpectingJourney = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
    var branch;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getBranch();

          case 2:
            branch = _context3.sent;

            if (branch) {
              branch.removeListener('willShowJourney');
              branch.removeListener('willNotShowJourney');
            }

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function stopExpectingJourney() {
    return _ref3.apply(this, arguments);
  };
}();

var sendSMS = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(number, deeplink, referrer, callback) {
    var branch;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getBranch();

          case 2:
            branch = _context4.sent;


            if (branch) {
              branch.sendSMS(number, {
                data: {
                  '$deeplink_path': deeplink,
                  'referring_user': referrer
                }
              }, {
                make_new_link: true
              }, callback);
            }

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function sendSMS(_x2, _x3, _x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var createLink = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(linkPath, refer, params, callback) {
    var branch;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return getBranch();

          case 2:
            branch = _context5.sent;

            if (!(params.$canonical_url === undefined || linkPath === undefined)) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt('return', false);

          case 5:

            if (branch) {
              branch.link((0, _extends3.default)({}, params, {
                data: {
                  'referring_user': refer,
                  '$deeplink_path': linkPath,
                  'referringURL': params.$canonical_url,
                  'branch_channel': params.channel,
                  'username': refer
                }
              }), function (err, link) {
                if (link) {
                  callback(link);
                  return true;
                }
                console.error(err);
                return false;
              });
            }

          case 6:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined);
  }));

  return function createLink(_x6, _x7, _x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}();

exports.sendSMS = sendSMS;
exports.createLink = createLink;
exports.expectJourney = expectJourney;
exports.stopExpectingJourney = stopExpectingJourney;

/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fbemitter = __webpack_require__(1276);

var values = {};
var experiments = {};
var experimentWeights = {};
var activeExperiments = {};
var experimentsWithDefinedVariants = {};
var playedExperiments = {};

var emitter = new _fbemitter.EventEmitter();

var PushtellEventEmitter = function PushtellEventEmitter() {};

PushtellEventEmitter.prototype.emitWin = function (experimentName) {
  if (typeof experimentName !== 'string') {
    throw new Error("Required argument 'experimentName' should have type 'string'");
  }
  emitter.emit("win", experimentName, values[experimentName]);
};

PushtellEventEmitter.prototype._emitPlay = function (experimentName, variantName) {
  if (typeof experimentName !== 'string') {
    throw new Error("Required argument 'experimentName' should have type 'string'");
  }
  if (typeof variantName !== 'string') {
    throw new Error("Required argument 'variantName' should have type 'string'");
  }
  if (!playedExperiments[experimentName]) {
    emitter.emit('play', experimentName, variantName);
    playedExperiments[experimentName] = true;
  }
};

PushtellEventEmitter.prototype._resetPlayedExperiments = function () {
  values = {};
  playedExperiments = {};
};

PushtellEventEmitter.prototype._reset = function () {
  values = {};
  experiments = {};
  experimentWeights = {};
  activeExperiments = {};
  experimentsWithDefinedVariants = {};
  playedExperiments = {};
};

PushtellEventEmitter.prototype.rewind = function () {
  this._reset();
  emitter.removeAllListeners();
};

PushtellEventEmitter.prototype._incrementActiveExperiments = function (experimentName) {
  activeExperiments[experimentName] = activeExperiments[experimentName] || 0;
  activeExperiments[experimentName] += 1;
  emitter.emit("active", experimentName);
};

PushtellEventEmitter.prototype._decrementActiveExperiments = function (experimentName) {
  activeExperiments[experimentName] -= 1;
  emitter.emit("inactive", experimentName);
};

PushtellEventEmitter.prototype.addActiveVariantListener = function (experimentName, callback) {
  if (typeof experimentName === "function") {
    callback = experimentName;
    return emitter.addListener("active-variant", function (_experimentName, variantName, passthrough) {
      callback(_experimentName, variantName, passthrough);
    });
  }
  return emitter.addListener("active-variant", function (_experimentName, variantName, passthrough) {
    if (_experimentName === experimentName) {
      callback(_experimentName, variantName, passthrough);
    }
  });
};

PushtellEventEmitter.prototype.emit = function () {
  return emitter.emit.apply(emitter, arguments);
};

PushtellEventEmitter.prototype.addListener = function (eventName, callback) {
  return emitter.addListener(eventName, callback);
};

PushtellEventEmitter.prototype.once = function (eventName, callback) {
  return emitter.once(eventName, callback);
};

PushtellEventEmitter.prototype.addPlayListener = function (experimentName, callback) {
  if (typeof experimentName === "function") {
    callback = experimentName;
    return emitter.addListener('play', function (_experimentName, variantName) {
      callback(_experimentName, variantName);
    });
  }
  return emitter.addListener('play', function (_experimentName, variantName) {
    if (_experimentName === experimentName) {
      callback(_experimentName, variantName);
    }
  });
};

PushtellEventEmitter.prototype.addWinListener = function (experimentName, callback) {
  if (typeof experimentName === "function") {
    callback = experimentName;
    return emitter.addListener('win', function (_experimentName, variantName) {
      callback(_experimentName, variantName);
    });
  }
  return emitter.addListener('win', function (_experimentName, variantName) {
    if (_experimentName === experimentName) {
      callback(_experimentName, variantName);
    }
  });
};

PushtellEventEmitter.prototype.defineVariants = function (experimentName, variantNames, variantWeights) {
  var variantsNamesMap = {};
  var variantWeightsMap = {};
  variantNames.forEach(function (variantName) {
    variantsNamesMap[variantName] = true;
  });
  if (Array.isArray(variantWeights)) {
    if (variantNames.length !== variantWeights.length) {
      throw new Error("Required argument 'variantNames' should have the same number of elements as optional argument 'variantWeights'");
    }
    variantNames.forEach(function (variantName, index) {
      if (typeof variantWeights[index] !== 'number') {
        throw new Error("Optional argument 'variantWeights' should be an array of numbers.");
      }
      variantWeightsMap[variantName] = variantWeights[index];
    });
  } else {
    variantNames.forEach(function (variantName, index) {
      variantWeightsMap[variantName] = 1;
    });
  }
  experimentWeights[experimentName] = variantWeightsMap;
  experiments[experimentName] = variantsNamesMap;
  experimentsWithDefinedVariants[experimentName] = true;
};

PushtellEventEmitter.prototype.getSortedVariants = function (experimentName) {
  var variantNames = Object.keys(experiments[experimentName]);
  variantNames.sort();
  return variantNames;
};

PushtellEventEmitter.prototype.getSortedVariantWeights = function (experimentName) {
  return this.getSortedVariants(experimentName).map(function (variantName) {
    return experimentWeights[experimentName][variantName];
  });
};

PushtellEventEmitter.prototype.getActiveExperiments = function () {
  var response = {};
  Object.keys(activeExperiments).forEach(function (experimentName) {
    if (activeExperiments[experimentName] === 0) {
      return;
    }
    response[experimentName] = {};
    Object.keys(experiments[experimentName]).forEach(function (variantName) {
      response[experimentName][variantName] = values[experimentName] === variantName;
    });
  });
  return response;
};

PushtellEventEmitter.prototype.getActiveVariant = function (experimentName) {
  return values[experimentName];
};

PushtellEventEmitter.prototype.setActiveVariant = function (experimentName, variantName, passthrough) {
  values[experimentName] = variantName;
  emitter.emit("active-variant", experimentName, variantName, passthrough);
};

PushtellEventEmitter.prototype.addExperimentVariant = function (experimentName, variantName) {
  experiments[experimentName] = experiments[experimentName] || {};
  experimentWeights[experimentName] = experimentWeights[experimentName] || {};
  if (experiments[experimentName][variantName] !== true) {
    if (experimentsWithDefinedVariants[experimentName]) {
      var error = new Error("Experiment “" + experimentName + "” added new variants after variants were defined.");
      error.type = "PUSHTELL_INVALID_VARIANT";
      throw error;
    }
    if (values[experimentName]) {
      var _error = new Error("Experiment “" + experimentName + "” added new variants after a variant was selected. Declare the variant names using emitter.defineVariants(experimentName, variantNames).");
      _error.type = "PUSHTELL_INVALID_VARIANT";
      throw _error;
    }
    experimentWeights[experimentName][variantName] = 1;
  }
  experiments[experimentName][variantName] = true;
};

exports.default = new PushtellEventEmitter();
;
module.exports = exports['default'];

/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLocation = exports.withRouter = undefined;

var _reactRouter = __webpack_require__(64);

Object.defineProperty(exports, 'withRouter', {
  enumerable: true,
  get: function get() {
    return _reactRouter.withRouter;
  }
});

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(1044);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withLocation = exports.withLocation = (0, _recompose.getContext)({ location: _propTypes2.default.object });

/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1252);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 1128:
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__(1044);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = function Container(_ref) {
  var children = _ref.children,
      _ref$condensed = _ref.condensed,
      condensed = _ref$condensed === undefined ? false : _ref$condensed;
  return _react2.default.createElement(
    'div',
    (0, _glamor.css)({
      padding: condensed ? '8px 16px' : '16px 16px',
      '@media (min-width: 701px)': {
        padding: condensed ? '8px 7.5vw' : '16px 7.5vw'
      }
    }),
    children
  );
};

exports.default = (0, _recompose.pure)(Container);

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _glamor = __webpack_require__(415);

var _reactHelmet = __webpack_require__(1049);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _NestedStatus = __webpack_require__(1191);

var _NestedStatus2 = _interopRequireDefault(_NestedStatus);

var _Application = __webpack_require__(1050);

var _Application2 = _interopRequireDefault(_Application);

var _scroll = __webpack_require__(1052);

var _reactIntl = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  title: {
    'id': 'NotFound.title',
    'defaultMessage': 'Page Not Found'
  },
  appLinkText: {
    'id': 'NotFound.messageAppLinkText',
    'defaultMessage': 'use the app instead'
  }
});

var _ref2 = (0, _jsx3.default)(_scroll.ScrollTop, {});

var _ref3 = (0, _jsx3.default)(_NestedStatus2.default, {
  code: 404
});

var _ref4 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'NotFound.smallMessage',
  description: 'Small status code message on not found page',
  defaultMessage: '404 page not found'
});

var NotFound = function NotFound(_ref) {
  var intl = _ref.intl,
      viewer = _ref.viewer;

  return (0, _jsx3.default)(_Application2.default, {
    viewer: viewer
  }, void 0, _react2.default.createElement(
    'div',
    (0, _glamor.style)({ height: '70vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }),
    _ref2,
    (0, _jsx3.default)(_reactHelmet2.default, {
      title: intl.formatMessage(messages.title),
      meta: [{ name: 'robots', content: 'noindex' }],
      link: [{
        rel: 'canonical',
        href: 'https://www.depop.com/not-found'
      }]
    }),
    _ref3,
    _react2.default.createElement(
      'h1',
      (0, _glamor.style)({ fontWeight: 'normal', fontSize: '24px', marginBottom: '1em' }),
      (0, _jsx3.default)(_reactIntl.FormattedMessage, {
        id: 'NotFound.message',
        description: 'Message on the not found page',
        defaultMessage: 'Sorry, that page doesn\'t exist. Try again or {link}',
        values: {
          link: _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, (0, _glamor.style)({ color: 'inherit', fontWeight: 'bold' }), { href: 'https://depop-beta.app.link/F5P0iUMdUw' }),
            intl.formatMessage(messages.appLinkText)
          )
        }
      })
    ),
    _react2.default.createElement(
      'p',
      (0, _glamor.style)({ fontSize: '14px' }),
      _ref4
    )
  ));
};

exports.default = _reactRelay2.default.createContainer((0, _reactIntl.injectIntl)(NotFound), {
  fragments: {
    viewer: function viewer() {
      return function (RQL_0) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'NotFound_ViewerRelayQL',
          type: 'Viewer'
        };
      }(_Application2.default.getFragment('viewer'));
    }
  }
});

/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductListItem = exports.ProductList = undefined;

var _ProductList2 = __webpack_require__(1387);

var _ProductList3 = _interopRequireDefault(_ProductList2);

var _ProductListItem2 = __webpack_require__(1232);

var _ProductListItem3 = _interopRequireDefault(_ProductListItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ProductList = _ProductList3.default;
exports.ProductListItem = _ProductListItem3.default;

/***/ }),

/***/ 1141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(1245);

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__(1246);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !(0, _shallowequal2.default)(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = _exenv2.default.canUseDOM;


    return SideEffect;
  };
};

/***/ }),

/***/ 1142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withNotifications = exports.NotificationsProvider = undefined;

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = __webpack_require__(1057);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _uniqueId2 = __webpack_require__(1143);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _class, _temp;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBroadcast = __webpack_require__(1192);

var _recompose = __webpack_require__(1044);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationsProvider = exports.NotificationsProvider = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(NotificationsProvider, _React$Component);

  function NotificationsProvider(props) {
    (0, _classCallCheck3.default)(this, NotificationsProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NotificationsProvider.__proto__ || (0, _getPrototypeOf2.default)(NotificationsProvider)).call(this, props));

    _this.addNotification = function (text) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';

      _this.setState(function (_ref) {
        var notifications = _ref.notifications;

        var id = (0, _uniqueId3.default)();

        setTimeout(function () {
          return _this.removeNotification(id);
        }, 5000);

        return {
          notifications: [].concat((0, _toConsumableArray3.default)(notifications), [{
            id: id,
            content: text,
            status: status
          }])
        };
      });
    };

    _this.removeNotification = function (id) {
      _this.setState(function (_ref2) {
        var notifications = _ref2.notifications;

        var index = notifications.findIndex(function (notification) {
          return notification.id === id;
        });

        if (index < 0) {
          return;
        }

        return {
          notifications: [].concat((0, _toConsumableArray3.default)(notifications.slice(0, index)), (0, _toConsumableArray3.default)(notifications.slice(index + 1)))
        };
      });
    };

    _this.state = {
      notifications: []
    };
    return _this;
  }

  (0, _createClass3.default)(NotificationsProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        addNotification: this.addNotification,
        removeNotification: this.removeNotification
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return (0, _jsx3.default)(_reactBroadcast.Broadcast, {
        channel: 'notifications',
        value: this.state.notifications
      }, void 0, this.props.children);
    }
  }]);
  return NotificationsProvider;
}(_react2.default.Component), _class.childContextTypes = {
  addNotification: _propTypes2.default.func,
  removeNotification: _propTypes2.default.func
}, _temp);


var withNotifications = (0, _recompose.getContext)({
  addNotification: _propTypes2.default.func,
  removeNotification: _propTypes2.default.func
});

exports.withNotifications = withNotifications;
exports.default = NotificationsProvider;

/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(1127);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ 1145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FillHorizontal(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    (0, _glamor.css)({
      display: 'flex',
      flexDirection: 'row'
    }),
    children
  );
}

FillHorizontal.Spacer = function Separator(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === undefined ? 8 : _ref2$size;

  return _react2.default.createElement('div', (0, _glamor.css)({
    width: size,
    flexGrow: 1
  }));
};

FillHorizontal.Separator = function Separator(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === undefined ? 8 : _ref3$size;

  return _react2.default.createElement('div', (0, _glamor.css)({
    width: size,
    flexGrow: 0,
    flexShrink: 0
  }));
};

exports.default = FillHorizontal;

/***/ }),

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(124);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.buildShopLocation = buildShopLocation;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactRouter = __webpack_require__(64);

var _recompose = __webpack_require__(1044);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildShopLocation(username, id, from, listIndex) {
  return {
    pathname: '/' + username,
    state: {
      userId: id,
      from: from,
      listIndex: listIndex
    }
  };
}

var ShopLink = function ShopLink(_ref) {
  var user = _ref.user,
      from = _ref.from,
      relay = _ref.relay,
      listIndex = _ref.listIndex,
      props = (0, _objectWithoutProperties3.default)(_ref, ['user', 'from', 'relay', 'listIndex']);
  return _react2.default.createElement(_reactRouter.Link, (0, _extends3.default)({ to: buildShopLocation(user.username, user.publicId, from, listIndex) }, props));
};

exports.default = _reactRelay2.default.createContainer((0, _recompose.pure)(ShopLink), {
  fragments: {
    user: function user() {
      return function () {
        return {
          children: [{
            fieldName: 'publicId',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'username',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'ShopLink_UserRelayQL',
          type: 'User'
        };
      }();
    }
  }
});

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initExperiment = exports.emmitButtonClick = undefined;

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _objectWithoutProperties2 = __webpack_require__(124);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(416);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAbTest = __webpack_require__(1273);

var _url = __webpack_require__(1283);

var _tracking = __webpack_require__(193);

var _overlays = __webpack_require__(426);

var _DeeplinkConfig = __webpack_require__(1080);

var _DeeplinkConfig2 = _interopRequireDefault(_DeeplinkConfig);

var _config = __webpack_require__(281);

var _HomeHeader = __webpack_require__(1285);

var _HomeHeader2 = _interopRequireDefault(_HomeHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noTrackVariant = 'NX';

var createTrackingObject = function createTrackingObject(experimentName, variantName) {
  return { testId: experimentName, variantId: variantName };
};
var filteredRun = function filteredRun(callback) {
  return function (experimentName, variantName) {
    return variantName !== noTrackVariant ? callback(experimentName, variantName) : function () {
      return null;
    };
  };
};

var trackExperimentShow = function trackExperimentShow(experimentName, variantName) {
  return (0, _tracking.trackShowAB)({ testId: experimentName, variantId: variantName });
};
var trackExperimentWin = function trackExperimentWin(experimentName, variantName, buttonName) {
  return (0, _tracking.trackActionAB)({ testId: experimentName, variantId: variantName, button: buttonName });
};

var emmitButtonClick = exports.emmitButtonClick = function emmitButtonClick(experimentName, buttonName) {
  if (!experimentName || !buttonName) {
    return false;
  }
  var variantId = _reactAbTest.emitter.getActiveVariant(experimentName);

  if (!variantId) {
    return false;
  }

  trackExperimentWin(experimentName, variantId, buttonName);
};

var initExperiment = exports.initExperiment = function initExperiment(experimentName) {
  // emitter.defineVariants(experimentName, ['A', 'B'], [50, 50]);
  _reactAbTest.emitter.defineVariants(experimentName, ['A', 'B'], [0, 100]);
  // Called when the experiment is displayed to the user.
  _reactAbTest.emitter.addPlayListener(experimentName, filteredRun(trackExperimentShow));

  var userSetVariant = (0, _url.getSearchParam)('variant');
  if (userSetVariant) {
    console.log('Setting variant to: ', userSetVariant);
    _reactAbTest.emitter.setActiveVariant(experimentName, userSetVariant);
  }

  if (false) {
    _reactAbTest.experimentDebugger.enable();
  }
};

var HomeAB = function (_React$Component) {
  (0, _inherits3.default)(HomeAB, _React$Component);

  function HomeAB() {
    (0, _classCallCheck3.default)(this, HomeAB);
    return (0, _possibleConstructorReturn3.default)(this, (HomeAB.__proto__ || (0, _getPrototypeOf2.default)(HomeAB)).apply(this, arguments));
  }

  (0, _createClass3.default)(HomeAB, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var updateAB = this.props.updateAB;

      updateAB();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          experiment = _props.experiment,
          updateAB = _props.updateAB;

      var variantId = _reactAbTest.emitter.getActiveVariant(experiment);
      updateAB(variantId);
    }
  }, {
    key: 'onStoreButtonClick',
    value: function onStoreButtonClick(store) {
      var experiment = this.props.experiment;

      emmitButtonClick(experiment, store || 'app store');
      this.refs.experiment.win();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          experiment = _props2.experiment,
          abId = _props2.abId,
          props = (0, _objectWithoutProperties3.default)(_props2, ['children', 'experiment', 'abId']);

      var token = abId;
      var onStoreButtonClick = this.onStoreButtonClick.bind(this);

      return _react2.default.createElement(
        _reactAbTest.Experiment,
        { ref: 'experiment', name: experiment, userIdentifier: token },
        (0, _jsx3.default)(_reactAbTest.Variant, {
          name: 'A'
        }, void 0, (0, _jsx3.default)(_DeeplinkConfig2.default, {
          path: 'explore',
          referer: experiment + '_A',
          canonicalUrl: 'https://www.depop.com/'
        })),
        (0, _jsx3.default)(_reactAbTest.Variant, {
          name: 'B'
        }, void 0, (0, _jsx3.default)(_DeeplinkConfig2.default, {
          path: 'explore',
          referer: experiment + '_B',
          canonicalUrl: 'https://www.depop.com/'
        }), (0, _jsx3.default)(_HomeHeader2.default, {
          action: onStoreButtonClick
        }))
      );
    }
  }]);
  return HomeAB;
}(_react2.default.Component);

;

var mapStateToProps = function mapStateToProps(_ref) {
  var abId = _ref.abId;
  return {
    abId: abId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateAB: function updateAB(value) {
      return dispatch((0, _overlays.updateLandingAB)(value));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HomeAB);

/***/ }),

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(1260);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(1262);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(1263);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(1265);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(1195);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(1144);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(1266);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ 1153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ 1154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),

/***/ 1155:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1194)))

/***/ }),

/***/ 1156:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1261)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),

/***/ 1157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),

/***/ 1158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(1269);
var parse = __webpack_require__(1270);
var formats = __webpack_require__(1199);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 1159:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__(1044);

var _colors = __webpack_require__(1043);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logo = function Logo() {
  return _react2.default.createElement(
    'div',
    (0, _glamor.css)({
      display: 'inline-block',
      width: '100%',
      height: '100%'
    }),
    (0, _jsx3.default)('svg', {
      viewBox: '0 0 1295 333'
    }, void 0, _react2.default.createElement('path', (0, _extends3.default)({}, (0, _glamor.css)({ fill: _colors.RED }), {
      fillRule: 'nonzero',
      d: 'M0 167.9c0-54.5 38.884-88 101.06-88h64.373V0H246v251H100.76C38.883 251 0 218.8 0 167.9zm85-2.7c0 20.9 12.653 31.8 36.96 31.8H165v-64h-42.64C98.05 133 85 144 85 165.2zm682-.1c0 54.5-38.884 88-101.06 88h-64.373V333H521V82h145.24C728.117 82 767 114.2 767 165.1zm-85 2.7c0-20.9-12.668-31.8-37.007-31.8H602v64h42.693c24.34 0 37.307-11 37.307-32.2zm613-2.7c0 54.5-38.884 88-101.06 88h-64.373V333H1049V82h145.24c61.876 0 100.76 32.2 100.76 83.1zm-85 2.7c0-20.9-12.668-31.8-37.007-31.8H1130v64h42.693c24.34 0 37.307-11 37.307-32.2zm-419-1.2c0-60.996 48.8-93.6 116-93.6s116 32.604 116 93.6c0 60.993-48.8 94.4-116 94.4-67.2-.1-116-33.407-116-94.4zm153-.95c0-29.733-14.9-44.65-37.5-44.65S869 135.917 869 165.65c0 29.332 14.9 45.35 37.5 45.35 22.7-.1 37.5-16.018 37.5-45.35zm-450 4.262C494 108.918 454.77 72 383.898 72 315.82 72 272 108.918 272 166.702 272 225.19 315.422 260 387.79 260c45.52 0 82.253-17.054 101.618-44.743l-57.696-21.067c-9.982 10.935-25.055 16.954-40.926 16.954-23.857 0-40.427-9.63-44.72-25.983-.3-1.102-.5-2.106-.698-3.31H494v-11.938zM346 144c1.902-19.814 15.62-32 39.45-32 23.832 0 37.55 12.88 37.55 32h-77z'
    })))
  );
};

exports.default = (0, _recompose.pure)(Logo);

/***/ }),

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(124);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = __webpack_require__(417);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(418);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _Modal = __webpack_require__(1219);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyModal = function (_React$Component) {
  (0, _inherits3.default)(LazyModal, _React$Component);

  function LazyModal(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, LazyModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LazyModal.__proto__ || (0, _getPrototypeOf2.default)(LazyModal)).call(this, props));

    _this.load = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var result;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.load();

            case 2:
              result = _context.sent;

              _this.setState({ ready: true, result: result });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.state = { ready: false, result: null };
    return _this;
  }

  (0, _createClass3.default)(LazyModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isOpened && !this.state.ready) {
        this.load();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isOpened && !this.state.ready) {
        this.load();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpened = _props.isOpened,
          render = _props.render,
          props = (0, _objectWithoutProperties3.default)(_props, ['isOpened', 'render']);
      var _state = this.state,
          ready = _state.ready,
          result = _state.result;


      return _react2.default.createElement(_Modal2.default, (0, _extends3.default)({}, props, { isOpened: ready && isOpened, render: function (_render) {
          function render() {
            return _render.apply(this, arguments);
          }

          render.toString = function () {
            return _render.toString();
          };

          return render;
        }(function () {
          return render(result);
        }) }));
    }
  }]);
  return LazyModal;
}(_react2.default.Component);

exports.default = LazyModal;

/***/ }),

/***/ 1178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatProductPrice = formatProductPrice;

var _accounting = __webpack_require__(1372);

function chopPennies(string) {
  if (string.endsWith('.00')) {
    return string.substr(0, string.length - 3);
  } else {
    return string;
  }
}

function formatProductPrice(price, currency) {
  return chopPennies((0, _accounting.formatMoney)(price, currency));
}

/***/ }),

/***/ 1179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListGrid = exports.ListVertical = undefined;

var _ListVertical2 = __webpack_require__(1388);

var _ListVertical3 = _interopRequireDefault(_ListVertical2);

var _ListGrid2 = __webpack_require__(1389);

var _ListGrid3 = _interopRequireDefault(_ListGrid2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ListVertical = _ListVertical3.default;
exports.ListGrid = _ListGrid3.default;

/***/ }),

/***/ 1180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isSold;
var soldStates = ['MARKED_AS_SOLD', 'PURCHASED', 'PRODUCT_BANNED_PURCHASED', 'USER_BANNED_PURCHASED'];

function isSold(product) {
  return soldStates.indexOf(product.saleStatus) !== -1;
}

/***/ }),

/***/ 1189:
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 1190:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(279),
    isSymbol = __webpack_require__(1054);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 1191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactSideEffect = __webpack_require__(1141);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NestedStatus = function (_Component) {
  (0, _inherits3.default)(NestedStatus, _Component);

  function NestedStatus() {
    (0, _classCallCheck3.default)(this, NestedStatus);
    return (0, _possibleConstructorReturn3.default)(this, (NestedStatus.__proto__ || (0, _getPrototypeOf2.default)(NestedStatus)).apply(this, arguments));
  }

  (0, _createClass3.default)(NestedStatus, [{
    key: 'render',
    value: function render() {
      if (this.props.children) {
        return this.props.children;
      } else {
        return null;
      }
    }
  }]);
  return NestedStatus;
}(_react.Component);

function handleStateChangeOnClient() {}

function reducePropsToState(propsList) {
  var innermostProps = propsList[propsList.length - 1];
  if (innermostProps) {
    return innermostProps.code;
  }
  return 200;
}

exports.default = (0, _reactSideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(NestedStatus);

/***/ }),

/***/ 1192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Subscriber = exports.Broadcast = undefined;

var _Broadcast2 = __webpack_require__(1253);

var _Broadcast3 = _interopRequireDefault(_Broadcast2);

var _Subscriber2 = __webpack_require__(1254);

var _Subscriber3 = _interopRequireDefault(_Subscriber2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Broadcast = _Broadcast3.default;
exports.Subscriber = _Subscriber3.default;

/***/ }),

/***/ 1193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyRootStyles;

var _glamor = __webpack_require__(415);

var _colors = __webpack_require__(1043);

var _typography = __webpack_require__(1042);

// TODO: Source the assets url from config
var assetBaseURL = 'https://d3170a3msf25m.cloudfront.net/assets';

var GT_AMERICA_EXTENDED_BOLD_WOFF2 = assetBaseURL + '/GT-America-Extended-Bold.woff2';
var GT_AMERICA_EXTENDED_BOLD_WOFF = assetBaseURL + '/GT-America-Extended-Bold.woff';

var GT_AMERICA_EXTENDED_REGULAR_EOT = assetBaseURL + '/GTAmerica-ExtendedRegular.eot';
var GT_AMERICA_EXTENDED_REGULAR_WOFF2 = assetBaseURL + '/GTAmerica-ExtendedRegular.woff2';
var GT_AMERICA_EXTENDED_REGULAR_WOFF = assetBaseURL + '/GTAmerica-ExtendedRegular.woff';
var GT_AMERICA_EXTENDED_REGULAR_TTF = assetBaseURL + '/GTAmerica-ExtendedRegular.ttf';

var GT_AMERICA_STANDARD_BOLD_EOT = assetBaseURL + '/GTAmerica-Bold.eot';
var GT_AMERICA_STANDARD_BOLD_WOFF2 = assetBaseURL + '/GTAmerica-Bold.woff2';
var GT_AMERICA_STANDARD_BOLD_WOFF = assetBaseURL + '/GTAmerica-Bold.woff';
var GT_AMERICA_STANDARD_BOLD_TTF = assetBaseURL + '/GTAmerica-Bold.ttf';

var GT_AMERICA_STANDARD_REGULAR_EOT = assetBaseURL + '/GTAmerica-Regular.eot';
var GT_AMERICA_STANDARD_REGULAR_WOFF2 = assetBaseURL + '/GTAmerica-Regular.woff2';
var GT_AMERICA_STANDARD_REGULAR_WOFF = assetBaseURL + '/GTAmerica-Regular.woff';
var GT_AMERICA_STANDARD_REGULAR_TTF = assetBaseURL + '/GTAmerica-Regular.ttf';

function applyRootStyles() {

  _glamor.css.insert('\n  @font-face {\n    font-family: \'GT America Extended Bold\';\n    src: url(\'' + GT_AMERICA_EXTENDED_BOLD_WOFF2 + '\') format(\'woff2\'),\n         url(\'' + GT_AMERICA_EXTENDED_BOLD_WOFF + '\') format(\'woff\');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n  }\n\n  @font-face {\n    font-family: \'GT America Extended Regular\';\n    src: url(\'' + GT_AMERICA_EXTENDED_REGULAR_EOT + '\');\n    src: url(\'' + GT_AMERICA_EXTENDED_REGULAR_EOT + '?#iefix\') format(\'embedded-opentype\'),\n         url(\'' + GT_AMERICA_EXTENDED_REGULAR_WOFF2 + '\') format(\'woff2\'),\n         url(\'' + GT_AMERICA_EXTENDED_REGULAR_WOFF + '\') format(\'woff\'),\n         url(\'' + GT_AMERICA_EXTENDED_REGULAR_TTF + '\') format(\'truetype\');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n  }\n\n  @font-face {\n    font-family: \'GT America Standard Bold\';\n    src: url(\'' + GT_AMERICA_STANDARD_BOLD_EOT + '\');\n    src: url(\'' + GT_AMERICA_STANDARD_BOLD_EOT + '?#iefix\') format(\'embedded-opentype\'),\n         url(\'' + GT_AMERICA_STANDARD_BOLD_WOFF2 + '\') format(\'woff2\'),\n         url(\'' + GT_AMERICA_STANDARD_BOLD_WOFF + '\') format(\'woff\'),\n         url(\'' + GT_AMERICA_STANDARD_BOLD_TTF + '\') format(\'truetype\');\n    font-weight: bold;\n    font-style: normal;\n    font-display: swap;\n  }\n\n  @font-face {\n    font-family: \'GT America Standard Regular\';\n    src: url(\'' + GT_AMERICA_STANDARD_REGULAR_EOT + '\');\n    src: url(\'' + GT_AMERICA_STANDARD_REGULAR_EOT + '?#iefix\') format(\'embedded-opentype\'),\n         url(\'' + GT_AMERICA_STANDARD_REGULAR_WOFF2 + '\') format(\'woff2\'),\n         url(\'' + GT_AMERICA_STANDARD_REGULAR_WOFF + '\') format(\'woff\'),\n         url(\'' + GT_AMERICA_STANDARD_REGULAR_TTF + '\') format(\'truetype\');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n  }\n  ');

  _glamor.css.insert('html, body, div, span, object, iframe,\n  h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n  abbr, address, cite, code,\n  del, dfn, em, img, ins, kbd, q, samp,\n  small, strong, sub, sup, var,\n  b, i,\n  dl, dt, dd, ol, ul, li,\n  fieldset, form, label, legend,\n  table, caption, tbody, tfoot, thead, tr, th, td,\n  article, aside, canvas, details, figcaption, figure,\n  footer, header, hgroup, menu, nav, section, summary,\n  time, mark, audio, video {\n    margin:0;\n    padding:0;\n    border:0;\n    outline:0;\n    font-size:100%;\n    vertical-align:baseline;\n    background:transparent;\n  }');

  _glamor.css.insert('body {\n    line-height:1;\n    padding-right:0px !important;\n    margin-right:0px !important;\n  }');

  _glamor.css.insert('article,aside,details,figcaption,figure,\n  footer,header,hgroup,menu,nav,section {\n    display:block;\n  }');

  _glamor.css.insert('nav ul {\n    list-style:none;\n  }');

  _glamor.css.insert('\n  @keyframes fadeIn {\n    0% { opacity: 0; }\n    50% { opacity: 0; }\n    100% { opacity: 100%; }\n  }\n\n  .fade-in {\n    animation: fadeIn 150ms ease-in;\n    animation-iteration-count: 1;\n  }');

  _glamor.css.insert('a {\n    margin:0;\n    padding:0;\n    font-size:100%;\n    vertical-align:baseline;\n    background:transparent;\n  }');

  _glamor.css.insert('table {\n    border-collapse:collapse;\n    border-spacing:0;\n  }');

  _glamor.css.insert('hr {\n    display:block;\n    height:1px;\n    border:0;\n    border-top:1px solid #cccccc;\n    margin:1em 0;\n    padding:0;\n  }');

  _glamor.css.insert('input, select {\n    vertical-align:middle;\n  }');

  _glamor.css.insert('\n  html {\n    box-sizing: border-box;\n  }\n\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n\n  html,\n  body {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    font-family: ' + _typography.FAMILY_STANDARD + ';\n    font-size: 16px;\n    background: white;\n  }\n\n  #mount {\n    height: 100%;\n  }\n  ');

  _glamor.css.insert('input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 10000px white inset;\n  }');

  _glamor.css.insert('#nprogress {\n    pointer-events: none;\n  }');

  _glamor.css.insert('#nprogress .bar {\n    background: ' + _colors.RED + ';\n\n    position: fixed;\n    z-index: 1031;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 2px;\n  }');

  _glamor.css.insert('#nprogress .peg {\n    display: block;\n    position: absolute;\n    right: 0px;\n    width: 100px;\n    height: 100%;\n    opacity: 1.0;\n    transform: rotate(3deg) translate(0px, -4px);\n  }');
}

/***/ }),

/***/ 1194:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 1195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),

/***/ 1196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withIdGenerator = exports.IDGenerator = undefined;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(1044);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDGenerator = exports.IDGenerator = function () {
  function IDGenerator() {
    (0, _classCallCheck3.default)(this, IDGenerator);

    this._counter = 0;
  }

  (0, _createClass3.default)(IDGenerator, [{
    key: 'next',
    value: function next() {
      this._counter++;
      return this._counter;
    }
  }]);
  return IDGenerator;
}();

var provideIdGenerator = (0, _recompose.withContext)({ idGenerator: _propTypes2.default.object }, function () {
  return { idGenerator: new IDGenerator() };
});

var withIdGenerator = (0, _recompose.getContext)({ idGenerator: _propTypes2.default.object });

exports.withIdGenerator = withIdGenerator;
exports.default = provideIdGenerator;

/***/ }),

/***/ 1197:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(5));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactFixedPage"] = factory(require("react"));
	else
		root["ReactFixedPage"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _class, _temp;

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _reactSideEffect = __webpack_require__(2);

	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var FixedPage = (_temp = _class = function (_Component) {
	  _inherits(FixedPage, _Component);

	  function FixedPage() {
	    _classCallCheck(this, FixedPage);

	    return _possibleConstructorReturn(this, (FixedPage.__proto__ || Object.getPrototypeOf(FixedPage)).apply(this, arguments));
	  }

	  _createClass(FixedPage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);

	  return FixedPage;
	}(_react.Component), _class.propTypes = {
	  fixed: _react.PropTypes.bool.isRequired
	}, _temp);


	var any = function any(list, iterator) {
	  for (var i = 0; i < list.length; i++) {
	    if (iterator(list[i])) {
	      return true;
	    }
	  }

	  return false;
	};

	var reducePropsToState = function reducePropsToState(propsList) {
	  return any(propsList, function (_ref) {
	    var fixed = _ref.fixed;
	    return fixed;
	  });
	};

	var scrollTop = null,
	    lastFixed = false;

	var handleStateChangeOnClient = function handleStateChangeOnClient(fixed) {
	  if (fixed === lastFixed) {
	    return;
	  }
	  lastFixed = fixed;

	  var scrollingElement = document.scrollingElement || document.documentElement;

	  if (fixed) {
	    scrollTop = scrollingElement.scrollTop;
	    Object.assign(scrollingElement.style, {
	      top: scrollTop * -1 + 'px', left: 0, right: 0, bottom: 0, position: 'fixed', overflow: 'hidden'
	    });
	    scrollingElement.scrollTop = scrollTop;
	  } else {
	    Object.assign(scrollingElement.style, {
	      top: null, left: null, right: null, bottom: null, position: null, overflow: null
	    });
	    scrollingElement.scrollTop = scrollTop;
	    scrollTop = null;
	  }
	};

	exports.default = (0, _reactSideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(FixedPage);

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _exenv = __webpack_require__(3);

	var _exenv2 = _interopRequireDefault(_exenv);

	var _shallowequal = __webpack_require__(4);

	var _shallowequal2 = _interopRequireDefault(_shallowequal);

	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }

	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }

	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }

	    var mountedInstances = [];
	    var state = undefined;

	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));

	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }

	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);

	      function SideEffect() {
	        _classCallCheck(this, SideEffect);

	        _Component.apply(this, arguments);
	      }

	      SideEffect.peek = function peek() {
	        return state;
	      };

	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }

	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };

	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_shallowequal2['default'](nextProps, this.props);
	      };

	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };

	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };

	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };

	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };

	      _createClass(SideEffect, null, [{
	        key: 'displayName',

	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',

	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _exenv2['default'].canUseDOM,
	        enumerable: true
	      }]);

	      return SideEffect;
	    })(_react.Component);

	    return SideEffect;
	  };
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */

	(function () {
		'use strict';

		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);

		var ExecutionEnvironment = {

			canUseDOM: canUseDOM,

			canUseWorkers: typeof Worker !== 'undefined',

			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),

			canUseViewport: canUseDOM && !!window.screen

		};

		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}

	}());


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var fetchKeys = __webpack_require__(5);

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {

	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

	    if (ret !== void 0) {
	        return !!ret;
	    }

	    if (objA === objB) {
	        return true;
	    }

	    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	        return false;
	    }

	    var keysA = fetchKeys(objA);
	    var keysB = fetchKeys(objB);

	    var len = keysA.length;
	    if (len !== keysB.length) {
	        return false;
	    }

	    compareContext = compareContext || null;

	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < len; i++) {
	        var key = keysA[i];
	        if (!bHasOwnProperty(key)) {
	            return false;
	        }
	        var valueA = objA[key];
	        var valueB = objB[key];

	        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	        if (_ret === false || _ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	    }

	    return true;
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(6),
	    isArguments = __webpack_require__(7),
	    isArray = __webpack_require__(8);

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}

	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');

	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;

	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));

	  var index = -1,
	      result = [];

	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};

	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;

	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;

	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	module.exports = keys;


/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */

	/** `Object#toString` result references. */
	var funcTag = '[object Function]';

	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}

	module.exports = getNative;


/***/ },
/* 7 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	module.exports = isArguments;


/***/ },
/* 8 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */

	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';

	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/** Used for native method references. */
	var objectProto = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}

	module.exports = isArray;


/***/ }
/******/ ])
});
;

/***/ }),

/***/ 1198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

exports.arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

exports.isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),

/***/ 1200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = detectUserMention;
function detectUserMention(input) {
  var spacedInput = input + ' ';
  var userMatch = spacedInput.match('@([a-zA-Z0-9_]+)[:;, ]');
  if (userMatch) {
    return userMatch[1];
  }
  return false;
}

/***/ }),

/***/ 1201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(1046);

var _Link2 = _interopRequireDefault(_Link);

var _reactIntl = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.aboutLabel',
  description: 'About Label',
  defaultMessage: 'About'
});

var AboutLink = function AboutLink(props) {
  return _react2.default.createElement(
    _Link2.default,
    (0, _extends3.default)({ to: { pathname: '/about/' } }, props),
    _ref
  );
};

exports.default = AboutLink;

/***/ }),

/***/ 1202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(124);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(192);

var _connectors = __webpack_require__(1079);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.loginLabel',
  description: 'Login Label',
  defaultMessage: 'Login'
});

var LoginLink = function LoginLink(_ref) {
  var openLogin = _ref.openLogin,
      props = (0, _objectWithoutProperties3.default)(_ref, ['openLogin']);
  return _react2.default.createElement(
    'a',
    (0, _extends3.default)({ onClick: openLogin }, props),
    _ref2
  );
};

exports.default = (0, _connectors.loginConnector)(LoginLink);

/***/ }),

/***/ 1203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 * 
 * @providesModule EmitterSubscription
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventSubscription = __webpack_require__(1278);

/**
 * EmitterSubscription represents a subscription with listener and context data.
 */

var EmitterSubscription = (function (_EventSubscription) {
  _inherits(EmitterSubscription, _EventSubscription);

  /**
   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
   *   this subscription
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  function EmitterSubscription(subscriber, listener, context) {
    _classCallCheck(this, EmitterSubscription);

    _EventSubscription.call(this, subscriber);
    this.listener = listener;
    this.context = context;
  }

  return EmitterSubscription;
})(EventSubscription);

module.exports = EmitterSubscription;

/***/ }),

/***/ 1204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Variant = function (_Component) {
  _inherits(Variant, _Component);

  function Variant() {
    _classCallCheck(this, Variant);

    return _possibleConstructorReturn(this, (Variant.__proto__ || Object.getPrototypeOf(Variant)).apply(this, arguments));
  }

  _createClass(Variant, [{
    key: 'render',
    value: function render() {
      if (_react2.default.isValidElement(this.props.children)) {
        return this.props.children;
      } else {
        return _react2.default.createElement(
          'span',
          null,
          this.props.children
        );
      }
    }
  }]);

  return Variant;
}(_react.Component);

Variant.propTypes = {
  name: _propTypes2.default.string.isRequired
};
Variant.displayName = "Pushtell.Variant";
exports.default = Variant;
;
module.exports = exports['default'];

/***/ }),

/***/ 1205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

var _reactIntl = __webpack_require__(192);

var _appStoreEn = __webpack_require__(435);

var _appStoreEn2 = _interopRequireDefault(_appStoreEn);

var _appStoreIt = __webpack_require__(436);

var _appStoreIt2 = _interopRequireDefault(_appStoreIt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBadge = function getBadge(language) {
  switch (language) {
    case 'it':
      return _appStoreIt2.default;
    case 'en':
    default:
      return _appStoreEn2.default;
  }
};

var messages = (0, _reactIntl.defineMessages)({
  lang: {
    'id': 'Language.ShortCode',
    'defaultMessage': 'en'
  },
  alt: {
    'id': 'AppStore.alt',
    'defaultMessage': 'Download on the App Store'
  }
});

var badgeStyle = (0, _glamor.style)({
  width: 145,
  height: 48,
  display: 'block',
  verticalAlign: 'bottom'
});

var AppStore = function (_React$Component) {
  (0, _inherits3.default)(AppStore, _React$Component);

  function AppStore() {
    (0, _classCallCheck3.default)(this, AppStore);
    return (0, _possibleConstructorReturn3.default)(this, (AppStore.__proto__ || (0, _getPrototypeOf2.default)(AppStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppStore, [{
    key: 'render',
    value: function render() {
      var intl = this.props.intl;


      return _react2.default.createElement('img', (0, _extends3.default)({}, badgeStyle, { alt: intl.formatMessage(messages.alt), src: getBadge(intl.formatMessage(messages.lang)) }));
    }
  }]);
  return AppStore;
}(_react2.default.Component);

;

// export default () => (
//   <img {...badgeStyle} src={badgeEnglish} />
// );

exports.default = (0, _reactIntl.injectIntl)(AppStore);

/***/ }),

/***/ 1206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

var _reactIntl = __webpack_require__(192);

var _googlePlayEn = __webpack_require__(437);

var _googlePlayEn2 = _interopRequireDefault(_googlePlayEn);

var _googlePlayIt = __webpack_require__(438);

var _googlePlayIt2 = _interopRequireDefault(_googlePlayIt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBadge = function getBadge(language) {
  switch (language) {
    case 'it':
      return _googlePlayIt2.default;
    case 'en':
    default:
      return _googlePlayEn2.default;
  }
};

var messages = (0, _reactIntl.defineMessages)({
  lang: {
    'id': 'Language.ShortCode',
    'defaultMessage': 'en'
  },
  alt: {
    'id': 'PlayStore.alt',
    'defaultMessage': 'Get it on the Play Store'
  }
});

var badgeStyle = (0, _glamor.style)({
  width: 145,
  height: 48,
  display: 'block',
  verticalAlign: 'bottom'
});

var PlayStore = function (_React$Component) {
  (0, _inherits3.default)(PlayStore, _React$Component);

  function PlayStore() {
    (0, _classCallCheck3.default)(this, PlayStore);
    return (0, _possibleConstructorReturn3.default)(this, (PlayStore.__proto__ || (0, _getPrototypeOf2.default)(PlayStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlayStore, [{
    key: 'render',
    value: function render() {
      var intl = this.props.intl;


      return _react2.default.createElement('img', (0, _extends3.default)({}, badgeStyle, { alt: intl.formatMessage(messages.alt), src: getBadge(intl.formatMessage(messages.lang)) }));
    }
  }]);
  return PlayStore;
}(_react2.default.Component);

;

// export default () => (
//   <img {...badgeStyle} src={badgeEnglish} />
// );

exports.default = (0, _reactIntl.injectIntl)(PlayStore);

/***/ }),

/***/ 1207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(1046);

var _Link2 = _interopRequireDefault(_Link);

var _reactIntl = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.jobsLabel',
  description: 'Jobs Label',
  defaultMessage: 'Jobs'
});

var JobsLink = function JobsLink(props) {
  return _react2.default.createElement(
    _Link2.default,
    (0, _extends3.default)({ to: { pathname: '/about/jobs/' } }, props),
    _ref
  );
};

exports.default = JobsLink;

/***/ }),

/***/ 1208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(1046);

var _Link2 = _interopRequireDefault(_Link);

var _reactIntl = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.eventsLabel',
  description: 'Events Label',
  defaultMessage: 'Events'
});

var EventsLink = function EventsLink(props) {
  return _react2.default.createElement(
    _Link2.default,
    (0, _extends3.default)({ to: { pathname: '/events/' } }, props),
    _ref
  );
};

exports.default = EventsLink;

/***/ }),

/***/ 1209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PressLink = function PressLink(props) {
  return _react2.default.createElement(
    "a",
    (0, _extends3.default)({
      rel: "noopener",
      target: "_blank",
      href: "https://press.depop.com"
    }, props),
    "Press"
  );
};

exports.default = PressLink;

/***/ }),

/***/ 1210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__(1046);

var _Link2 = _interopRequireDefault(_Link);

var _reactIntl = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.spacesLabel',
  description: 'Spaces Label',
  defaultMessage: 'Spaces'
});

var SpacesLink = function SpacesLink(props) {
  return _react2.default.createElement(
    _Link2.default,
    (0, _extends3.default)({ to: { pathname: '/about/spaces' } }, props),
    _ref
  );
};

exports.default = SpacesLink;

/***/ }),

/***/ 1211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.supportLabel',
  description: 'Support Label',
  defaultMessage: 'Support'
});

var SupportLink = function SupportLink(props) {
  return _react2.default.createElement(
    'a',
    (0, _extends3.default)({ rel: 'noopener', target: '_blank', href: 'http://help.depop.com/' }, props),
    _ref
  );
};

exports.default = SupportLink;

/***/ }),

/***/ 1212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstagramLink = function InstagramLink(props) {
  return _react2.default.createElement(
    "a",
    (0, _extends3.default)({
      rel: "noopener",
      target: "_blank",
      href: "https://instagram.com/depop/"
    }, props),
    "Instagram"
  );
};

exports.default = InstagramLink;

/***/ }),

/***/ 1213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterLink = function TwitterLink(props) {
  return _react2.default.createElement(
    "a",
    (0, _extends3.default)({
      rel: "noopener",
      target: "_blank",
      href: "https://twitter.com/depop/"
    }, props),
    "Twitter"
  );
};

exports.default = TwitterLink;

/***/ }),

/***/ 1214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookLink = function FacebookLink(props) {
  return _react2.default.createElement(
    "a",
    (0, _extends3.default)({
      rel: "noopener",
      target: "_blank",
      href: "https://facebook.com/depop"
    }, props),
    "Facebook"
  );
};

exports.default = FacebookLink;

/***/ }),

/***/ 1215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(192);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _browserCookies = __webpack_require__(430);

var _browserCookies2 = _interopRequireDefault(_browserCookies);

var _recompose = __webpack_require__(1044);

var _tracking = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.logoutLabel',
  description: 'Logout Label',
  defaultMessage: 'Logout'
});

var Logout = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(Logout, _React$Component);

  function Logout() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Logout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Logout.__proto__ || (0, _getPrototypeOf2.default)(Logout)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      event.preventDefault();

      _browserCookies2.default.erase('token');
      _this.context.resetEnvironment(function () {
        (0, _tracking.trackLogout)();
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Logout, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'a',
        (0, _extends3.default)({ href: 'javascript:;', onClick: this.handleClick }, this.props),
        _ref2
      );
    }
  }]);
  return Logout;
}(_react2.default.Component), _class.contextTypes = {
  resetEnvironment: _propTypes2.default.func
}, _temp2);
exports.default = (0, _recompose.pure)(Logout);

/***/ }),

/***/ 1216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(1057);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _locale = __webpack_require__(446);

var _reactRedux = __webpack_require__(416);

var _typography = __webpack_require__(1042);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(_ref) {
  var locale = _ref.locale;

  return {
    language: locale.language,
    availableLanguages: locale.availableLanguages
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChange: function onChange(event) {
      return dispatch((0, _locale.changeLanguage)(event.target.value));
    }
  };
}

/**
* A component used in development to switch locales, and
* should never be visible in a production build, right?
*/
function LocaleSwitcher(_ref2) {
  var language = _ref2.language,
      availableLanguages = _ref2.availableLanguages,
      onChange = _ref2.onChange;

  var buttonStyle = (0, _glamor.css)({
    position: 'relative',
    color: '#666',
    display: 'inlineBlock',
    margin: '0 5px',
    border: 0,
    padding: 0,
    fontWeight: 'normal',
    touchAction: 'manipulation',
    fontFamily: _typography.FAMILY_STANDARD,
    cursor: 'pointer',
    userSelect: 'none',
    background: 'none',
    outline: 'none',
    fontSize: 16,
    ':hover': {
      textDecoration: 'underline',
      color: '#000'
    }
  });

  var selectedButtonStyle = (0, _glamor.css)({
    color: '#000',
    fontFamily: _typography.FAMILY_STANDARD_BOLD,
    textDecoration: 'underline'
  });

  return _react2.default.createElement(
    'div',
    (0, _glamor.css)({ margin: '0 -5px' }),
    availableLanguages.map(function (lang) {
      var styles = [buttonStyle].concat((0, _toConsumableArray3.default)(language === lang.value ? [selectedButtonStyle] : []));

      return _react2.default.createElement(
        'button',
        (0, _extends3.default)({
          key: lang.value,
          value: lang.value,
          onClick: onChange
        }, (0, _glamor.merge)(styles)),
        lang.name
      );
    })
  );
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LocaleSwitcher);

/***/ }),

/***/ 1217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DesktopOnly;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DesktopOnly(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    (0, _glamor.css)({
      display: 'none',
      '@media (min-width: 701px)': { display: 'block' }
    }),
    children
  );
}

/***/ }),

/***/ 1218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(124);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(192);

var _connectors = __webpack_require__(1079);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function combineActions(mainAction, secondaryAction) {
  mainAction();
  secondaryAction();
}

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.downloadLabel',
  description: 'Download Label',
  defaultMessage: 'Download App'
});

var DownloadLink = function DownloadLink(_ref) {
  var openDownload = _ref.openDownload,
      onclick = _ref.onclick,
      props = (0, _objectWithoutProperties3.default)(_ref, ['openDownload', 'onclick']);
  return _react2.default.createElement(
    'a',
    (0, _extends3.default)({ onClick: function onClick() {
        openDownload();
        onclick();
      },
      rel: 'noopener'
    }, props),
    _ref2
  );
};

exports.default = (0, _connectors.downloadConnector)(DownloadLink);

/***/ }),

/***/ 1219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(1220);

var _Portal2 = _interopRequireDefault(_Portal);

var _ModalShell = __webpack_require__(1221);

var _ModalShell2 = _interopRequireDefault(_ModalShell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Modal(_ref) {
  var render = _ref.render,
      trigger = _ref.trigger,
      isOpened = _ref.isOpened,
      onClose = _ref.onClose;

  return (0, _jsx3.default)(_Portal2.default, {
    closeOnEsc: true,
    openByClickOn: trigger,
    isOpened: isOpened,
    onClose: onClose,
    render: function (_render) {
      function render() {
        return _render.apply(this, arguments);
      }

      render.toString = function () {
        return _render.toString();
      };

      return render;
    }(function () {
      return (0, _jsx3.default)(_ModalShell2.default, {}, void 0, render());
    })
  });
}

exports.default = Modal;

/***/ }),

/***/ 1220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(280);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEYCODES = {
  ESCAPE: 27
};

var Portal = (_temp = _class = function (_React$PureComponent) {
  (0, _inherits3.default)(Portal, _React$PureComponent);

  function Portal() {
    (0, _classCallCheck3.default)(this, Portal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Portal.__proto__ || (0, _getPrototypeOf2.default)(Portal)).call(this));

    _this.handleWrapperClick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (_this.state.active) {
        return;
      }
      _this.openPortal();
    };

    _this.openPortal = function (props) {
      _this.setState({ active: true });
      _this.renderPortal(props);
      _this.props.onOpen(_this.node);
    };

    _this.closePortal = function () {
      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var resetPortalState = function resetPortalState() {
        if (_this.node) {
          _reactDom2.default.unmountComponentAtNode(_this.node);
          document.body.removeChild(_this.node);
        }
        _this.portal = null;
        _this.node = null;
        if (isUnmounted !== true) {
          _this.setState({ active: false });
        }
      };

      if (_this.state.active) {
        if (_this.props.beforeClose) {
          _this.props.beforeClose(_this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        _this.props.onClose();
      }
    };

    _this.handleOutsideMouseClick = function (event) {
      if (!_this.state.active) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(_this.portal);
      if (root.contains(event.target) || event.button && event.button !== 0) {
        return;
      }

      event.stopPropagation();
      _this.closePortal();
    };

    _this.handleKeydown = function (event) {
      if (event.keyCode === KEYCODES.ESCAPE && _this.state.active) {
        _this.closePortal();
      }
    };

    _this.renderPortal = function (props) {
      if (!_this.node) {
        _this.node = document.createElement('div');
        document.body.appendChild(_this.node);
      }

      var renderFn = props.render;

      _this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, _react2.default.cloneElement(renderFn(), { closePortal: _this.closePortal }), _this.node, _this.props.onUpdate);
    };

    _this.state = { active: false };
    _this.portal = null;
    _this.node = null;
    return _this;
  }

  (0, _createClass3.default)(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isOpened) {
        this.openPortal(this.props);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.closePortal(true);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, {
          onClick: this.handleWrapperClick
        });
      }
      return null;
    }
  }]);
  return Portal;
}(_react2.default.PureComponent), _class.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
}, _temp);
exports.default = Portal;

/***/ }),

/***/ 1221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__(1044);

var _glamor = __webpack_require__(415);

var _zIndex = __webpack_require__(1067);

var _reactFixedPage = __webpack_require__(1197);

var _reactFixedPage2 = _interopRequireDefault(_reactFixedPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEYCODES = {
  ESCAPE: 27
};

var ModalShell = function (_React$Component) {
  (0, _inherits3.default)(ModalShell, _React$Component);

  function ModalShell(props) {
    (0, _classCallCheck3.default)(this, ModalShell);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ModalShell.__proto__ || (0, _getPrototypeOf2.default)(ModalShell)).call(this, props));

    _this.handleKeyDown = function (event) {
      if (event.keyCode === KEYCODES.ESCAPE) {
        _this.close();
      }
    };

    _this.close = function () {
      var closePortal = _this.props.closePortal;

      _this.setState({ isOpen: false });
      setTimeout(function () {
        closePortal();
      }, 200);
    };

    _this.handleCloseClick = function (event) {
      event.preventDefault();
      _this.close();
    };

    _this.state = { isOpen: false };
    return _this;
  }

  (0, _createClass3.default)(ModalShell, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      document.addEventListener('keydown', this.handleKeyDown);
      setTimeout(function () {
        _this2.setState({ isOpen: true });
      }, 4);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var isOpen = this.state.isOpen;


      var rootStyles = (0, _glamor.css)({
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
        cursor: 'default',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 0 100px 0 rgba(0, 0, 0, .25)',
        transition: '\n        transform .1s ease-in-out,\n        opacity .1s ease-in-out,\n        margin .05s ease-in-out,\n        max-width .1s ease-in-out,\n        min-height .1s ease-in-out',
        opacity: isOpen ? 1 : 0,
        transform: isOpen ? 'scale(1)' : 'scale(0)',
        pointerEvents: 'all',
        '@media (min-width: 701px)': {
          width: 'auto',
          maxWidth: 'calc(100% - 32px)',
          height: 'auto'
        }
      });

      return _react2.default.createElement(
        'div',
        (0, _glamor.css)({
          position: 'fixed',
          zIndex: _zIndex.ZINDEX_OVERLAY_BG,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0
        }),
        _react2.default.createElement('div', (0, _extends3.default)({
          onClick: this.close
        }, (0, _glamor.css)({
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          opacity: isOpen ? 1 : 0,
          transition: 'opacity .1s ease-in-out'
        }))),
        _react2.default.createElement(
          'div',
          (0, _glamor.css)({
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: _zIndex.ZINDEX_MODAL,
            pointerEvents: 'none'
          }),
          (0, _jsx3.default)(_reactFixedPage2.default, {
            fixed: isOpen
          }),
          _react2.default.createElement(
            'div',
            rootStyles,
            _react2.default.createElement(
              'div',
              (0, _glamor.css)({
                width: '100%',
                height: '100%',
                backgroundColor: '#FFFFFF'
              }),
              _react2.default.cloneElement(children, {
                closeModal: this.close
              })
            )
          )
        )
      );
    }
  }]);
  return ModalShell;
}(_react2.default.Component);

exports.default = (0, _recompose.pure)(ModalShell);

/***/ }),

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory();
  } else {
    root.Scrollparent = factory();
  }
}(this, function () {
  var regex = /(auto|scroll)/;

  var parents = function (node, ps) {
    if (node.parentNode === null) { return ps; }

    return parents(node.parentNode, ps.concat([node]));
  };

  var style = function (node, prop) {
    return getComputedStyle(node, null).getPropertyValue(prop);
  };

  var overflow = function (node) {
    return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
  };

  var scroll = function (node) {
   return regex.test(overflow(node));
  };

  var scrollParent = function (node) {
    if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
      return ;
    }

    var ps = parents(node.parentNode, []);

    for (var i = 0; i < ps.length; i += 1) {
      if (scroll(ps[i])) {
        return ps[i];
      }
    }

    return document.scrollingElement || document.documentElement;
  };

  return scrollParent;
}));


/***/ }),

/***/ 1231:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(80);

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = isProductViewable;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var acceptableStates = ['ONSALE', 'PURCHASED', 'MARKED_AS_SOLD'];

var listMandatoryFields = ['slug', 'publicId', 'saleStatus', 'description', 'dateUpdated'];

var detailMandatoryFields = [].concat(listMandatoryFields, ['seller', 'pictures', 'counters', 'price']);

function isProductViewable(product, isDetail) {
  var checkFields = isDetail ? detailMandatoryFields : listMandatoryFields;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(checkFields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var field = _step.value;

      if (!product[field]) {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (!(acceptableStates.indexOf(product.saleStatus) !== -1)) {
    return false;
  }

  return true;
}

/***/ }),

/***/ 1232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _isSold = __webpack_require__(1180);

var _isSold2 = _interopRequireDefault(_isSold);

var _reactIntl = __webpack_require__(192);

var _colors = __webpack_require__(1043);

var _typography = __webpack_require__(1042);

var _InvalidProductListItem = __webpack_require__(1233);

var _InvalidProductListItem2 = _interopRequireDefault(_InvalidProductListItem);

var _ProductLink = __webpack_require__(1390);

var _ProductLink2 = _interopRequireDefault(_ProductLink);

var _Picture = __webpack_require__(1066);

var _Picture2 = _interopRequireDefault(_Picture);

var _glamor = __webpack_require__(415);

var _money = __webpack_require__(1178);

var _tracking = __webpack_require__(193);

var _VideoIndicator = __webpack_require__(1391);

var _VideoIndicator2 = _interopRequireDefault(_VideoIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OVERLAY_Z_INDEX = 50;
var SOLD_Z_INDEX = 70;
var VIDEO_Z_INDEX = 90;

var overlayStyle = {
  content: '""',
  display: 'block',
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  zIndex: OVERLAY_Z_INDEX,
  backgroundColor: 'rgba(0,0,0,0.3)'
};

var productLinkStyle = {
  position: 'relative',
  textDecoration: 'none',
  color: 'inherit'
};

var soldLabelStyle = {
  position: 'absolute',
  fontSize: 16,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, .2)',
  textTransform: 'uppercase',
  letterSpacing: '.05em',
  color: _colors.YELLOW,
  padding: '4px 15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: _typography.FAMILY_EXTENDED_BOLD,
  zIndex: SOLD_Z_INDEX
};

var videoIndicatorStyle = {
  display: 'inline-block',
  position: 'absolute',
  top: '10px',
  right: '9px',
  zIndex: VIDEO_Z_INDEX
};

var priceLabelStyle = {
  display: 'none',
  margin: '4px 0 calc(4px - 0.5vw)',
  maxWidth: '100%',
  width: '12em',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  fontSize: 12,
  fontFamily: _typography.FAMILY_EXTENDED_BOLD,
  textOverflow: 'ellipsis'
};

var _ref2 = (0, _jsx3.default)(_InvalidProductListItem2.default, {});

var _ref3 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'ProductListItem.Sold',
  defaultMessage: 'Sold'
});

var _ref4 = (0, _jsx3.default)(_VideoIndicator2.default, {});

var ProductListItem = function (_React$PureComponent) {
  (0, _inherits3.default)(ProductListItem, _React$PureComponent);

  function ProductListItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ProductListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProductListItem.__proto__ || (0, _getPrototypeOf2.default)(ProductListItem)).call.apply(_ref, [this].concat(args))), _this), _this.trackClick = function () {
      (0, _tracking.trackProductCardClick)({
        id: _this.props.product.publicId,
        index: _this.props.productListIndex,
        listName: _this.props.listName
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ProductListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          product = _props.product,
          from = _props.from,
          productListIndex = _props.productListIndex;


      if (!product.picture) {
        return _ref2;
      }

      var hasVideo = !!product.videos && product.videos.length && !!product.videos[0].url;

      return _react2.default.createElement(
        _ProductLink2.default,
        (0, _extends3.default)({}, (0, _glamor.style)(productLinkStyle), {
          product: product,
          onClick: this.trackClick,
          from: from,
          listIndex: productListIndex }),
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, (0, _glamor.style)({ position: 'relative', background: 'black' }), (0, _glamor.hover)({
            '@media(min-width: 701px)': {
              '::after': overlayStyle
            }
          })),
          _react2.default.createElement(
            'div',
            (0, _glamor.active)({ opacity: '0.8' }),
            (0, _jsx3.default)(_Picture2.default, {
              picture: product.picture
            })
          ),
          (0, _isSold2.default)(product) ? _react2.default.createElement(
            'div',
            (0, _glamor.style)(soldLabelStyle),
            _ref3
          ) : null,
          hasVideo ? _react2.default.createElement(
            'span',
            (0, _glamor.style)(videoIndicatorStyle),
            _ref4
          ) : null
        ),
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, (0, _glamor.style)(priceLabelStyle), (0, _glamor.media)('(min-width: 701px)', { display: 'block' })),
          (0, _money.formatProductPrice)(product.price.display, product.price.currencySymbol)
        )
      );
    }
  }]);
  return ProductListItem;
}(_react2.default.PureComponent);

exports.default = _reactRelay2.default.createContainer(ProductListItem, {
  fragments: {
    product: function product() {
      return function (RQL_0, RQL_1) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'publicId',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'slug',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'saleStatus',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            children: [{
              fieldName: 'currencySymbol',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'display',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }],
            fieldName: 'price',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true
            },
            type: 'ProductPrice'
          }, {
            children: [{
              fieldName: 'url',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'videos',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id',
              isPlural: true
            },
            type: 'Video'
          }, {
            children: [].concat.apply([], [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }, _reactRelay2.default.QL.__frag(RQL_1)]),
            fieldName: 'picture',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'Picture'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'ProductListItem_ProductRelayQL',
          type: 'Product'
        };
      }(_ProductLink2.default.getFragment('product'), _Picture2.default.getFragment('picture'));
    }
  }
});

/***/ }),

/***/ 1233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(192);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'ProductListItem.cannotBeDisplayed',
  description: 'Shown on a product in a list, if it can\'t be shown for some reason',
  defaultMessage: 'This product cannot be displayed.'
});

var InvalidProductListItem = function InvalidProductListItem() {
  return _react2.default.createElement(
    'div',
    (0, _glamor.style)({
      width: '100%',
      paddingBottom: '100%',
      position: 'relative',
      backgroundColor: '#fff'
    }),
    _react2.default.createElement(
      'div',
      (0, _glamor.style)({
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontSize: '14px',
        padding: '10px',
        top: '0',
        bottom: '0',
        right: '0',
        left: '0'
      }),
      _ref
    )
  );
};

exports.default = InvalidProductListItem;

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),

/***/ 1246:
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(196);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(1189);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),

/***/ 1248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enabled = false;

var ScrollTop = function (_React$PureComponent) {
  (0, _inherits3.default)(ScrollTop, _React$PureComponent);

  function ScrollTop() {
    (0, _classCallCheck3.default)(this, ScrollTop);
    return (0, _possibleConstructorReturn3.default)(this, (ScrollTop.__proto__ || (0, _getPrototypeOf2.default)(ScrollTop)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScrollTop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (enabled) {
        window.scrollTo(0, 0);
      } else {
        enabled = true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return ScrollTop;
}(_react2.default.PureComponent);

exports.default = ScrollTop;

/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(279),
    now = __webpack_require__(1250),
    toNumber = __webpack_require__(1190);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(66);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 1251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var outer = (0, _glamor.style)({
  overflow: 'hidden',
  width: '50%',
  height: 4,
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  borderRadius: 2
});

var inner = (0, _glamor.style)({
  position: 'relative',
  width: '100%',
  height: '100%'
});

var beforeAnimation = (0, _glamor.keyframes)({
  '0%': { left: '-100%', width: '100%' },
  '100%': { left: '100%', width: '10%' }
});

var afterAnimation = (0, _glamor.keyframes)({
  '0%': { left: '-150%', width: '100%' },
  '100%': { left: '100%', width: '10%' }
});

var loaderBefore = (0, _glamor.style)({
  position: 'absolute',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  animation: beforeAnimation + ' 1.5s infinite ease-out'
});

var loaderAfter = (0, _glamor.style)({
  position: 'absolute',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  animation: afterAnimation + ' 1.5s infinite ease-out'
});

exports.default = function () {
  return _react2.default.createElement(
    'div',
    outer,
    _react2.default.createElement(
      'div',
      inner,
      _react2.default.createElement('div', loaderBefore),
      _react2.default.createElement('div', loaderAfter)
    )
  );
};

/***/ }),

/***/ 1252:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(197),
    arrayMap = __webpack_require__(1128),
    isArray = __webpack_require__(194),
    isSymbol = __webpack_require__(1054);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 1253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(27);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createBroadcast = function createBroadcast(initialValue) {
  var listeners = [];
  var currentValue = initialValue;

  return {
    publish: function publish(value) {
      currentValue = value;
      listeners.forEach(function (listener) {
        return listener(currentValue);
      });
    },
    subscribe: function subscribe(listener) {
      listeners.push(listener);

      // Publish to this subscriber once immediately.
      listener(currentValue);

      return function () {
        return listeners = listeners.filter(function (item) {
          return item !== listener;
        });
      };
    }
  };
};

/**
 * A <Broadcast> provides a generic way for descendants to "subscribe"
 * to some value that changes over time, bypassing any intermediate
 * shouldComponentUpdate's in the hierarchy. It puts all subscription
 * functions on context.broadcasts, keyed by "channel".
 *
 * To use it, a subscriber must opt-in to context.broadcasts. See the
 * <Subscriber> component for a reference implementation.
 */

var Broadcast = function (_React$Component) {
  _inherits(Broadcast, _React$Component);

  function Broadcast() {
    var _temp, _this, _ret;

    _classCallCheck(this, Broadcast);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.broadcast = createBroadcast(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Broadcast.prototype.getBroadcastsContext = function getBroadcastsContext() {
    var _extends2;

    var channel = this.props.channel;
    var broadcasts = this.context.broadcasts;


    return _extends({}, broadcasts, (_extends2 = {}, _extends2[channel] = this.broadcast.subscribe, _extends2));
  };

  Broadcast.prototype.getChildContext = function getChildContext() {
    return {
      broadcasts: this.getBroadcastsContext()
    };
  };

  Broadcast.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    !(this.props.channel === nextProps.channel) ?  false ? (0, _invariant2.default)(false, 'You cannot change <Broadcast channel>') : (0, _invariant2.default)(false) : void 0;

    if (this.props.value !== nextProps.value) this.broadcast.publish(nextProps.value);
  };

  Broadcast.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return Broadcast;
}(_react2.default.Component);

Broadcast.contextTypes = {
  broadcasts: _react.PropTypes.object
};
Broadcast.childContextTypes = {
  broadcasts: _react.PropTypes.object.isRequired
};


if (false) {
  Broadcast.propTypes = {
    channel: _react.PropTypes.string.isRequired,
    children: _react.PropTypes.node.isRequired,
    value: _react.PropTypes.any
  };
}

exports.default = Broadcast;

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _invariant = __webpack_require__(27);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A <Subscriber> pulls the value for a channel off of context.broadcasts
 * and passes it to its children function.
 */
var Subscriber = function (_React$Component) {
  _inherits(Subscriber, _React$Component);

  function Subscriber() {
    var _temp, _this, _ret;

    _classCallCheck(this, Subscriber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      value: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Subscriber.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var channel = this.props.channel;


    if (this.context.broadcasts) {
      var subscribe = this.context.broadcasts[channel];

      !(typeof subscribe === 'function') ?  false ? (0, _invariant2.default)(false, '<Subscriber channel="%s"> must be rendered in the context of a <Broadcast channel="%s">', channel, channel) : (0, _invariant2.default)(false) : void 0;

      this.unsubscribe = subscribe(function (value) {
        // This function will be called once immediately.
        _this2.setState({ value: value });
      });
    }
  };

  Subscriber.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  };

  Subscriber.prototype.render = function render() {
    return this.props.children(this.state.value);
  };

  return Subscriber;
}(_react2.default.Component);

Subscriber.contextTypes = {
  broadcasts: _react2.default.PropTypes.object
};


if (false) {
  Subscriber.propTypes = {
    channel: _react.PropTypes.string.isRequired,
    children: _react.PropTypes.func.isRequired
  };
}

exports.default = Subscriber;

/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(435);

__webpack_require__(436);

__webpack_require__(437);

__webpack_require__(438);

__webpack_require__(439);

__webpack_require__(440);

__webpack_require__(441);

__webpack_require__(442);

__webpack_require__(443);

__webpack_require__(444);

__webpack_require__(449);

__webpack_require__(450);

__webpack_require__(451);

__webpack_require__(452);

__webpack_require__(453);

__webpack_require__(454);

/***/ }),

/***/ 1257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactRedux = __webpack_require__(416);

var _recompose = __webpack_require__(1044);

var _Container = __webpack_require__(1129);

var _Container2 = _interopRequireDefault(_Container);

var _NotificationsList = __webpack_require__(1258);

var _NotificationsList2 = _interopRequireDefault(_NotificationsList);

var _UniqueIdProvider = __webpack_require__(1196);

var _UniqueIdProvider2 = _interopRequireDefault(_UniqueIdProvider);

var _glamor = __webpack_require__(415);

var _applyRootStyles = __webpack_require__(1193);

var _applyRootStyles2 = _interopRequireDefault(_applyRootStyles);

var _zIndex = __webpack_require__(1067);

var _getCurrentUser = __webpack_require__(432);

var _OverlayBackground = __webpack_require__(1267);

var _OverlayBackground2 = _interopRequireDefault(_OverlayBackground);

var _SearchOverlay = __webpack_require__(1268);

var _SearchOverlay2 = _interopRequireDefault(_SearchOverlay);

var _MobileMenu = __webpack_require__(1271);

var _MobileMenu2 = _interopRequireDefault(_MobileMenu);

var _AppNavigation = __webpack_require__(1286);

var _AppNavigation2 = _interopRequireDefault(_AppNavigation);

var _DeeplinkBanner = __webpack_require__(1306);

var _DeeplinkBanner2 = _interopRequireDefault(_DeeplinkBanner);

var _CookieBanner = __webpack_require__(1308);

var _CookieBanner2 = _interopRequireDefault(_CookieBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _applyRootStyles2.default)();

var _ref = (0, _jsx3.default)(_DeeplinkBanner2.default, {});

var _ref2 = (0, _jsx3.default)(_CookieBanner2.default, {});

var _ref3 = (0, _jsx3.default)(_NotificationsList2.default, {});

var _ref4 = (0, _jsx3.default)(_OverlayBackground2.default, {});

var Shell = function (_React$PureComponent) {
  (0, _inherits3.default)(Shell, _React$PureComponent);

  function Shell() {
    (0, _classCallCheck3.default)(this, Shell);
    return (0, _possibleConstructorReturn3.default)(this, (Shell.__proto__ || (0, _getPrototypeOf2.default)(Shell)).apply(this, arguments));
  }

  (0, _createClass3.default)(Shell, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          viewer = _props.viewer,
          hideHeader = _props.hideHeader,
          hideFooter = _props.hideFooter,
          hideAppBanner = _props.hideAppBanner,
          hideCookieBanner = _props.hideCookieBanner,
          _props$navigation = _props.navigation,
          isSearchOpen = _props$navigation.isSearchOpen,
          isMobileNavOpen = _props$navigation.isMobileNavOpen;


      var bottomPlacementStyle = {
        position: 'fixed',
        bottom: '0px',
        left: '0px',
        right: '0px',
        zIndex: _zIndex.ZINDEX_PAGE_BOTTOM_WRAP
      };

      return _react2.default.createElement(
        'div',
        (0, _glamor.css)({ position: 'relative' }),
        (0, _jsx3.default)(_AppNavigation2.default, {
          viewer: viewer,
          hideHeader: hideHeader,
          hideFooter: hideFooter
        }),
        _react2.default.createElement(
          'div',
          (0, _glamor.css)({ marginBottom: 54 }),
          (0, _jsx3.default)(_Container2.default, {}, void 0, children)
        ),
        _react2.default.createElement(
          'div',
          (0, _glamor.css)(bottomPlacementStyle),
          hideAppBanner ? null : _ref,
          hideCookieBanner ? null : _ref2
        ),
        _ref3,
        _ref4,
        (0, _jsx3.default)(_MobileMenu2.default, {
          user: viewer.currentUser,
          isOpen: isMobileNavOpen
        }),
        (0, _jsx3.default)(_SearchOverlay2.default, {
          isOpen: isSearchOpen
        })
      );
    }
  }]);
  return Shell;
}(_react2.default.PureComponent);

var mapStateToProps = function mapStateToProps(_ref5) {
  var navigation = _ref5.navigation;
  return {
    navigation: navigation
  };
};

var connector = (0, _reactRedux.connect)(mapStateToProps);

var enhance = (0, _recompose.compose)(connector, _UniqueIdProvider2.default);

exports.default = _reactRelay2.default.createContainer(enhance(Shell), {
  fragments: {
    viewer: function viewer() {
      return function (RQL_0, RQL_1, RQL_2, RQL_3) {
        return {
          children: [].concat.apply([], [{
            children: [].concat.apply([], [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }, _reactRelay2.default.QL.__frag(RQL_0)]),
            fieldName: 'currentUser',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'User'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_1), _reactRelay2.default.QL.__frag(RQL_2), _reactRelay2.default.QL.__frag(RQL_3)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Shell_ViewerRelayQL',
          type: 'Viewer'
        };
      }(_MobileMenu2.default.getFragment('user'), _getCurrentUser.currentUserFragment, _AppNavigation2.default.getFragment('viewer'), _AppNavigation2.default.getFragment('viewer'));
    }
  }
});

/***/ }),

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactBroadcast = __webpack_require__(1192);

var _NotificationsList = __webpack_require__(1259);

var _NotificationsList2 = _interopRequireDefault(_NotificationsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationsListWrapper = function () {
  function NotificationsListWrapper(props) {
    return (0, _jsx3.default)(_reactBroadcast.Subscriber, {
      channel: 'notifications'
    }, void 0, function (notifications) {
      return (0, _jsx3.default)(_NotificationsList2.default, {
        notifications: notifications
      });
    });
  }

  return NotificationsListWrapper;
}();

exports.default = NotificationsListWrapper;

/***/ }),

/***/ 1259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

var _reactMotion = __webpack_require__(1152);

var _NotificationsProvider = __webpack_require__(1142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationsList = function (_React$PureComponent) {
  (0, _inherits3.default)(NotificationsList, _React$PureComponent);

  function NotificationsList() {
    (0, _classCallCheck3.default)(this, NotificationsList);
    return (0, _possibleConstructorReturn3.default)(this, (NotificationsList.__proto__ || (0, _getPrototypeOf2.default)(NotificationsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(NotificationsList, [{
    key: 'willLeave',
    value: function willLeave() {
      return {
        opacity: (0, _reactMotion.spring)(0),
        marginTop: (0, _reactMotion.spring)(-58),
        marginLeft: (0, _reactMotion.spring)(10)
      };
    }
  }, {
    key: 'willEnter',
    value: function willEnter() {
      return {
        opacity: 0,
        marginTop: 5,
        marginLeft: 300
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          notifications = _props.notifications,
          removeNotification = _props.removeNotification;


      return (0, _jsx3.default)(_reactMotion.TransitionMotion, {
        willLeave: this.willLeave,
        willEnter: this.willEnter,
        styles: notifications.map(function (notification) {
          return {
            key: notification.id,
            data: notification,
            style: {
              opacity: (0, _reactMotion.spring)(1),
              marginTop: 5,
              marginLeft: (0, _reactMotion.spring)(10)
            }
          };
        })
      }, void 0, function (interpolatedStyles) {
        return _react2.default.createElement(
          'ul',
          (0, _glamor.css)({
            position: 'fixed',
            top: 62,
            right: 24,
            zIndex: 99999,
            listStyleType: 'none',
            margin: 0,
            padding: 0,
            width: 300,
            overflowX: 'hidden'
          }),
          interpolatedStyles.map(function (config) {
            var color = config.data.status === 'error' ? '#d81f2a' : '#266e1c';
            return _react2.default.createElement(
              'li',
              (0, _extends3.default)({
                key: config.key,
                style: config.style
              }, (0, _glamor.css)({
                fontSize: 14,
                backgroundColor: '#fff',
                padding: 16,
                color: color,
                borderLeft: '4px solid ' + color,
                margin: 0,
                marginBottom: 16,
                marginRight: 10,
                width: 280,
                userSelect: 'none',
                cursor: 'pointer',
                boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.25)'
              }), {
                onClick: function onClick() {
                  return removeNotification(config.data.id);
                } }),
              config.data.content
            );
          })
        );
      });
    }
  }]);
  return NotificationsList;
}(_react2.default.PureComponent);

exports.default = (0, _NotificationsProvider.withNotifications)(NotificationsList);

/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(1153);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(1144);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(1154);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(1155);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(1156);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(1157);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1194)))

/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(1153);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(1144);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(1154);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(1155);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(1156);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(1157);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(1153);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(1144);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(1154);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(1264);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(1155);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(1156);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(1157);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(1195);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(416);

var _glamor = __webpack_require__(415);

var _zIndex = __webpack_require__(1067);

var _reactFixedPage = __webpack_require__(1197);

var _reactFixedPage2 = _interopRequireDefault(_reactFixedPage);

var _navigation = __webpack_require__(424);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverlayBackground = function OverlayBackground(_ref) {
  var isOpen = _ref.isOpen,
      closeAll = _ref.closeAll;
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, (0, _glamor.css)({
      position: 'fixed',
      zIndex: _zIndex.ZINDEX_OVERLAY_BG,
      top: 0,
      right: 0,
      pointerEvents: isOpen ? 'auto' : 'none',
      left: 0,
      bottom: -100,
      content: '""',
      transition: 'opacity 0.2s ease-in-out',
      opacity: isOpen ? 1 : 0,
      background: 'rgba(0, 0, 0, .4)'
    }), {
      onClick: isOpen && closeAll }),
    ' ',
    (0, _jsx3.default)(_reactFixedPage2.default, {
      fixed: isOpen
    })
  );
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var navigation = _ref2.navigation;
  return {
    isOpen: navigation.isSearchOpen || navigation.isMobileNavOpen
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeAll: function closeAll() {
      return dispatch((0, _navigation.closeAll)());
    }
  };
};

var connector = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);

exports.default = connector(OverlayBackground);

/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(416);

var _glamor = __webpack_require__(415);

var _qs = __webpack_require__(1158);

var _qs2 = _interopRequireDefault(_qs);

var _detectUserMention = __webpack_require__(1200);

var _detectUserMention2 = _interopRequireDefault(_detectUserMention);

var _zIndex = __webpack_require__(1067);

var _typography = __webpack_require__(1042);

var _colors = __webpack_require__(1043);

var _Logo = __webpack_require__(1159);

var _Logo2 = _interopRequireDefault(_Logo);

var _Cross = __webpack_require__(1078);

var _Cross2 = _interopRequireDefault(_Cross);

var _Container = __webpack_require__(1129);

var _Container2 = _interopRequireDefault(_Container);

var _FillHorizontal = __webpack_require__(1145);

var _FillHorizontal2 = _interopRequireDefault(_FillHorizontal);

var _navigation = __webpack_require__(424);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEYCODES = {
  ESCAPE: 27
};

var _ref = (0, _jsx3.default)(_Logo2.default, {});

var _ref2 = (0, _jsx3.default)(_FillHorizontal2.default.Spacer, {
  size: 24
});

var _ref3 = (0, _jsx3.default)(_Cross2.default, {});

var SearchOverlay = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(SearchOverlay, _React$Component);

  function SearchOverlay(props) {
    (0, _classCallCheck3.default)(this, SearchOverlay);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchOverlay.__proto__ || (0, _getPrototypeOf2.default)(SearchOverlay)).call(this, props));

    _this.handleKeyDown = function (event) {
      if (event.keyCode === KEYCODES.ESCAPE) {
        _this.props.closeSearch();
      }
    };

    _this.setInputRef = function (el) {
      _this._input = el;
    };

    _this.handleSubmit = function (event) {
      event.preventDefault();
      _this._input.blur();

      var query = _this._input.value;

      var presentUsername = (0, _detectUserMention2.default)(query);

      if (presentUsername) {
        _this.context.router.push({
          pathname: '/' + presentUsername
        });
      } else {
        _this.context.router.push({
          pathname: '/search/',
          search: '?' + _qs2.default.stringify({
            q: query
          })
        });
      }
    };

    _this.state = {
      forceFocus: false
    };
    return _this;
  }

  (0, _createClass3.default)(SearchOverlay, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isOpen && this.props.isOpen) {
        document.addEventListener('keydown', this.handleKeyDown);
        this._input.focus();
      }

      if (prevProps.isOpen && !this.props.isOpen) {
        document.removeEventListener('keydown', this.handleKeyDown);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          closeSearch = _props.closeSearch,
          location = _props.location;
      var forceFocus = this.state.forceFocus;


      return _react2.default.createElement(
        'div',
        (0, _glamor.css)({
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          zIndex: _zIndex.ZINDEX_MODAL,
          pointerEvents: 'none'
        }),
        _react2.default.createElement(
          'div',
          (0, _glamor.css)({
            position: 'absolute',
            pointerEvents: 'all',
            transform: isOpen ? 'translateY(50%)' : null,
            top: '-100%',
            left: 0,
            right: 0,
            height: '100%',
            backgroundColor: _colors.WHITE,
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            opacity: isOpen ? 1 : 0,
            transition: 'transform 0.2s ease-in-out, opacity 0.2s ease-in-out ' + (isOpen ? '' : '0.2s')
          }),
          _react2.default.createElement('div', (0, _glamor.css)({ height: '50%' })),
          (0, _jsx3.default)(_Container2.default, {}, void 0, (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_FillHorizontal2.default, {}, void 0, _react2.default.createElement(
            'div',
            (0, _glamor.css)({
              flexGrow: '0',
              flexShrink: '0',
              width: '90px'
            }),
            _ref
          ), _ref2, _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, (0, _glamor.css)({
              display: 'block',
              width: 24,
              height: 24,
              padding: 4,
              cursor: 'pointer',
              ':hover': {
                color: _colors.RED
              }
            }), {
              onClick: closeSearch }),
            _ref3
          )))),
          _react2.default.createElement('div', (0, _glamor.css)({ flexGrow: 1 })),
          (0, _jsx3.default)(_Container2.default, {}, void 0, _react2.default.createElement(
            'form',
            (0, _extends3.default)({}, (0, _glamor.css)({
              marginBottom: 20
            }), {
              action: '/search/',
              method: 'get',
              onSubmit: this.handleSubmit }),
            _react2.default.createElement('input', (0, _extends3.default)({}, (0, _glamor.css)({
              display: 'block',
              maxWidth: '100%',
              padding: '3px 0',
              border: 'none',
              margin: 0,
              fontSize: 64,
              fontFamily: _typography.FAMILY_EXTENDED_BOLD,
              borderBottom: '2px solid #AAAAAA',
              borderRadius: 0,
              width: '100%',
              '::placeholder': {
                color: '#AAAAAA'
              },
              ':focus': {
                outline: 'none',
                borderBottomColor: _colors.BLACK
              }
            }), {
              name: 'q',
              ref: this.setInputRef,
              type: 'text',
              placeholder: 'Search',
              autoComplete: 'off',
              onChange: this.handleChange
            })),
            _react2.default.createElement('div', (0, _glamor.css)({ height: 8 })),
            _react2.default.createElement(
              'div',
              (0, _glamor.css)({
                color: '#AAAAAA',
                fontSize: 12,
                fontFamily: _typography.FAMILY_STANDARD
              }),
              'hit enter to search or escape to close this window'
            )
          )),
          _react2.default.createElement('div', (0, _glamor.css)({ flexGrow: 1 }))
        ),
        _react2.default.createElement('div', (0, _glamor.css)({
          position: 'absolute',
          pointerEvents: 'all',
          transform: isOpen ? 'translateY(-50%)' : null,
          bottom: '-100%',
          left: 0,
          right: 0,
          height: '100%',
          backgroundColor: _colors.RED,
          transition: 'transform 0.2s ease-in-out'
        }))
      );
    }
  }]);
  return SearchOverlay;
}(_react2.default.Component), _class.contextTypes = {
  router: _propTypes2.default.object.isRequired
}, _temp);


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeSearch: function closeSearch() {
      return dispatch((0, _navigation.closeSearch)());
    }
  };
};

var connector = (0, _reactRedux.connect)(null, mapDispatchToProps);

exports.default = connector(SearchOverlay);

/***/ }),

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1198);
var formats = __webpack_require__(1199);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1198);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactRedux = __webpack_require__(416);

var _reactIntl = __webpack_require__(192);

var _glamor = __webpack_require__(415);

var _zIndex = __webpack_require__(1067);

var _typography = __webpack_require__(1042);

var _colors = __webpack_require__(1043);

var _ShopLink = __webpack_require__(1146);

var _ShopLink2 = _interopRequireDefault(_ShopLink);

var _Cross = __webpack_require__(1078);

var _Cross2 = _interopRequireDefault(_Cross);

var _navigation = __webpack_require__(424);

var _AboutLink = __webpack_require__(1201);

var _AboutLink2 = _interopRequireDefault(_AboutLink);

var _LoginLink = __webpack_require__(1202);

var _LoginLink2 = _interopRequireDefault(_LoginLink);

var _DeepDownloadLink = __webpack_require__(1272);

var _DeepDownloadLink2 = _interopRequireDefault(_DeepDownloadLink);

var _JobsLink = __webpack_require__(1207);

var _JobsLink2 = _interopRequireDefault(_JobsLink);

var _EventsLink = __webpack_require__(1208);

var _EventsLink2 = _interopRequireDefault(_EventsLink);

var _PressLink = __webpack_require__(1209);

var _PressLink2 = _interopRequireDefault(_PressLink);

var _SpacesLink = __webpack_require__(1210);

var _SpacesLink2 = _interopRequireDefault(_SpacesLink);

var _SupportLink = __webpack_require__(1211);

var _SupportLink2 = _interopRequireDefault(_SupportLink);

var _InstagramLink = __webpack_require__(1212);

var _InstagramLink2 = _interopRequireDefault(_InstagramLink);

var _TwitterLink = __webpack_require__(1213);

var _TwitterLink2 = _interopRequireDefault(_TwitterLink);

var _FacebookLink = __webpack_require__(1214);

var _FacebookLink2 = _interopRequireDefault(_FacebookLink);

var _Logout = __webpack_require__(1215);

var _Logout2 = _interopRequireDefault(_Logout);

var _LocaleSwitcher = __webpack_require__(1216);

var _LocaleSwitcher2 = _interopRequireDefault(_LocaleSwitcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEYCODES = {
  ESCAPE: 27
};

function PrimaryMenuItem(_ref) {
  var children = _ref.children;

  return _react2.default.cloneElement(children, (0, _glamor.css)({
    color: _colors.BLACK,
    fontSize: 20,
    lineHeight: 1.6,
    fontFamily: _typography.FAMILY_STANDARD_BOLD,
    cursor: 'pointer',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline'
    }
  }));
}

function SecondaryMenuItem(_ref2) {
  var children = _ref2.children;

  return _react2.default.cloneElement(children, (0, _glamor.css)({
    color: _colors.BLACK,
    fontSize: 20,
    lineHeight: 1.6,
    fontFamily: _typography.FAMILY_STANDARD,
    cursor: 'pointer',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline'
    }
  }));
}

function SocialMenuItem(_ref3) {
  var children = _ref3.children;

  return _react2.default.cloneElement(children, (0, _glamor.css)({
    color: _colors.BLACK,
    fontSize: 16,
    lineHeight: 1.6,
    fontFamily: _typography.FAMILY_STANDARD,
    cursor: 'pointer',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline'
    }
  }));
}

var _ref5 = (0, _jsx3.default)(_Cross2.default, {});

var _ref6 = (0, _jsx3.default)(_Logout2.default, {});

var _ref7 = (0, _jsx3.default)(_LoginLink2.default, {});

var _ref8 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.profileLabel',
  description: 'Profile Label',
  defaultMessage: 'Profile'
});

var _ref9 = (0, _jsx3.default)(_DeepDownloadLink2.default, {});

var _ref10 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(SecondaryMenuItem, {}, void 0, (0, _jsx3.default)(_AboutLink2.default, {})));

var _ref11 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(SecondaryMenuItem, {}, void 0, (0, _jsx3.default)(_JobsLink2.default, {})));

var _ref12 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(SecondaryMenuItem, {}, void 0, (0, _jsx3.default)(_EventsLink2.default, {})));

var _ref13 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(SecondaryMenuItem, {}, void 0, (0, _jsx3.default)(_SpacesLink2.default, {})));

var _ref14 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(SecondaryMenuItem, {}, void 0, (0, _jsx3.default)(_SupportLink2.default, {})));

var _ref15 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(SocialMenuItem, {}, void 0, (0, _jsx3.default)(_InstagramLink2.default, {})));

var _ref16 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(SocialMenuItem, {}, void 0, (0, _jsx3.default)(_TwitterLink2.default, {})));

var _ref17 = (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(SocialMenuItem, {}, void 0, (0, _jsx3.default)(_FacebookLink2.default, {})));

var _ref18 = (0, _jsx3.default)(_LocaleSwitcher2.default, {});

var MobileMenu = function (_React$Component) {
  (0, _inherits3.default)(MobileMenu, _React$Component);

  function MobileMenu() {
    var _ref4;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MobileMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref4 = MobileMenu.__proto__ || (0, _getPrototypeOf2.default)(MobileMenu)).call.apply(_ref4, [this].concat(args))), _this), _this.handleKeyDown = function (event) {
      if (event.keyCode === KEYCODES.ESCAPE) {
        _this.props.closeMobileNavigation();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MobileMenu, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isOpen && this.props.isOpen) {
        document.addEventListener('keydown', this.handleKeyDown);
      }

      if (prevProps.isOpen && !this.props.isOpen) {
        document.removeEventListener('keydown', this.handleKeyDown);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          isOpen = _props.isOpen,
          closeMobileNavigation = _props.closeMobileNavigation;


      return _react2.default.createElement(
        'div',
        (0, _glamor.css)({
          position: 'fixed',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          top: 0,
          left: -216,
          transform: isOpen ? 'translateX(216px)' : null,
          boxShadow: isOpen ? '8px 0 48px rgba(0, 0, 0, 0.2)' : null,
          zIndex: _zIndex.ZINDEX_MODAL,
          width: 216,
          bottom: -100,
          background: _colors.WHITE,
          color: _colors.BLACK,
          padding: '24px 32px 124px',
          transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out'
        }),
        _react2.default.createElement(
          'a',
          (0, _extends3.default)({}, (0, _glamor.css)({
            display: 'block',
            width: 24,
            height: 24,
            padding: 4,
            cursor: 'pointer',
            ':hover': {
              color: _colors.RED
            }
          }), {
            onClick: closeMobileNavigation }),
          _ref5
        ),
        _react2.default.createElement('div', (0, _glamor.css)({ height: 56, flexShrink: 0, flexGrow: 0 })),
        _react2.default.createElement(
          'nav',
          (0, _glamor.css)({ display: 'flex', flexDirection: 'column', flexGrow: 1 }),
          _react2.default.createElement(
            'ul',
            (0, _glamor.css)({
              listStyleType: 'none',
              margin: 0,
              padding: 0
            }),
            (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(PrimaryMenuItem, {}, void 0, user ? _ref6 : _ref7)),
            (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(PrimaryMenuItem, {}, void 0, user ? (0, _jsx3.default)(_ShopLink2.default, {
              user: user
            }, void 0, _ref8) : _ref9))
          ),
          _react2.default.createElement('div', (0, _glamor.css)({ height: 32, flexShrink: 0, flexGrow: 0 })),
          _react2.default.createElement(
            'ul',
            (0, _glamor.css)({ listStyleType: 'none', margin: 0, padding: 0 }),
            _ref10,
            _ref11,
            _ref12,
            _ref13,
            _ref14
          ),
          _react2.default.createElement('div', (0, _glamor.css)({ flexGrow: 1 })),
          _react2.default.createElement(
            'ul',
            (0, _glamor.css)({ listStyleType: 'none', margin: 0, padding: 0 }),
            _ref15,
            _ref16,
            _ref17
          ),
          _react2.default.createElement('div', (0, _glamor.css)({ height: 32, flexShrink: 0, flexGrow: 0 })),
          _ref18
        )
      );
    }
  }]);
  return MobileMenu;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeMobileNavigation: function closeMobileNavigation() {
      return dispatch((0, _navigation.closeMobileNavigation)());
    }
  };
};

var connector = (0, _reactRedux.connect)(null, mapDispatchToProps);

exports.default = _reactRelay2.default.createContainer(connector(MobileMenu), {
  fragments: {
    user: function user() {
      return function (RQL_0) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'MobileMenu_UserRelayQL',
          type: 'User'
        };
      }(_ShopLink2.default.getFragment('user'));
    }
  }
});

/***/ }),

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(124);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(416);

var _reactIntl = __webpack_require__(192);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HomeAB = __webpack_require__(1147);

var _contextWrappers = __webpack_require__(1123);

var _tracking = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var theExperimentName = 'LandingPage_AB_mobile';

var _ref3 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.downloadLabel',
  description: 'Download Label',
  defaultMessage: 'Download App'
});

var DeepDownloadLink = function (_React$Component) {
  (0, _inherits3.default)(DeepDownloadLink, _React$Component);

  function DeepDownloadLink(props) {
    (0, _classCallCheck3.default)(this, DeepDownloadLink);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DeepDownloadLink.__proto__ || (0, _getPrototypeOf2.default)(DeepDownloadLink)).call(this, props));

    _this.clickDownloadApp = function () {
      var overlays = _this.props.overlays;

      var _ref = overlays.deeplinkDownload || { path: '' },
          source = _ref.path;

      _this.winExperiment();
      (0, _tracking.trackDownLoadAppHeader)({ source: source });
    };

    _this.state = { mounted: false };
    return _this;
  }

  (0, _createClass3.default)(DeepDownloadLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ mounted: true });
    }
  }, {
    key: 'winExperiment',
    value: function winExperiment() {
      var overlays = this.props.overlays;
      var landingAB = overlays.landingAB;


      if (!landingAB) {
        return function () {
          return false;
        };
      }

      return (0, _HomeAB.emmitButtonClick)(landingAB, 'download app');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          overlays = _props.overlays,
          dispatch = _props.dispatch,
          userAgent = _props.userAgent,
          onclick = _props.onclick,
          router = _props.router,
          props = (0, _objectWithoutProperties3.default)(_props, ['overlays', 'dispatch', 'userAgent', 'onclick', 'router']);
      var mounted = this.state.mounted;

      var _ref2 = overlays.deeplink || { link: '' },
          link = _ref2.link;

      var isLanding = router.isActive('/', true);
      var channel = isLanding ? 'landingpage_mobile_' + (userAgent.isAndroid ? 'google' : 'apple') + '_a' : undefined;
      var href = link ? link + '?channel=' + (channel || 'download%20button') : 'javascript:;';
      var onClick = onclick || this.clickDownloadApp;

      if (!mounted) {
        return null;
      }

      return _react2.default.createElement(
        'a',
        (0, _extends3.default)({
          target: '_blank',
          href: href,
          onClick: onClick
        }, props),
        _ref3
      );
    }
  }]);
  return DeepDownloadLink;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref4) {
  var userAgent = _ref4.userAgent,
      overlays = _ref4.overlays;
  return {
    userAgent: userAgent,
    overlays: overlays
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _contextWrappers.withRouter)(DeepDownloadLink));

/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  Experiment: __webpack_require__(1274),
  Variant: __webpack_require__(1204),
  emitter: __webpack_require__(1122),
  experimentDebugger: __webpack_require__(1280),
  mixpanelHelper: __webpack_require__(1281),
  segmentHelper: __webpack_require__(1282)
};


/***/ }),

/***/ 1274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CoreExperiment = __webpack_require__(1275);

var _CoreExperiment2 = _interopRequireDefault(_CoreExperiment);

var _emitter = __webpack_require__(1122);

var _emitter2 = _interopRequireDefault(_emitter);

var _crc = __webpack_require__(286);

var _crc2 = _interopRequireDefault(_crc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var store = void 0;

var noopStore = {
  getItem: function getItem() {},
  setItem: function setItem() {}
};

if (typeof window !== 'undefined' && 'localStorage' in window && window['localStorage'] !== null) {
  try {
    var key = '__pushtell_react__';
    window.localStorage.setItem(key, key);
    if (window.localStorage.getItem(key) !== key) {
      store = noopStore;
    } else {
      window.localStorage.removeItem(key);
      store = window.localStorage;
    }
  } catch (e) {
    store = noopStore;
  }
} else {
  store = noopStore;
}

_emitter2.default.addActiveVariantListener(function (experimentName, variantName, skipSave) {
  if (skipSave) {
    return;
  }
  store.setItem('PUSHTELL-' + experimentName, variantName);
});

var Experiment = function (_Component) {
  _inherits(Experiment, _Component);

  function Experiment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Experiment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Experiment.__proto__ || Object.getPrototypeOf(Experiment)).call.apply(_ref, [this].concat(args))), _this), _this.win = function () {
      _emitter2.default.emitWin(_this.props.name);
    }, _this.getSelectedVariant = function () {
      /*
       Choosing a weighted variant:
        For C, A, B with weights 2, 4, 8
         variants = A, B, C
        weights = 4, 8, 2
        weightSum = 14
        weightedIndex = 9
         AAAABBBBBBBBCC
        ========^
        Select B
       */

      // Sorted array of the variant names, example: ["A", "B", "C"]
      var variants = _emitter2.default.getSortedVariants(_this.props.name);
      // Array of the variant weights, also sorted by variant name. For example, if
      // variant C had weight 2, variant A had weight 4, and variant B had weight 8
      // return [4, 8, 2] to correspond with ["A", "B", "C"]
      var weights = _emitter2.default.getSortedVariantWeights(_this.props.name);
      // Sum the weights
      var weightSum = weights.reduce(function (a, b) {
        return a + b;
      }, 0);
      // A random number between 0 and weightSum
      var weightedIndex = typeof _this.props.userIdentifier === 'string' ? Math.abs((0, _crc2.default)(_this.props.userIdentifier) % weightSum) : Math.floor(Math.random() * weightSum);
      // Iterate through the sorted weights, and deduct each from the weightedIndex.
      // If weightedIndex drops < 0, select the variant. If weightedIndex does not
      // drop < 0, default to the last variant in the array that is initially assigned.
      var selectedVariant = variants[variants.length - 1];
      for (var index = 0; index < weights.length; index++) {
        weightedIndex -= weights[index];
        if (weightedIndex < 0) {
          selectedVariant = variants[index];
          break;
        }
      }
      _emitter2.default.setActiveVariant(_this.props.name, selectedVariant);
      return selectedVariant;
    }, _this.getLocalStorageValue = function () {
      if (typeof _this.props.userIdentifier === "string") {
        return _this.getSelectedVariant();
      }
      var activeValue = _emitter2.default.getActiveVariant(_this.props.name);
      if (typeof activeValue === "string") {
        return activeValue;
      }
      var storedValue = store.getItem('PUSHTELL-' + _this.props.name);
      if (typeof storedValue === "string") {
        _emitter2.default.setActiveVariant(_this.props.name, storedValue, true);
        return storedValue;
      }
      if (typeof _this.props.defaultVariantName === 'string') {
        _emitter2.default.setActiveVariant(_this.props.name, _this.props.defaultVariantName);
        return _this.props.defaultVariantName;
      }
      return _this.getSelectedVariant();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Experiment, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(_CoreExperiment2.default, _extends({}, this.props, { value: this.getLocalStorageValue }));
    }
  }]);

  return Experiment;
}(_react.Component);

Experiment.propTypes = {
  name: _propTypes2.default.string.isRequired,
  defaultVariantName: _propTypes2.default.string,
  userIdentifier: _propTypes2.default.string
};
Experiment.displayName = "Pushtell.Experiment";
exports.default = Experiment;
module.exports = exports['default'];

/***/ }),

/***/ 1275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(8);

var _warning2 = _interopRequireDefault(_warning);

var _emitter = __webpack_require__(1122);

var _emitter2 = _interopRequireDefault(_emitter);

var _Variant = __webpack_require__(1204);

var _Variant2 = _interopRequireDefault(_Variant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CoreExperiment = function (_Component) {
  _inherits(CoreExperiment, _Component);

  function CoreExperiment(props) {
    _classCallCheck(this, CoreExperiment);

    var _this = _possibleConstructorReturn(this, (CoreExperiment.__proto__ || Object.getPrototypeOf(CoreExperiment)).call(this));

    _this.win = function () {
      _emitter2.default.emitWin(_this.props.name);
    };

    _this.state = {};
    _this.displayName = "Pushtell.CoreExperiment";


    var children = {};
    _react2.default.Children.forEach(props.children, function (element) {
      if (!_react2.default.isValidElement(element) || element.type.displayName !== "Pushtell.Variant") {
        var error = new Error("Pushtell Experiment children must be Pushtell Variant components.");
        error.type = "PUSHTELL_INVALID_CHILD";
        throw error;
      }
      children[element.props.name] = element;
      _emitter2.default.addExperimentVariant(props.name, element.props.name);
    });
    _emitter2.default.emit("variants-loaded", props.name);
    _this.state.variants = children;
    return _this;
  }

  _createClass(CoreExperiment, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value || nextProps.children !== this.props.children) {
        var value = typeof nextProps.value === "function" ? nextProps.value() : nextProps.value;
        var children = {};
        _react2.default.Children.forEach(nextProps.children, function (element) {
          children[element.props.name] = element;
        });
        this.setState({
          value: value,
          variants: children
        });
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var value = typeof this.props.value === "function" ? this.props.value() : this.props.value;
      if (!this.state.variants[value]) {
        if (false) {
          (0, _warning2.default)(true, 'Experiment “' + this.props.name + '” does not contain variant “' + value + '”');
        }
      }
      _emitter2.default._incrementActiveExperiments(this.props.name);
      _emitter2.default.setActiveVariant(this.props.name, value);
      _emitter2.default._emitPlay(this.props.name, value);
      this.setState({
        value: value
      });
      this.valueSubscription = _emitter2.default.addActiveVariantListener(this.props.name, function (experimentName, variantName) {
        _this2.setState({
          value: variantName
        });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _emitter2.default._decrementActiveExperiments(this.props.name);
      this.valueSubscription.remove();
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.variants[this.state.value] || null;
    }
  }]);

  return CoreExperiment;
}(_react.Component);

CoreExperiment.propTypes = {
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
};
exports.default = CoreExperiment;
;
module.exports = exports['default'];

/***/ }),

/***/ 1276:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var fbemitter = {
  EventEmitter: __webpack_require__(1277),
  EmitterSubscription : __webpack_require__(1203)
};

module.exports = fbemitter;


/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BaseEventEmitter
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EmitterSubscription = __webpack_require__(1203);
var EventSubscriptionVendor = __webpack_require__(1279);

var emptyFunction = __webpack_require__(102);
var invariant = __webpack_require__(0);

/**
 * @class BaseEventEmitter
 * @description
 * An EventEmitter is responsible for managing a set of listeners and publishing
 * events to them when it is told that such events happened. In addition to the
 * data for the given event it also sends a event control object which allows
 * the listeners/handlers to prevent the default behavior of the given event.
 *
 * The emitter is designed to be generic enough to support all the different
 * contexts in which one might want to emit events. It is a simple multicast
 * mechanism on top of which extra functionality can be composed. For example, a
 * more advanced emitter may use an EventHolder and EventFactory.
 */

var BaseEventEmitter = (function () {
  /**
   * @constructor
   */

  function BaseEventEmitter() {
    _classCallCheck(this, BaseEventEmitter);

    this._subscriber = new EventSubscriptionVendor();
    this._currentSubscription = null;
  }

  /**
   * Adds a listener to be invoked when events of the specified type are
   * emitted. An optional calling context may be provided. The data arguments
   * emitted will be passed to the listener function.
   *
   * TODO: Annotate the listener arg's type. This is tricky because listeners
   *       can be invoked with varargs.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
    return this._subscriber.addSubscription(eventType, new EmitterSubscription(this._subscriber, listener, context));
  };

  /**
   * Similar to addListener, except that the listener is removed after it is
   * invoked once.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke only once when the
   *   specified event is emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.once = function once(eventType, listener, context) {
    var emitter = this;
    return this.addListener(eventType, function () {
      emitter.removeCurrentListener();
      listener.apply(context, arguments);
    });
  };

  /**
   * Removes all of the registered listeners, including those registered as
   * listener maps.
   *
   * @param {?string} eventType - Optional name of the event whose registered
   *   listeners to remove
   */

  BaseEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
    this._subscriber.removeAllSubscriptions(eventType);
  };

  /**
   * Provides an API that can be called during an eventing cycle to remove the
   * last listener that was invoked. This allows a developer to provide an event
   * object that can remove the listener (or listener map) during the
   * invocation.
   *
   * If it is called when not inside of an emitting cycle it will throw.
   *
   * @throws {Error} When called not during an eventing cycle
   *
   * @example
   *   var subscription = emitter.addListenerMap({
   *     someEvent: function(data, event) {
   *       console.log(data);
   *       emitter.removeCurrentListener();
   *     }
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   *   emitter.emit('someEvent', 'def'); // does not log anything
   */

  BaseEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
    !!!this._currentSubscription ?  false ? invariant(false, 'Not in an emitting cycle; there is no current subscription') : invariant(false) : undefined;
    this._subscriber.removeSubscription(this._currentSubscription);
  };

  /**
   * Returns an array of listeners that are currently registered for the given
   * event.
   *
   * @param {string} eventType - Name of the event to query
   * @return {array}
   */

  BaseEventEmitter.prototype.listeners = function listeners(eventType) /* TODO: Array<EventSubscription> */{
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    return subscriptions ? subscriptions.filter(emptyFunction.thatReturnsTrue).map(function (subscription) {
      return subscription.listener;
    }) : [];
  };

  /**
   * Emits an event of the given type with the given data. All handlers of that
   * particular type will be notified.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {*} Arbitrary arguments to be passed to each registered listener
   *
   * @example
   *   emitter.addListener('someEvent', function(message) {
   *     console.log(message);
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   */

  BaseEventEmitter.prototype.emit = function emit(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    if (subscriptions) {
      var keys = Object.keys(subscriptions);
      for (var ii = 0; ii < keys.length; ii++) {
        var key = keys[ii];
        var subscription = subscriptions[key];
        // The subscription may have been removed during this event loop.
        if (subscription) {
          this._currentSubscription = subscription;
          this.__emitToSubscription.apply(this, [subscription].concat(Array.prototype.slice.call(arguments)));
        }
      }
      this._currentSubscription = null;
    }
  };

  /**
   * Provides a hook to override how the emitter emits an event to a specific
   * subscription. This allows you to set up logging and error boundaries
   * specific to your environment.
   *
   * @param {EmitterSubscription} subscription
   * @param {string} eventType
   * @param {*} Arbitrary arguments to be passed to each registered listener
   */

  BaseEventEmitter.prototype.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
    var args = Array.prototype.slice.call(arguments, 2);
    subscription.listener.apply(subscription.context, args);
  };

  return BaseEventEmitter;
})();

module.exports = BaseEventEmitter;

/***/ }),

/***/ 1278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventSubscription
 * @typechecks
 */



/**
 * EventSubscription represents a subscription to a particular event. It can
 * remove its own subscription.
 */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EventSubscription = (function () {

  /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */

  function EventSubscription(subscriber) {
    _classCallCheck(this, EventSubscription);

    this.subscriber = subscriber;
  }

  /**
   * Removes this subscription from the subscriber that controls it.
   */

  EventSubscription.prototype.remove = function remove() {
    if (this.subscriber) {
      this.subscriber.removeSubscription(this);
      this.subscriber = null;
    }
  };

  return EventSubscription;
})();

module.exports = EventSubscription;

/***/ }),

/***/ 1279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 * 
 * @providesModule EventSubscriptionVendor
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var invariant = __webpack_require__(0);

/**
 * EventSubscriptionVendor stores a set of EventSubscriptions that are
 * subscribed to a particular event type.
 */

var EventSubscriptionVendor = (function () {
  function EventSubscriptionVendor() {
    _classCallCheck(this, EventSubscriptionVendor);

    this._subscriptionsForType = {};
    this._currentSubscription = null;
  }

  /**
   * Adds a subscription keyed by an event type.
   *
   * @param {string} eventType
   * @param {EventSubscription} subscription
   */

  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
    !(subscription.subscriber === this) ?  false ? invariant(false, 'The subscriber of the subscription is incorrectly set.') : invariant(false) : undefined;
    if (!this._subscriptionsForType[eventType]) {
      this._subscriptionsForType[eventType] = [];
    }
    var key = this._subscriptionsForType[eventType].length;
    this._subscriptionsForType[eventType].push(subscription);
    subscription.eventType = eventType;
    subscription.key = key;
    return subscription;
  };

  /**
   * Removes a bulk set of the subscriptions.
   *
   * @param {?string} eventType - Optional name of the event type whose
   *   registered supscriptions to remove, if null remove all subscriptions.
   */

  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
    if (eventType === undefined) {
      this._subscriptionsForType = {};
    } else {
      delete this._subscriptionsForType[eventType];
    }
  };

  /**
   * Removes a specific subscription. Instead of calling this function, call
   * `subscription.remove()` directly.
   *
   * @param {object} subscription
   */

  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
    var eventType = subscription.eventType;
    var key = subscription.key;

    var subscriptionsForType = this._subscriptionsForType[eventType];
    if (subscriptionsForType) {
      delete subscriptionsForType[key];
    }
  };

  /**
   * Returns the array of subscriptions that are currently registered for the
   * given event type.
   *
   * Note: This array can be potentially sparse as subscriptions are deleted
   * from it when they are removed.
   *
   * TODO: This returns a nullable array. wat?
   *
   * @param {string} eventType
   * @return {?array}
   */

  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
    return this._subscriptionsForType[eventType];
  };

  return EventSubscriptionVendor;
})();

module.exports = EventSubscriptionVendor;

/***/ }),

/***/ 1280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(280);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _emitter = __webpack_require__(1122);

var _emitter2 = _interopRequireDefault(_emitter);

var _ExecutionEnvironment = __webpack_require__(285);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (true) {
  module.exports = {
    enable: function enable() {},
    disable: function disable() {}
  };
} else {
  var attachStyleSheet = function attachStyleSheet() {
    style = document.createElement("style");
    style.appendChild(document.createTextNode(""));
    document.head.appendChild(style);
    function addCSSRule(selector, rules) {
      if ("insertRule" in style.sheet) {
        style.sheet.insertRule(selector + "{" + rules + "}", 0);
      } else if ("addRule" in style.sheet) {
        style.sheet.addRule(selector, rules, 0);
      }
    }
    addCSSRule("#pushtell-debugger", "z-index: 25000");
    addCSSRule("#pushtell-debugger", "position: fixed");
    addCSSRule("#pushtell-debugger", "transform: translateX(-50%)");
    addCSSRule("#pushtell-debugger", "bottom: 0");
    addCSSRule("#pushtell-debugger", "left: 50%");
    addCSSRule("#pushtell-debugger ul", "margin: 0");
    addCSSRule("#pushtell-debugger ul", "padding: 0 0 0 20px");
    addCSSRule("#pushtell-debugger li", "margin: 0");
    addCSSRule("#pushtell-debugger li", "padding: 0");
    addCSSRule("#pushtell-debugger li", "font-size: 14px");
    addCSSRule("#pushtell-debugger li", "line-height: 14px");
    addCSSRule("#pushtell-debugger input", "float: left");
    addCSSRule("#pushtell-debugger input", "margin: 0 10px 0 0");
    addCSSRule("#pushtell-debugger input", "padding: 0");
    addCSSRule("#pushtell-debugger input", "cursor: pointer");
    addCSSRule("#pushtell-debugger label", "color: #999999");
    addCSSRule("#pushtell-debugger label", "margin: 0 0 10px 0");
    addCSSRule("#pushtell-debugger label", "cursor: pointer");
    addCSSRule("#pushtell-debugger label", "font-weight: normal");
    addCSSRule("#pushtell-debugger label.active", "color: #000000");
    addCSSRule("#pushtell-debugger .pushtell-experiment-name", "font-size: 16px");
    addCSSRule("#pushtell-debugger .pushtell-experiment-name", "color: #000000");
    addCSSRule("#pushtell-debugger .pushtell-experiment-name", "margin: 0 0 10px 0");
    addCSSRule("#pushtell-debugger .pushtell-production-build-note", "font-size: 10px");
    addCSSRule("#pushtell-debugger .pushtell-production-build-note", "color: #999999");
    addCSSRule("#pushtell-debugger .pushtell-production-build-note", "text-align: center");
    addCSSRule("#pushtell-debugger .pushtell-production-build-note", "margin: 10px -40px 0 -10px");
    addCSSRule("#pushtell-debugger .pushtell-production-build-note", "border-top: 1px solid #b3b3b3");
    addCSSRule("#pushtell-debugger .pushtell-production-build-note", "padding: 10px 10px 5px 10px");
    addCSSRule("#pushtell-debugger .pushtell-handle", "cursor: pointer");
    addCSSRule("#pushtell-debugger .pushtell-handle", "padding: 5px 10px 5px 10px");
    addCSSRule("#pushtell-debugger .pushtell-panel", "padding: 15px 40px 5px 10px");
    addCSSRule("#pushtell-debugger .pushtell-container", "font-size: 11px");
    addCSSRule("#pushtell-debugger .pushtell-container", "background-color: #ebebeb");
    addCSSRule("#pushtell-debugger .pushtell-container", "color: #000000");
    addCSSRule("#pushtell-debugger .pushtell-container", "box-shadow: 0px 0 5px rgba(0, 0, 0, 0.1)");
    addCSSRule("#pushtell-debugger .pushtell-container", "border-top: 1px solid #b3b3b3");
    addCSSRule("#pushtell-debugger .pushtell-container", "border-left: 1px solid #b3b3b3");
    addCSSRule("#pushtell-debugger .pushtell-container", "border-right: 1px solid #b3b3b3");
    addCSSRule("#pushtell-debugger .pushtell-container", "border-top-left-radius: 2px");
    addCSSRule("#pushtell-debugger .pushtell-container", "border-top-right-radius: 2px");
    addCSSRule("#pushtell-debugger .pushtell-close", "cursor: pointer");
    addCSSRule("#pushtell-debugger .pushtell-close", "font-size: 16px");
    addCSSRule("#pushtell-debugger .pushtell-close", "font-weight: bold");
    addCSSRule("#pushtell-debugger .pushtell-close", "color: #CC0000");
    addCSSRule("#pushtell-debugger .pushtell-close", "position: absolute");
    addCSSRule("#pushtell-debugger .pushtell-close", "top: 0px");
    addCSSRule("#pushtell-debugger .pushtell-close", "right: 7px");
    addCSSRule("#pushtell-debugger .pushtell-close:hover", "color: #FF0000");
    addCSSRule("#pushtell-debugger .pushtell-close, #pushtell-debugger label", "transition: all .25s");
  };

  var removeStyleSheet = function removeStyleSheet() {
    if (style !== null) {
      document.head.removeChild(style);
      style = null;
    }
  };

  var style = null;

  var Debugger = _react2.default.createClass({
    displayName: "Pushtell.Debugger",
    getInitialState: function getInitialState() {
      return {
        experiments: _emitter2.default.getActiveExperiments(),
        visible: false
      };
    },
    toggleVisibility: function toggleVisibility() {
      this.setState({
        visible: !this.state.visible
      });
    },
    updateExperiments: function updateExperiments() {
      this.setState({
        experiments: _emitter2.default.getActiveExperiments()
      });
    },
    setActiveVariant: function setActiveVariant(experimentName, variantName) {
      _emitter2.default.setActiveVariant(experimentName, variantName);
    },
    componentWillMount: function componentWillMount() {
      this.activeSubscription = _emitter2.default.addListener("active", this.updateExperiments);
      this.inactiveSubscription = _emitter2.default.addListener("inactive", this.updateExperiments);
    },
    componentWillUnmount: function componentWillUnmount() {
      this.activeSubscription.remove();
      this.inactiveSubscription.remove();
    },
    render: function render() {
      var _this = this;

      var experimentNames = Object.keys(this.state.experiments);
      if (this.state.visible) {
        return _react2.default.createElement(
          'div',
          { className: 'pushtell-container pushtell-panel' },
          _react2.default.createElement(
            'div',
            { className: 'pushtell-close', onClick: this.toggleVisibility },
            '\xD7'
          ),
          experimentNames.map(function (experimentName) {
            var variantNames = Object.keys(_this.state.experiments[experimentName]);
            if (variantNames.length === 0) {
              return;
            }
            return _react2.default.createElement(
              'div',
              { className: 'pushtell-experiment', key: experimentName },
              _react2.default.createElement(
                'div',
                { className: 'pushtell-experiment-name' },
                experimentName
              ),
              _react2.default.createElement(
                'ul',
                null,
                variantNames.map(function (variantName) {
                  return _react2.default.createElement(
                    'li',
                    { key: variantName },
                    _react2.default.createElement(
                      'label',
                      { className: _this.state.experiments[experimentName][variantName] ? "active" : null, onClick: _this.setActiveVariant.bind(_this, experimentName, variantName) },
                      _react2.default.createElement('input', { type: 'radio', name: experimentName, value: variantName, defaultChecked: _this.state.experiments[experimentName][variantName] }),
                      variantName
                    )
                  );
                })
              )
            );
          }),
          _react2.default.createElement(
            'div',
            { className: 'pushtell-production-build-note' },
            'This panel is hidden on production builds.'
          )
        );
      } else if (experimentNames.length > 0) {
        return _react2.default.createElement(
          'div',
          { className: 'pushtell-container pushtell-handle', onClick: this.toggleVisibility },
          experimentNames.length,
          ' Active Experiment',
          experimentNames.length > 1 ? "s" : ""
        );
      } else {
        return null;
      }
    }
  });

  module.exports = {
    enable: function enable() {
      attachStyleSheet();
      var body = document.getElementsByTagName('body')[0];
      var container = document.createElement('div');
      container.id = 'pushtell-debugger';
      body.appendChild(container);
      _reactDom2.default.render(_react2.default.createElement(Debugger, null), container);
    },
    disable: function disable() {
      removeStyleSheet();
      var body = document.getElementsByTagName('body')[0];
      var container = document.getElementById('pushtell-debugger');
      if (container) {
        _reactDom2.default.unmountComponentAtNode(container);
        body.removeChild(container);
      }
    }
  };
}

/***/ }),

/***/ 1281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emitter = __webpack_require__(1122);

var _emitter2 = _interopRequireDefault(_emitter);

var _ExecutionEnvironment = __webpack_require__(285);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var playSubscription = void 0,
    winSubscription = void 0;

exports.default = {
  enable: function enable() {
    if (_ExecutionEnvironment.canUseDOM) {
      if (typeof mixpanel === "undefined") {
        var error = new Error("React A/B Test Mixpanel Helper: 'mixpanel' global is not defined.");
        error.type = "PUSHTELL_HELPER_MISSING_GLOBAL";
        throw error;
      }
      playSubscription = _emitter2.default.addPlayListener(function (experimentName, variantName) {
        mixpanel.track("Experiment Play", {
          "Experiment": experimentName,
          "Variant": variantName
        }, function () {
          _emitter2.default.emit("mixpanel-play", experimentName, variantName);
        });
      });
      winSubscription = _emitter2.default.addWinListener(function (experimentName, variantName) {
        mixpanel.track("Experiment Win", {
          "Experiment": experimentName,
          "Variant": variantName
        }, function () {
          _emitter2.default.emit("mixpanel-win", experimentName, variantName);
        });
      });
    }
  },
  disable: function disable() {
    if (_ExecutionEnvironment.canUseDOM) {
      if (!playSubscription || !winSubscription) {
        var error = new Error("React A/B Test Mixpanel Helper: Helper was not enabled.");
        error.type = "PUSHTELL_HELPER_INVALID_DISABLE";
        throw error;
      }
      playSubscription.remove();
      winSubscription.remove();
    }
  }
};
module.exports = exports['default'];

/***/ }),

/***/ 1282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emitter = __webpack_require__(1122);

var _emitter2 = _interopRequireDefault(_emitter);

var _ExecutionEnvironment = __webpack_require__(285);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var playSubscription = void 0,
    winSubscription = void 0;

exports.default = {
  enable: function enable() {
    if (_ExecutionEnvironment.canUseDOM) {
      if (typeof analytics === "undefined") {
        var error = new Error("React A/B Test Segment Helper: 'analytics' global is not defined.");
        error.type = "PUSHTELL_HELPER_MISSING_GLOBAL";
        throw error;
      }
      playSubscription = _emitter2.default.addPlayListener(function (experimentName, variantName) {
        analytics.track("Experiment Viewed", {
          "experimentName": experimentName,
          "variationName": variantName
        }, function () {
          _emitter2.default.emit("segment-play", experimentName, variantName);
        });
      });
      winSubscription = _emitter2.default.addWinListener(function (experimentName, variantName) {
        analytics.track("Experiment Won", {
          "experimentName": experimentName,
          "variationName": variantName
        }, function () {
          _emitter2.default.emit("segment-win", experimentName, variantName);
        });
      });
    }
  },
  disable: function disable() {
    if (_ExecutionEnvironment.canUseDOM) {
      if (!playSubscription || !winSubscription) {
        var error = new Error("React A/B Test Segment Helper: Helper was not enabled.");
        error.type = "PUSHTELL_HELPER_INVALID_DISABLE";
        throw error;
      }
      playSubscription.remove();
      winSubscription.remove();
    }
  }
};
module.exports = exports['default'];

/***/ }),

/***/ 1283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getSearchParam = exports.getSearchParam = function getSearchParam(param) {
  if (false || !window || !window.location || !window.location.search) {
    return null;
  }
  var currentUrl = new URL(window.location.href);
  return currentUrl.searchParams.get(param);
};

/***/ }),

/***/ 1284:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;(function() {var aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(c.get||c.set)throw new TypeError("ES3 does not support getters and setters.");a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},ba="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this;
function ca(a,b){if(b){for(var c=ba,d=a.split("."),e=0;e<d.length-1;e++){var h=d[e];h in c||(c[h]={});c=c[h]}d=d[d.length-1];e=c[d];h=b(e);h!=e&&null!=h&&aa(c,d,{configurable:!0,writable:!0,value:h})}}
ca("String.prototype.includes",function(a){return a?a:function(b,a){if(null==this)throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");if(b instanceof RegExp)throw new TypeError("First argument to String.prototype.includes must not be a regular expression");return-1!==(this+"").indexOf(b,a||0)}});ca("Number.isFinite",function(a){return a?a:function(b){return"number"!==typeof b?!1:!isNaN(b)&&Infinity!==b&&-Infinity!==b}});
ca("Number.isInteger",function(a){return a?a:function(b){return Number.isFinite(b)?b===Math.floor(b):!1}});
function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a,b,c){return a.call.apply(a.bind,arguments)}function fa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}
function ga(a,b,c){ga=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ea:fa;return ga.apply(null,arguments)};function k(a){var b=[];ha(new ia,a,b);return b.join("")}function ia(){}
function ha(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if("array"==da(b)){var d=b;b=d.length;c.push("[");for(var e="",h=0;h<b;h++)c.push(e),e=d[h],ha(a,e,c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");h="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(e=b[d],"function"!=typeof e&&(c.push(h),ja(d,c),c.push(":"),ha(a,e,c),h=","));c.push("}");return}}switch(typeof b){case "string":ja(b,c);break;case "number":c.push(isFinite(b)&&
!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var ka={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},la=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
function ja(a,b){b.push('"',a.replace(la,function(b){var a=ka[b];a||(a="\\u"+(b.charCodeAt(0)|65536).toString(16).substr(1),ka[b]=a);return a}),'"')};function n(a){a=String(a);try{return JSON.parse(a)}catch(b){}throw Error("Invalid JSON string: "+a);}function q(a){try{return"object"===typeof JSON&&"function"===typeof JSON.stringify?JSON.stringify(a):k(a)}catch(b){}throw Error("Could not stringify object");};function ma(){function a(){if(b.length)b[0](function(){b.shift();a()})}var b=[];return function(c){b.push(c);1===b.length&&a()}};var na=2,oa=200,r=5E3;function t(a,b,c){a=a.replace(/\$(\d)/g,function(a,c){return b[parseInt(c,10)-1]});c&&(a+="\n Failure Code:"+c);return a}function pa(a){return{data:a.data||"",data_parsed:a.data_parsed||{},has_app:a.has_app||null,identity:a.identity||null,referring_identity:a.referring_identity||null,referring_link:a.referring_link||null}}
function qa(a){var b=/^\$journeys_\S+$/,c=a.data,d={};if(!c)return{};switch(typeof c){case "string":try{c=n(c)}catch(e){c={}}break;case "object":break;default:c={}}Object.keys(c).forEach(function(a){b.test(a)&&(d[a]=c[a])});return d}function u(){return w()?document.referrer:String(window.location)}function ra(){var a;a="_branch_view_id".replace(/[\[\]]/g,"\\$&");return(a=(new RegExp("[?&]"+a+"(=([^&#]*)|&|#|$)")).exec(u()))&&a[2]?decodeURIComponent(a[2].replace(/\+/g," ")):""}
function sa(a){a.source="web-sdk";var b=a.data;switch(typeof b){case "string":try{b=n(b)}catch(c){b={_bncNoEval:!0}}break;case "object":break;default:b={}}b.$canonical_url||(b.$canonical_url=u());b.$og_title||(b.$og_title=x("title"));b.$og_description||(b.$og_description=x("description"));b.$og_image_url||(b.$og_image_url=x("image"));b.$og_video||(b.$og_video=x("video"));"string"===typeof b.$desktop_url&&(b.$desktop_url=b.$desktop_url.replace(/#r:[a-z0-9-_]+$/i,"").replace(/([\?\&]_branch_match_id=\d+)/,
""));try{n(b)}catch(c){b=k(b)}a.data=b;return a}function ta(a){function b(b){return""!==b}if(!a||"string"!==typeof a)return"";var c=document.createElement("a");c.href=a;a=c.pathname&&c.pathname.split("/").filter(b);return Array.isArray(a)&&a.length?a[a.length-1]+c.search:c.search}function y(a,b){a&&"object"===typeof a||(a={});if(!b||"object"!==typeof b)return a;for(var c in b)b.hasOwnProperty(c)&&(a[c]=b[c]);return a}
function ua(){try{var a=(w()&&va()?window.top.location.hash:window.location.hash).match(/r:([^&]*)/);if(a&&1<=a.length)return a[1]}catch(b){}}
function z(){var a=navigator.userAgent;return a.match(/android/i)?"android":a.match(/ipad/i)?"ipad":a.match(/i(os|p(hone|od))/i)?"ios":a.match(/\(BB[1-9][0-9]*\;/i)?"blackberry":a.match(/Windows Phone/i)?"windows_phone":a.match(/Kindle/i)||a.match(/Silk/i)||a.match(/KFTT/i)||a.match(/KFOT/i)||a.match(/KFJWA/i)||a.match(/KFJWI/i)||a.match(/KFSOWI/i)||a.match(/KFTHWA/i)||a.match(/KFTHWI/i)||a.match(/KFAPWA/i)||a.match(/KFAPWI/i)?"kindle":!1}
function wa(){var a=navigator.userAgent,b;if(/^((?!chrome|android|crios|fxios).)*safari/i.test(a))a:{var c;c=11;if((a=/version\/([^ ]*)/i.exec(a))&&a[1])try{if(parseFloat(a[1])>=c){b=!0;break a}}catch(d){}b=!1}else b=!1;return b}function xa(){try{var a=(w()&&va()?window.top.location.search:window.location.search).substring(1).match(/_branch_match_id=([^&]*)/);if(a&&1<=a.length)return a[1]}catch(b){}}function ya(a){return a.replace(/(\-\w)/g,function(b){return b[1].toUpperCase()})}
function za(a){var b="",c,d,e,h,g,f,l=0;a=a.replace(/\r\n/g,"\n");d="";for(e=0;e<a.length;e++)h=a.charCodeAt(e),128>h?d+=String.fromCharCode(h):(127<h&&2048>h?d+=String.fromCharCode(h>>6|192):(d+=String.fromCharCode(h>>12|224),d+=String.fromCharCode(h>>6&63|128)),d+=String.fromCharCode(h&63|128));for(a=d;l<a.length;)c=a.charCodeAt(l++),d=a.charCodeAt(l++),e=a.charCodeAt(l++),h=c>>2,c=(c&3)<<4|d>>4,g=(d&15)<<2|e>>6,f=e&63,isNaN(d)?f=g=64:isNaN(e)&&(f=64),b=b+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(h)+
"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(c)+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(g)+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(f);return b}function Aa(a,b,c){"function"===typeof a.addEventListener?a.addEventListener(b,c,void 0):"function"===typeof a.attachEvent?a.attachEvent("on"+b,c):a["on"+b]=c}
function Ba(a){if(!a)return null;-1<a.indexOf("://")&&(a=a.split("://")[1]);return a.substring(a.indexOf("/")+1)}function A(a){if(!a)return null;-1<a.indexOf("://")?a=a.split("://")[1]:"/"===a.charAt(0)&&(a=a.slice(1));return a}function x(a){var b;a=String(a);b=b||null;(a=document.querySelector('meta[property="og:'+a+'"]'))&&a.content&&(b=a.content);return b}
function C(){var a=document.getElementsByTagName("meta"),b={};if(!a||0===a.length)return b;for(var c={hostedIOS:null,hostedAndroid:null,applinksIOS:null,applinksAndroid:null,twitterIOS:null,twitterAndroid:null},d=0;d<a.length;d++)if((a[d].getAttribute("name")||a[d].getAttribute("property"))&&a[d].getAttribute("content")){var e=a[d].getAttribute("name"),h=a[d].getAttribute("property"),e=e||h,h=e.split(":");3===h.length&&"branch"===h[0]&&"deeplink"===h[1]&&("$ios_deeplink_path"===h[2]?c.hostedIOS=A(a[d].getAttribute("content")):
"$android_deeplink_path"===h[2]?c.hostedAndroid=A(a[d].getAttribute("content")):b[h[2]]=a[d].getAttribute("content"));"al:ios:url"===e&&(c.applinksIOS=A(a[d].getAttribute("content")));"twitter:app:url:iphone"===e&&(c.twitterIOS=A(a[d].getAttribute("content")));"al:android:url"===e&&(c.applinksAndroid=A(a[d].getAttribute("content")));"twitter:app:url:googleplay"===e&&(c.twitterAndroid=A(a[d].getAttribute("content")))}c&&"object"===typeof c&&Object.keys(c).length&&(c.hostedIOS?b.$ios_deeplink_path=
c.hostedIOS:c.applinksIOS?b.$ios_deeplink_path=c.applinksIOS:c.twitterIOS&&(b.$ios_deeplink_path=c.twitterIOS),c.hostedAndroid?b.$android_deeplink_path=c.hostedAndroid:c.applinksAndroid?b.$android_deeplink_path=c.applinksAndroid:c.twitterAndroid&&(b.$android_deeplink_path=c.twitterAndroid),b.hasOwnProperty("$ios_deeplink_path")&&b.hasOwnProperty("$android_deeplink_path")&&b.$ios_deeplink_path===b.$android_deeplink_path&&(b.$deeplink_path=b.$ios_deeplink_path));return b}
function Ca(){var a;try{navigator.languages&&0<navigator.languages.length?a=navigator.languages[0]:navigator.language&&(a=navigator.language),a=a.substring(0,2).toUpperCase()}catch(b){a=null}return a}function Da(a,b){var c=[];b.forEach(function(b){-1===a.indexOf(b)&&c.push(b)});return c}
var Ea=["purchase"],D={missingPurchaseEvent:"event name is either missing, of the wrong type or not valid. Please specify 'purchase' as the event name.",missingCommerceData:"commerce_data is either missing, of the wrong type or empty. Please ensure that commerce_data is constructed correctly.",invalidKeysForRoot:"Please remove the following keys from the root of commerce_data: ",invalidKeysForProducts:"Please remove the following keys from commerce_data.products: ",invalidProductListType:"commerce_data.products must be an array of objects",
invalidProductType:"Each product in the products list must be an object"};
function Fa(a){var b="sku name price quantity brand category variant".split(" "),c=Da("common type transaction_id currency revenue revenue_in_usd exchange_rate shipping tax coupon affiliation persona products".split(" "),Object.keys(a));if(c.length)return D.invalidKeysForRoot+c.join(", ");var d=[],e;if(a.hasOwnProperty("products")){if(!Array.isArray(a.products))return D.invalidProductListType;a.products.forEach(function(a){"object"!==typeof a&&(e=D.invalidProductType);d=d.concat(Da(b,Object.keys(a)))});
if(e)return e;if(d.length)return D.invalidKeysForProducts+d.join(", ")}return null}function Ga(a,b){if(!a||"string"!==typeof a||-1===Ea.indexOf(a.toLowerCase()))return D.missingPurchaseEvent;if(!b||"object"!==typeof b||!Object.keys(b).length)return D.missingCommerceData;var c=Fa(b);return c?c:null}function E(a){return"string"!==typeof a?null:a.replace(/</g,"&lt;").replace(/>/g,"&gt;")}function F(a,b,c){if(c){if("object"===typeof c&&!Object.keys(c).length)return a;a[b]=c}return a}
function Ha(){var a={},b;b={};b=F(b,"$og_title",x("title"));b=F(b,"$og_description",x("description"));b=F(b,"$og_image_url",x("image"));b=(b=F(b,"$og_video",x("video")))&&0<Object.keys(b).length?b:null;a=F(a,"og_data",b);a=F(a,"hosted_deeplink_data",C());b=document.getElementsByTagName("title");a=F(a,"title",0<b.length?b[0].innerText:null);b=document.querySelector('meta[name="description"]');a=F(a,"description",b&&b.content?b.content:null);b=document.querySelector('link[rel="canonical"]');return(a=
F(a,"canonical_url",b&&b.href?b.href:null))&&0<Object.keys(a).length?a:{}}var Ia="ADD_TO_CART ADD_TO_WISHLIST VIEW_CART INITIATE_PURCHASE ADD_PAYMENT_INFO PURCHASE SPEND_CREDITS SEARCH VIEW_ITEM VIEW_ITEMS RATE SHARE COMPLETE_REGISTRATION COMPLETE_TUTORIAL ACHIEVE_LEVEL UNLOCK_ACHIEVEMENT".split(" "),Ja="transaction_id revenue currency shipping tax coupon affiliation search_query description".split(" ");
function Ka(a){if(!a||!Object.keys(a).length)return null;for(var b=Da(Ja,Object.keys(a)),c={},d=0;d<b.length;d++){var e=b[d];c[e]=a[e];delete a[e]}return{custom_data:La(c),event_data:a}}function G(a,b){return a&&b?"array"===b?Array.isArray(a):typeof a===b&&!Array.isArray(a):!1}
function Ma(a){var b={},b=F(b,"http_origin",document.URL),b=F(b,"user_agent",navigator.userAgent),b=F(b,"language",Ca()),b=F(b,"screen_width",screen.width),b=F(b,"screen_height",screen.height),b=F(b,"http_referrer",document.referrer),b=F(b,"browser_fingerprint_id",a.D),b=F(b,"developer_identity",a.G),b=F(b,"sdk","web");return b=F(b,"sdk_version","2.31.0")}function w(){return window.self!==window.top}
function va(){var a="true";try{window.top.location.search&&(a="true")}catch(b){return!1}return"true"===a}function H(a){return a?a:w()?va()?window.top.document.referrer:"":document.referrer}function La(a){if(G(a,"object")&&Object.keys(a).length){for(var b in a)a.hasOwnProperty(b)&&(a[b]=G(a[b],"object")||G(a[b],"array")?q(a[b]):a[b].toString());return a}}function Na(a,b){var c=a?y({},a):{};return b&&0<Object.keys(b).length?0<Object.keys(c).length?y(c,b):y({},b):c};function I(a,b){return function(c,d,e){if("number"===typeof e||e)if(0===b){if("object"!==typeof e)return t("API request $1, parameter $2 is not $3",[c,d,"an object"])}else if(3===b){if(!(e instanceof Array))return t("API request $1, parameter $2 is not $3",[c,d,"an array"])}else if(2===b){if("number"!==typeof e)return t("API request $1, parameter $2 is not $3",[c,d,"a number"])}else if(4===b){if("boolean"!==typeof e)return t("API request $1, parameter $2 is not $3",[c,d,"a boolean"])}else{if("string"!==
typeof e)return t("API request $1, parameter $2 is not $3",[c,d,"a string"]);if(1!==b&&!b.test(e))return t("API request $1, parameter $2 is not $3",[c,d,"in the proper format"])}else if(a)return t("API request $1 missing parameter $2",[c,d]);return!1}}var J=/^[0-9]{15,20}$/;function K(a){return y(a,{browser_fingerprint_id:I(!0,J),identity_id:I(!0,J),sdk:I(!0,1),session_id:I(!0,J)})}
var Oa={destination:"https://api.branch.io",endpoint:"/v1/open",method:"POST",a:{browser_fingerprint_id:I(!1,J),alternative_browser_fingerprint_id:I(!1,J),identity_id:I(!1,J),link_identifier:I(!1,1),sdk:I(!1,1),options:I(!1,0),initial_referrer:I(!1,1)}},Pa={destination:"https://app.link",endpoint:"/_r",method:"GET",U:!0,a:{sdk:I(!0,1),_t:I(!1,J),branch_key:I(!0,1)}},Qa={destination:"",endpoint:"",method:"GET",f:{link_url:I(!0,1)},a:{click:I(!0,1)}},Ra={destination:"https://bnc.lt",endpoint:"/c",method:"POST",
f:{link_url:I(!0,1)},a:{sdk:I(!1,1),phone:I(!0,1)}},Sa={destination:"https://api.branch.io",endpoint:"/v1/referralcode",method:"POST",a:K({amount:I(!0,2),bucket:I(!1,1),calculation_type:I(!0,2),creation_source:I(!0,2),expiration:I(!1,1),location:I(!0,2),prefix:I(!1,1),type:I(!0,1)})},Ta={destination:"https://api.branch.io",endpoint:"/v1/referralcode",method:"POST",f:{code:I(!0,1)},a:K({})},Ua={destination:"https://api.branch.io",endpoint:"/v1/applycode",method:"POST",f:{code:I(!0,1)},a:K({})},Va=
{destination:"https://api.branch.io",endpoint:"/v1/logout",method:"POST",a:K({session_id:I(!0,J)})},Wa={destination:"https://api.branch.io",endpoint:"/v1/profile",method:"POST",a:K({identity_id:I(!0,J),identity:I(!0,1)})},Xa={destination:"https://api.branch.io",endpoint:"/v1/referrals",method:"GET",f:{identity_id:I(!0,J)},a:K({})},Ya={destination:"https://api.branch.io",endpoint:"/v1/credithistory",method:"GET",a:K({begin_after_id:I(!1,J),bucket:I(!1,1),direction:I(!1,2),length:I(!1,2),link_click_id:I(!1,
J)})},Za={destination:"https://api.branch.io",endpoint:"/v1/credits",method:"GET",a:K({branch_key:I(!0,1),identity:I(!0,1)})},$a={destination:"https://api.branch.io",endpoint:"/v1/redeem",method:"POST",a:K({amount:I(!0,2),bucket:I(!0,1),identity_id:I(!0,J)})},ab={destination:"https://api.branch.io",endpoint:"/v1/url",method:"POST",va:"obj",a:K({alias:I(!1,1),campaign:I(!1,1),channel:I(!1,1),data:I(!1,1),feature:I(!1,1),identity_id:I(!0,J),stage:I(!1,1),tags:I(!1,3),type:I(!1,2),source:I(!1,1)})},
bb={destination:"https://api.branch.io",endpoint:"/v1/deepview",U:!0,method:"POST",a:K({campaign:I(!1,1),_t:I(!1,J),channel:I(!1,1),data:I(!0,1),feature:I(!1,1),link_click_id:I(!1,1),open_app:I(!1,4),append_deeplink_path:I(!1,4),stage:I(!1,1),tags:I(!1,3),deepview_type:I(!0,1),source:I(!0,1)})},cb={destination:"https://api.branch.io",endpoint:"/v1/has-app",method:"GET",a:{browser_fingerprint_id:I(!0,J)}},db={destination:"https://api.branch.io",endpoint:"/v1/event",method:"POST",a:K({event:I(!0,1),
metadata:I(!0,0),initial_referrer:I(!1,1)})},eb={destination:"https://api.branch.io",endpoint:"/v1/event",method:"POST",a:K({event:I(!0,1),metadata:I(!1,0),initial_referrer:I(!1,1),commerce_data:I(!0,0)})},fb={destination:"https://api.branch.io",endpoint:"/v2/event/standard",method:"POST",a:{name:I(!0,1),user_data:I(!0,1),custom_data:I(!1,1),event_data:I(!1,1),content_items:I(!1,1)}},gb={destination:"https://api.branch.io",endpoint:"/v2/event/custom",method:"POST",a:{name:I(!0,1),user_data:I(!0,1),
custom_data:I(!1,1)}};function hb(a){for(var b=0;b<a.length;b++){var c=this[a[b]],c="function"===typeof c?c():c;if(c.isEnabled())return c.s={},c}}function L(a){return"branch_session"===a||"branch_session_first"===a?a:"BRANCH_WEBSDK_KEY"+a}function ib(a){return"true"===a?!0:"false"===a?!1:a}function jb(a){return"branch_session"===a||"branch_session_first"===a||0===a.indexOf("BRANCH_WEBSDK_KEY")}function lb(a){a=a.trim();var b=a.indexOf("=");return{name:a.substring(0,b),value:ib(a.substring(b+1,a.length))}}
function mb(a){var b;try{b=a&&localStorage?localStorage:sessionStorage}catch(c){return{isEnabled:function(){return!1}}}return{getAll:function(){if("undefined"===typeof b)return null;var a=null,d;for(d in b)d.indexOf("BRANCH_WEBSDK_KEY")||(null===a&&(a={}),a[d.replace("BRANCH_WEBSDK_KEY","")]=ib(b.getItem(d)));return a},get:function(a,d){return ib(d&&localStorage?localStorage.getItem(L(a)):b.getItem(L(a)))},set:function(a,d,e){e&&localStorage?localStorage.setItem(L(a),d):b.setItem(L(a),d)},remove:function(a,
d){d&&localStorage?localStorage.removeItem(L(a)):b.removeItem(L(a))},clear:function(){Object.keys(b).forEach(function(a){a.indexOf("BRANCH_WEBSDK_KEY")||b.removeItem(a)})},isEnabled:function(){try{return b.setItem("test",""),b.removeItem("test"),!0}catch(c){return!1}}}}hb.prototype.local=function(){return mb(!0)};hb.prototype.session=function(){return mb(!1)};
function nb(){function a(b,a){a&&(b=L(b));document.cookie=b+"=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/"}return{getAll:function(){for(var b={},a=document.cookie.split(";"),d=0;d<a.length;d++){var e=lb(a[d]);e&&e.hasOwnProperty("name")&&e.hasOwnProperty("value")&&jb(e.name)&&(b[e.name.replace("BRANCH_WEBSDK_KEY","")]=e.value)}return b},get:function(b){b=L(b);for(var a=document.cookie.split(";"),d=0;d<a.length;d++){var e=lb(a[d]);if(e&&e.hasOwnProperty("name")&&e.hasOwnProperty("value")&&e.name===
b)return e.value}return null},set:function(b,a){document.cookie=L(b)+"="+a+"; path=/"},remove:function(b){a(b,!0)},clear:function(){for(var b=document.cookie.split(";"),c=0;c<b.length;c++){var d=lb(b[c]);d&&d.hasOwnProperty("name")&&jb(d.name)&&a(d.name,!1)}},isEnabled:function(){return navigator.cookieEnabled}}}hb.prototype.cookie=function(){return nb()};
hb.prototype.pojo={getAll:function(){return this.s},get:function(a){return this.s[a]||null},set:function(a,b){this.s[a]=b},remove:function(a){delete this.s[a]},clear:function(){this.s={}},isEnabled:function(){return!0}};function M(a,b){try{return n(a.get(b?"branch_session_first":"branch_session",b))||null}catch(c){return null}}function ob(a,b,c){a.set("branch_session",k(b));c&&a.set("branch_session_first",k(b),!0)}function pb(a,b){if(b){var c=M(a)||{},c=y(c,b);a.set("branch_session",k(c))}};function qb(){}qb.prototype.g=0;function rb(a,b,c){if("undefined"===typeof b)return"";var d=[];if(b instanceof Array){for(a=0;a<b.length;a++)d.push(encodeURIComponent(c)+"="+encodeURIComponent(b[a]));return d.join("&")}for(var e in b)b.hasOwnProperty(e)&&(b[e]instanceof Array||"object"===typeof b[e]?d.push(rb(a,b[e],c?c+"."+e:e)):d.push(encodeURIComponent(c?c+"."+e:e)+"="+encodeURIComponent(b[e])));return d.join("&")}
function sb(a,b,c){function d(a,c){"undefined"===typeof c&&(c={});if(a.branch_key&&l.test(a.branch_key))return c.branch_key=a.branch_key,c;if(a.app_id&&f.test(a.app_id))return c.app_id=a.app_id,c;throw Error(t("API request $1 missing parameter $2",[b.endpoint,"branch_key or app_id"]));}var e,h,g=b.destination+b.endpoint,f=/^[0-9]{15,20}$/,l=/key_(live|test)_[A-Za-z0-9]{32}/;if("/v1/has-app"===b.endpoint)try{b.f=d(c,b.f)}catch(p){return{error:p.message}}if("undefined"!==typeof b.f)for(e in b.f)if(b.f.hasOwnProperty(e)){if(h=
"function"===typeof b.f[e]?b.f[e](b.endpoint,e,c[e]):h)return{error:h};g+="/"+c[e]}var m={};if("undefined"!==typeof b.a)for(e in b.a)if(b.a.hasOwnProperty(e)){if(h=b.a[e](b.endpoint,e,c[e]))return{error:h};h=c[e];"undefined"!==typeof h&&""!==h&&null!==h&&(m[e]=h)}if("POST"===b.method||"/v1/credithistory"===b.endpoint)try{c=d(c,m)}catch(p){return{error:p.message}}"/v1/event"===b.endpoint&&(m.metadata=q(m.metadata||{}),m.hasOwnProperty("commerce_data")&&(m.commerce_data=q(m.commerce_data||{})));"/v1/open"===
b.endpoint&&(m.options=q(m.options||{}));return{data:rb(a,m,""),url:g.replace(/^\//,"")}}function tb(a,b,c){var d=document.createElement("script");d.type="text/javascript";d.async=!0;d.src=a;a=document.getElementsByTagName("head");!a||1>a.length?"function"===typeof b&&b():(a[0].appendChild(d),"function"===typeof b&&Aa(d,"error",b),"function"===typeof c&&Aa(d,"load",c))}
function ub(a,b,c,d,e){var h="branch_callback__"+a.g++;a=0<=b.indexOf("branch.io")?"&data=":"&post_data=";c="POST"===d?encodeURIComponent(za(k(c))):"";var g=window.setTimeout(function(){window[h]=function(){};e(Error("Request timed out"),null,504)},r);window[h]=function(a){window.clearTimeout(g);e(null,a)};tb(b+(0>b.indexOf("?")?"?":"")+(c?a+c:"")+(0<=b.indexOf("/c/")?"&click=1":"")+"&callback="+h,function(){e(Error("Request blocked by client, probably adblock"),null)},function(){try{"function"===
typeof this.remove?this.remove():this.parentNode.removeChild(this)}catch(f){}delete window[h]})}
function vb(a,b,c,d,e,h,g){var f=window.XMLHttpRequest?new XMLHttpRequest:new ActiveXObject("Microsoft.XMLHTTP");f.ontimeout=function(){h(Error("Request timed out"),null,504)};f.onerror=function(a){h(Error(a.error||"Error in API: "+f.status),null,f.status)};f.onreadystatechange=function(){var a;if(4===f.readyState)if(200===f.status){if(g)a=f.responseText;else try{a=n(f.responseText)}catch(m){a={}}h(null,a,f.status)}else if(402===f.status)h(Error("Not enough credits to redeem."),null,f.status);else if("4"===
f.status.toString().substring(0,1)||"5"===f.status.toString().substring(0,1))f.responseURL&&f.responseURL.includes("v2/event")?h(f.responseText,null,f.status):h(Error("Error in API: "+f.status),null,f.status)};try{f.open(d,b,!0),f.timeout=r,f.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),f.send(c)}catch(l){e.set("use_jsonp",!0),ub(a,b,c,d,h)}}
function wb(a,b,c,d,e){function h(){d.get("use_jsonp")||b.U?ub(a,l,c,b.method,g):vb(a,l,m,b.method,d,g)}function g(a,b,c){a&&0<p&&"5"===(c||"").toString().substring(0,1)?(p--,window.setTimeout(function(){h()},oa)):e(a,b)}var f=sb(a,b,c);if(f.error)return e(Error(q({message:f.error,endpoint:b.endpoint,data:c})));var l,m="";"GET"===b.method?l=f.url+"?"+f.data:(l=f.url,m=f.data);var p=na;h()};function N(a){a&&a.parentNode.removeChild(a)}function xb(a,b){a&&!a.className.match(new RegExp("(\\s|^)"+b+"(\\s|$)"))&&(a.className+=" "+b)}function yb(a){var b=document.body;b&&b.className.match(new RegExp("(\\s|^)"+a+"(\\s|$)"))&&(b.className=b.className.replace(new RegExp("(\\s|^)"+a+"(\\s|$)")," "))}function zb(a){var b=new Date;return b.setDate(b.getDate()+a)}
function Ab(a){return document.body.currentStyle?document.body.currentStyle[ya(a)]:window.getComputedStyle(document.body).getPropertyValue(a)}
function Bb(a){function b(a){function c(){return Math.max(document.documentElement.clientHeight,window.innerHeight||0)/100}function e(){return Math.max(document.documentElement.clientWidth,window.innerWidth||0)/100}if(!a)return 0;var h=a.replace(/[0-9,\.]/g,"");a=a.match(/\d+/g);var g=parseInt(0<a.length?a[0]:"0",10);return parseInt({px:function(a){return a},em:function(a){return document.body.currentStyle?a*b(document.body.currentStyle.fontSize):a*parseFloat(window.getComputedStyle(document.body).fontSize)},
rem:function(a){return document.documentElement.currentStyle?a*b(document.documentElement.currentStyle.fontSize):a*parseFloat(window.getComputedStyle(document.documentElement).fontSize)},vw:function(a){return a*e()},vh:function(a){return a*c()},vmin:function(a){return a*Math.min(c(),e())},vmax:function(a){return a*Math.max(c(),e())},"%":function(){return document.body.clientWidth/100*g}}[h](g),10)}return(b("76px")+b(a)).toString()+"px"}
function Cb(a,b){var c=a.get("hideBanner",!0);if(b.ia&&navigator&&Number(navigator.doNotTrack))return!1;try{"string"===typeof c&&(c=n(c))}catch(e){c=!1}var c="number"===typeof c?new Date>=new Date(c):!c,d=b.F;"number"===typeof d&&(d=!1);return!document.getElementById("branch-banner")&&!document.getElementById("branch-banner-iframe")&&(c||d)&&(b.ka&&!z()||b.J&&"android"===z()||b.la&&"ipad"===z()||b.N&&"ios"===z()||b.K&&"blackberry"===z()||b.M&&"windows_phone"===z()||b.L&&"kindle"===z())};function Db(a,b){return"#branch-banner-iframe { position: "+("top"!==b||a?"fixed":"absolute")+"; }\n"}
function Eb(a,b){var c=".branch-banner-is-active { -webkit-transition: all 0.375s ease; transition: all 00.375s ease; }\n#branch-banner { width:100%; z-index: 99999; font-family: Helvetica Neue, Sans-serif; -webkit-font-smoothing: antialiased; -webkit-user-select: none; -moz-user-select: none; user-select: none; -webkit-transition: all 0.25s ease; transition: all 00.25s ease; }\n#branch-banner .button{ border: 1px solid "+(a.buttonBorderColor||("dark"===a.theme?"transparent":"#ccc"))+"; background: "+
(a.buttonBackgroundColor||"#fff")+"; color: "+(a.buttonFontColor||"#000")+"; cursor: pointer; margin-top: 0px; font-size: 14px; display: inline-block; margin-left: 5px; font-weight: 400; text-decoration: none;  border-radius: 4px; padding: 6px 12px; transition: all .2s ease;}\n#branch-banner .button:hover {  border: 1px solid "+(a.buttonBorderColorHover||("dark"===a.theme?"transparent":"#BABABA"))+"; background: "+(a.buttonBackgroundColorHover||"#E0E0E0")+"; color: "+(a.buttonFontColorHover||"#000")+
";}\n#branch-banner .button:focus { outline: none; }\n#branch-banner * { margin-right: 4px; position: relative; line-height: 1.2em; }\n#branch-banner-close { font-weight: 400; cursor: pointer; float: left; z-index: 2;padding: 0 5px 0 5px; margin-right: 0; }\n#branch-banner .content { width:100%; overflow: hidden; height: 76px; background: rgba(255, 255, 255, 0.95); color: #333; "+("top"===a.position?"border-bottom":"border-top")+': 1px solid #ddd; }\n#branch-banner-close { color: #000; font-size: 24px; top: 14px; opacity: .5; transition: opacity .3s ease; }\n#branch-banner-close:hover { opacity: 1; }\n#branch-banner .title { font-size: 18px; font-weight:bold; color: #555; }\n#branch-banner .description { font-size: 12px; font-weight: normal; color: #777; max-height: 30px; overflow: hidden; }\n#branch-banner .icon { float: left; padding-bottom: 40px; margin-right: 10px; margin-left: 5px; }\n#branch-banner .icon img { width: 63px; height: 63px; margin-right: 0; }\n#branch-banner .reviews { font-size:13px; margin: 1px 0 3px 0; color: #777; }\n#branch-banner .reviews .star { display:inline-block; position: relative; margin-right:0; }\n#branch-banner .reviews .star span { display: inline-block; margin-right: 0; color: #555; position: absolute; top: 0; left: 0; }\n#branch-banner .reviews .review-count { font-size:10px; }\n#branch-banner .reviews .star .half { width: 50%; overflow: hidden; display: block; }\n#branch-banner .content .left { padding: 6px 5px 6px 5px; }\n#branch-banner .vertically-align-middle { top: 50%; transform: translateY(-50%); -webkit-transform: translateY(-50%); -ms-transform: translateY(-50%); }\n#branch-banner .details > * { display: block; }\n#branch-banner .content .left { height: 63px; }\n#branch-banner .content .right { float: right; height: 63px; margin-bottom: 50px; padding-top: 22px; z-index: 1; }\n#branch-banner .right > div { float: left; }\n#branch-banner-action { top: 17px; }\n#branch-banner .content:after { content: ""; position: absolute; left: 0; right: 0; top: 100%; height: 1px; background: rgba(0, 0, 0, 0.2); }\n#branch-banner .theme-dark.content { background: rgba(51, 51, 51, 0.95); }\n#branch-banner .theme-dark #branch-banner-close{ color: #fff; text-shadow: 0 1px 1px rgba(0, 0, 0, .15); }\n#branch-banner .theme-dark .details { text-shadow: 0 1px 1px rgba(0, 0, 0, .15); }\n#branch-banner .theme-dark .title { color: #fff; }\n#branch-banner .theme-dark .description { color: #fff; }\n#branch-banner .theme-dark .reviews { color: #888; }\n#branch-banner .theme-dark .reviews .star span{ color: #fff; }\n#branch-banner .theme-dark .reviews .review-count{ color: #fff; }\n',
d=z();"ios"!==d&&"ipad"!==d||!a.N?"android"===d&&a.J?c+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n#branch-banner #branch-banner-close,#branch-banner .theme-dark #branch-banner-close { height:17px; width: 17px; text-align: center; font-size: 15px; top: 24px;  border-radius:14px; border:0; line-height:14px; color:#b1b1b3; background:#efefef; padding: 0; opacity: 1; }\n#branch-banner .button { top: 0; text-decoration:none; border-bottom: 3px solid #A4C639; padding: 0 10px; height: 24px; line-height: 24px; text-align: center; color: #fff; margin-top: 2px;  font-weight: bold; background-color: #A4C639; border-radius: 5px; }\n#branch-banner .button:hover { border-bottom:3px solid #8c9c29; background-color: #c1d739; }\n":
"blackberry"===d&&a.K?c+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n":
"windows_phone"===d&&a.M?c+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n":
"kindle"===d&&a.L?c+="#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n":
(c+="#branch-banner { position: fixed; min-width: 600px; }\n#branch-sms-block * { vertical-align: bottom; font-size: 15px; }\n#branch-sms-block { display: inline-block; }\n#branch-banner input{ border: 1px solid #ccc;  font-weight: 400;  border-radius: 4px; height: 30px; padding: 5px 7px 4px; width: 145px; font-size: 14px;}\n#branch-banner input:focus { outline: none; }\n#branch-banner input.error { color: rgb(194, 0, 0); border-color: rgb(194, 0, 0); }\n#branch-banner .branch-icon-wrapper { width:25px; height: 25px; vertical-align: middle; display: inline-block; margin-top: -18px; }\n@keyframes branch-spinner { 0% { transform: rotate(0deg); -webkit-transform: rotate(0deg); -ms-transform: rotate(0deg); } 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); } }\n@-webkit-keyframes branch-spinner { 0% { transform: rotate(0deg); -webkit-transform: rotate(0deg); -ms-transform: rotate(0deg); } 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg); -ms-transform: rotate(360deg); } }\n#branch-spinner { -webkit-animation: branch-spinner 1s ease-in-out infinite; animation: branch-spinner 1s ease-in-out infinite; transition: all 0.7s ease-in-out; border:2px solid #ddd; border-bottom-color:#428bca; width:80%; height:80%; border-radius:50%; -webkit-font-smoothing: antialiased !important; }\n#branch-banner .theme-dark input { border-color: transparent; }\n",
c=window.ActiveXObject?c+"#branch-banner .checkmark { color: #428bca; font-size: 22px; }\n":c+"#branch-banner .checkmark { stroke: #428bca; stroke-dashoffset: 745.74853515625; stroke-dasharray: 745.74853515625; -webkit-animation: dash 2s ease-out forwards; animation: dash 2s ease-out forwards; }\n@-webkit-keyframes dash { 0% { stroke-dashoffset: 745.748535 15625; } 100% { stroke-dashoffset: 0; } }\n@keyframes dash { 0% { stroke-dashoffset: 745.74853515625; } 100% { stroke-dashoffset: 0; } }\n"):c+=
"#branch-banner { position: absolute; }\n#branch-banner .content .left .details .title { font-size: 12px; }\n#branch-mobile-action { white-space: nowrap; }\n#branch-banner .content .left .details .description { font-size: 11px; font-weight: normal; }\n@media only screen and (min-device-width: 320px) and (max-device-width: 350px) { #branch-banner .content .right { max-width: 120px; } }\n@media only screen and (min-device-width: 351px) and (max-device-width: 400px) and (orientation: landscape) { #branch-banner .content .right { max-width: 150px; } }\n@media only screen and (min-device-width: 401px) and (max-device-width: 480px) and (orientation: landscape) { #branch-banner .content .right { max-width: 180px; } }\n";
c+=a.$;a.w&&(c+="body { margin: 0; }\n",d=document.createElement("style"),d.type="text/css",d.id="branch-iframe-css",d.innerHTML="body { -webkit-transition: all 0.375s ease; transition: all 00.375s ease; }\n#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width:100%; left: 0; right: 0; border: 0; height: 76px; z-index: 99999; -webkit-transition: all 0.25s ease; transition: all 00.25s ease; }\n"+(z()?Db(a.ea,a.position):Db(a.aa,a.position)),(document.head||document.getElementsByTagName("head")[0]).appendChild(d));
d=document.createElement("style");d.type="text/css";d.id="branch-css";d.innerHTML=c;c=a.w?b.contentWindow.document:document;(c=c.head||c.getElementsByTagName("head")[0])&&"function"===typeof c.appendChild&&c.appendChild(d);"top"===a.position?b.style.top="-76px":"bottom"===a.position&&(b.style.bottom="-76px")};function Fb(a,b){var c;if(a.u||a.H){if(a.u){c="";for(var d=0;5>d;d++)c+='<span class="star"><svg class="star" fill="#555555" height="12" viewBox="3 2 20 19" width="12"><path d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/><path d="M0 0h24v24H0z" fill="none"/><foreignObject display="none"><span class="star">\u2606</span></foreignObject></svg>',a.u>d&&
(c+=d+1>a.u&&a.u%1?'<span class="half"><svg fill="#555555" height="12" viewBox="3 2 20 19" width="12"><defs><path d="M0 0h24v24H0V0z" id="a"/></defs><clipPath id="b"><use overflow="visible" xlink:href="#a"/></clipPath><path clip-path="url(#b)" d="M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"/></svg><foreignObject display="none"><span class="half">\u2605</span></foreignObject></span>':'<span class="full"><svg fill="#555555" height="12" viewBox="3 2 20 19" width="12"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/><path d="M0 0h24v24H0z" fill="none"/><foreignObject display="none"><span class="full">\u2605</span></foreignObject></svg> </span>'),
c+="</span>";c='<span class="stars">'+c+"</span>"}else c="";c='<div class="reviews">'+c+(a.H?'<span class="review-count">'+a.H+"</span>":"")+"</div>"}else c="";return'<div class="content'+(a.theme?" theme-"+a.theme:"")+'"><div class="right">'+b+'</div><div class="left">'+(a.ba?"":'<div id="branch-banner-close" class="branch-animation" aria-label="Close">&times;</div>')+'<div class="icon"><img src="'+a.icon+'" alt="Application icon"></div><div class="details vertically-align-middle"><div class="title">'+
a.title+"</div>"+c+'<div class="description">'+a.description+"</div></div></div></div>"}
function Gb(a,b){var c='<div id="branch-sms-form-container">'+(z()?'<a id="branch-mobile-action" class="button" href="#" target="_parent">'+((M(b)||{}).has_app?a.fa:a.ca)+"</a>":'<div class="branch-icon-wrapper" id="branch-loader-wrapper" style="opacity: 0;"><div id="branch-spinner"></div></div><div id="branch-sms-block"><form id="sms-form"><input type="phone" aria-label="Enter phone number" class="branch-animation" name="branch-sms-phone" id="branch-sms-phone" placeholder="'+a.ha+'"><button type="submit" id="branch-sms-send" class="branch-animation button">'+
a.ja+"</button></form></div>")+"</div>";if(a.w){var d=document.createElement("iframe");d.src="about:blank";d.style.overflow="hidden";d.scrolling="no";d.id="branch-banner-iframe";d.className="branch-animation";document.body.appendChild(d);var e=z(),c='<html><head></head><body class="'+("ios"===e||"ipad"===e?"branch-banner-ios":"android"===e?"branch-banner-android":"branch-banner-desktop")+'"><div id="branch-banner" class="branch-animation">'+Fb(a,c)+"</body></html>";d.contentWindow.document.open();
d.contentWindow.document.write(c);d.contentWindow.document.close()}else d=document.createElement("div"),d.id="branch-banner",d.className="branch-animation",d.innerHTML=Fb(a,c),document.body.appendChild(d);return c=d};function Hb(a,b,c,d){function e(){g();l.style.background="#FFD4D4";f.className="error";setTimeout(function(){l.style.background="#FFFFFF";f.className=""},2E3)}function h(){v=a.createElement("div");v.className="branch-icon-wrapper";v.id="branch-checkmark";v.style="opacity: 0;";v.innerHTML=window.ActiveXObject?'<span class="checkmark">&#x2713;</span>':'<svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 98.5 98.5" enable-background="new 0 0 98.5 98.5" xml:space="preserve"><path class="checkmark" fill="none" stroke-width="8" stroke-miterlimit="10" d="M81.7,17.8C73.5,9.3,62,4,49.2,4C24.3,4,4,24.3,4,49.2s20.3,45.2,45.2,45.2s45.2-20.3,45.2-45.2c0-8.6-2.4-16.6-6.5-23.4l0,0L45.6,68.2L24.7,47.3"/></svg>';
p.appendChild(v);l.style.opacity="0";f.style.opacity="0";m.style.opacity="0";setTimeout(function(){v.style.opacity="1"},20);f.value=""}function g(){l.removeAttribute("disabled");f.removeAttribute("disabled");l.style.opacity="1";f.style.opacity="1";m.style.opacity="0"}var f=a.getElementById("branch-sms-phone"),l=a.getElementById("branch-sms-send"),m=a.getElementById("branch-loader-wrapper"),p=a.getElementById("branch-sms-form-container"),v;if(f){var B=f.value;/^\d{7,}$/.test(B.replace(/[\s()+\-\.]|ext/gi,
""))?(O(b,"willSendBannerSMS"),l.setAttribute("disabled",""),f.setAttribute("disabled",""),l.style.opacity=".4",f.style.opacity=".4",m.style.opacity="1",f.className="",b.sendSMS(B,d,c,function(a){a?(O(b,"sendBannerSMSError"),e()):(O(b,"didSendBannerSMS"),h(),setTimeout(function(){p.removeChild(v);g()},3E3))})):e()}}
function Ib(a,b,c,d){function e(a,c){"function"===typeof a&&(c=a,a={});a=a||{};"top"===b.position?g.style.top="-76px":"bottom"===b.position&&(g.style.bottom="-76px");"number"===typeof b.F?d.set("hideBanner",zb(b.F),!0):d.set("hideBanner",!0,!0);a.T?("top"===b.position?document.body.style.marginTop=m:"bottom"===b.position&&(document.body.style.marginBottom=v),yb("branch-banner-is-active"),N(g),N(document.getElementById("branch-css")),c()):(setTimeout(function(){N(g);N(document.getElementById("branch-css"));
c()},270),setTimeout(function(){"top"===b.position?document.body.style.marginTop=m:"bottom"===b.position&&(document.body.style.marginBottom=v);yb("branch-banner-is-active")},20))}function h(){"top"===b.position?g.style.top="0":"bottom"===b.position&&(g.style.bottom="0");O(a,"didShowBanner")}if(!Cb(d,b))return O(a,"willNotShowBanner"),null;O(a,"willShowBanner");var g=Gb(b,d);Eb(b,g);c.channel=c.channel||"app banner";var f=b.w?g.contentWindow.document:document;if(z()){b.open_app=b.ga;b.append_deeplink_path=
b.Z;b.make_new_link=b.da;b.deepview_type="banner";a.deepview(c,b);var l=f.getElementById("branch-mobile-action");l&&(l.onclick=function(b){b.preventDefault();a.deepviewCta()})}else f.getElementById("sms-form")?f.getElementById("sms-form").addEventListener("submit",function(d){d.preventDefault();Hb(f,a,b,c)}):g.onload=function(){f=g.contentWindow.document;f.getElementById("sms-form")&&f.getElementById("sms-form").addEventListener("submit",function(d){d.preventDefault();Hb(f,a,b,c)})};var l=Ab("margin-top"),
m=document.body.style.marginTop,p=Ab("margin-bottom"),v=document.body.style.marginBottom,B=f.getElementById("branch-banner-close");B&&(B.onclick=function(b){b.preventDefault();O(a,"willCloseBanner");e({},function(){O(a,"didCloseBanner")})});xb(document.body,"branch-banner-is-active");"top"===b.position?document.body.style.marginTop=Bb(l):"bottom"===b.position&&(document.body.style.marginBottom=Bb(p));b.T?h():setTimeout(h,20);return e};var Jb,P="top",Kb="absolute",Q="76px",R=!1,Lb=!1,S=[],Mb=window.innerHeight,Nb=window.innerWidth;window.innerHeight<window.innerWidth&&(Mb=window.innerWidth,Nb=window.innerHeight);
var Ob=0,Pb=0,Qb=/<script type="application\/json">((.|\s)*?)<\/script>/,Rb=/<script type="text\/javascript">((.|\s)*?)<\/script>/,Sb=/<style type="text\/css" id="branch-css">((.|\s)*?)<\/style>/,Tb=/#branch-banner-spacer {((.|\s)*?)}/,Ub=/margin-bottom: (.*?);/,Vb=/<script id="journeyLinkData" type="application\/json">((.|\s)*?)<\/script>/,T=null,Wb=null,Xb=!1,Yb=!1,Zb=!1,$b=!1,ac=!1,bc="",cc=[],U=null;function dc(a){if(a=a.match(Qb))return n(a[1])}
function ec(){var a=document.createElement("style");a.type="text/css";a.id="branch-iframe-css";Ob=Ab("margin-top");var b=+Ob.slice(0,-2);Pb=Ab("margin-bottom");var c=+Pb.slice(0,-2),d=+Q.slice(0,-2);"top"===P?document.body.style.marginTop=(+d+b).toString()+"px":"bottom"===P&&(document.body.style.marginBottom=(+d+c).toString()+"px");0<S.length&&S.forEach(function(a){var b,c=window.getComputedStyle(a);c&&(b=R&&"fixed"===c.getPropertyValue("position"));b||(a.style.marginTop=Q)});"top"===bc&&bc!==P&&
ac&&cc&&0<cc.length&&cc.forEach(function(a){a.style.marginTop=0});ac=!1;bc="";cc=[];$b=!1;a.innerHTML=fc();document.head.appendChild(a)}
function fc(){var a="",b="";document.body.style.transition="";document.getElementById("branch-banner-iframe")&&(document.getElementById("branch-banner-iframe").style.transition="");Zb||(a="body { -webkit-transition: all 0.375s ease; }\n",document.body.style.transition="all 00.375s ease",b="-webkit-transition: all 0.25s ease; transition: all 00.25s ease;");return(a?a:"")+("#branch-banner-iframe { box-shadow: 0 0 5px rgba(0, 0, 0, .35); width: 1px; min-width:100%; left: 0; right: 0; border: 0; height: "+
Q+"; z-index: 99999; "+b+" }\n#branch-banner-iframe { position: "+Kb+"; }\n@media only screen and (orientation: landscape) { body { "+("top"===P?"margin-top: ":"margin-bottom: ")+(R?Nb+"px":Q)+"; }\n#branch-banner-iframe { height: "+(R?Nb+"px":Q)+"; }")}function gc(a){xb(document.body,"branch-banner-is-active");R&&"fixed"===Kb&&xb(document.body,"branch-banner-no-scroll");setTimeout(function(){"top"===P?a.style.top="0":"bottom"===P&&(a.style.bottom="0");O(T,"didShowJourney",U);Xb=!0},20)}
function hc(a){var b=7;if(a=a.match(Qb))a=n(a[1])||{},"number"===typeof a.dismissPeriod&&(b=a.dismissPeriod);return-1===b?!0:zb(b)}
function ic(a,b,c,d,e){Wb=d;if(c&&d){var h=d.contentWindow.document;Array.prototype.forEach.call(h.querySelectorAll("#branch-mobile-action"),function(a){a.addEventListener("click",function(){O(T,"didClickJourneyCTA",U);$b=!0;c();jc(d)})});var g=h.querySelectorAll(".branch-banner-continue");Array.prototype.forEach.call(g,function(c){c.addEventListener("click",function(){O(T,"didClickJourneyContinue",U);$b=!0;jc(d);b.set("hideBanner"+a.id,e,!0)})});g=h.querySelectorAll(".branch-banner-close");Array.prototype.forEach.call(g,
function(c){c.addEventListener("click",function(){O(T,"didClickJourneyClose",U);$b=!0;jc(d);b.set("hideBanner"+a.id,e,!0)})})}}
function jc(a){if(Zb&&!Yb){document.body.style.transition="all 00.375s ease";document.getElementById("branch-banner-iframe").style.transition="all 00.25s ease";var b=document.getElementById("branch-iframe-css").innerHTML+"\n";document.getElementById("branch-iframe-css").innerHTML="";document.getElementById("branch-iframe-css").innerHTML=b+"body { -webkit-transition: all 0.375s ease; }\n#branch-banner-iframe { -webkit-transition: all 0.25s ease; }\n"}"top"===P?a.style.top="-"+Q:"bottom"===P&&(a.style.bottom=
"-"+Q);O(T,"willCloseJourney",U);setTimeout(function(){N(a);N(document.getElementById("branch-css"));N(document.getElementById("branch-iframe-css"));N(document.getElementById("branch-journey-cta"));(!Yb||$b)&&S&&0<S.length?S.forEach(function(a){a.style.marginTop=0}):(ac=Yb,bc=P,cc=S);"top"===P?document.body.style.marginTop=Ob:"bottom"===P&&(document.body.style.marginBottom=Pb);yb("branch-banner-is-active");yb("branch-banner-no-scroll");O(T,"didCloseJourney",U);Xb=!1},Yb?0:270)};var kc=1;
function lc(a,b){var c={banner_id:Jb},d=a.match(Vb);if(d){var e=d[1],d="";try{d=n(e)}catch(v){}if(d){var e=d.journey_link_data,h=["browser_fingerprint_id","app_id","source","open_app","link_click_id"];if(e&&"object"===typeof e&&!Array.isArray(e)&&0<Object.keys(e).length&&h&&Array.isArray(h)&&0<h.length)for(var g in e)e.hasOwnProperty(g)&&-1<h.indexOf(g)&&delete e[g];c=y(c,d)}}U=c;O(T,"willShowJourney",U);c=b?"OPEN":"GET";g=a;(d=dc(g))&&d.bannerHeight&&d.position&&d.sticky?(Q=d.bannerHeight,P=d.position,
Kb=d.sticky):(g=g.match(Tb))?(P="top",(g=g[1].match(Ub))&&(Q=g[1]),Kb="absolute"):(P="bottom",Kb="fixed");if(-1!==Q.indexOf("vh")||-1!==Q.indexOf("%"))g=Q.indexOf("vh")?Q.slice(0,-2):Q.slice(0,-1),Q=g/100*Mb+"px",100>g?Lb=!0:R=!0;if(g=dc(a)){var f;b&&g&&g.ctaText&&g.ctaText.has_app?f=g.ctaText.has_app:g&&g.ctaText&&g.ctaText.no_app&&(f=g.ctaText.no_app);c=f;S=[];if(g&&g.injectorSelector&&(f=document.querySelectorAll(g.injectorSelector)))for(g=0;g<f.length;g++)S.push(f[g].parentElement)}f=(f=a.match(Sb))?
f[1]:void 0;if(g=a.match(Rb))g=g[1],d=document.createElement("script"),d.id="branch-journey-cta",d.innerHTML=g,document.body.appendChild(d);g=a;var d=g.match(Qb),e=g.match(Rb),h=g.match(Sb),l=g.match(Vb);d&&(g=g.replace(Qb,""));e&&(g=g.replace(Rb,""));h&&(g=g.replace(Sb,""));l&&(g=g.replace(Vb,""));a=g;g=document.createElement("iframe");g.src="about:blank";g.style.overflow="hidden";g.scrolling="no";g.id="branch-banner-iframe";g.className="branch-animation";document.body.appendChild(g);d=z();d='<html><head></head><body class="'+
("ios"===d||"ipad"===d?"branch-banner-ios":"android"===d?"branch-banner-android":"branch-banner-desktop")+'">'+a+"</body></html>";g.contentWindow.document.open();g.contentWindow.document.write(d);g.contentWindow.document.close();ec();d=document.createElement("style");d.type="text/css";d.id="branch-css";d.innerHTML=f;f=g.contentWindow.document;f.head.appendChild(d);if(Lb||R){var m=f.getElementsByClassName("branch-banner-content")[0];m&&(m.style.height=Q)}"top"===P?g.style.top="-"+Q:"bottom"===P&&(g.style.bottom=
"-"+Q);try{var m=f.getElementsByClassName("branch-banner-content")[0],p=window.getComputedStyle(m).getPropertyValue("background-color").split(", ");p[3]&&!parseFloat(p[3])&&(g.style.boxShadow="none")}catch(v){}g.contentWindow.document.getElementById("branch-mobile-action").innerHTML=c;gc(g);return g}
function mc(a,b,c,d,e,h,g){if(!(document.getElementById("branch-banner")||document.getElementById("branch-banner-iframe")||document.getElementById("branch-banner-container"))){T=g;var f=null,l=null;c=c||{};c.feature="journeys";c=sa(c);(g=document.getElementById("branch-iframe-css"))&&g.parentElement.removeChild(g);var m=document.createElement("div");m.id="branch-banner";document.body.insertBefore(m,null);xb(m,"branch-banner-is-active");if(b.html)lc(b.html,e);else if(b.url){var p="branch_view_callback__"+
kc++;c=encodeURIComponent(za(k(c)));g=b.url+"&callback="+p;g+="&_lan="+(T.ma||Ca()||"en");vb(a,g+("&data="+c),{},"GET",{},function(a,c){var g=!1;if(!a&&c){var kb=h?0:hc(c),zc=window.setTimeout(function(){window[p]=function(){}},r);window[p]=function(a){window.clearTimeout(zc);g||(l=a,ic(b,d,l,f,kb))};f=lc(c,e);if(null===f){g=!0;return}ic(b,d,l,f,kb)}document.body.removeChild(m)},!0)}}}
function nc(a,b){var c=b.b.get("hideBanner"+a.id,!0);if(!0===c||c>Date.now())return!0;b.b.remove("hideBanner"+a.id,!0);return!1}
function oc(a,b,c,d,e){e.m=!!c.branch_view_enabled;e.b.set("branch_view_enabled",e.m);var h=null,g=null,f=null,l=null,m=null,p=!1,v=!1,B=!1;d&&(h=d.branch_view_id||null,g=d.no_journeys||null,e.ma=(d.user_language||Ca()||"en").toLowerCase(),Zb=d.disable_entry_animation||!1,Yb=d.disable_exit_animation||!1,v=d.make_new_link||!1,B=d.open_app||!1);(h=h||ra()||null)&&z()&&(p=!0,l={id:h,ua:-1,url:"https://api.branch.io/v1/branchview/"+a+"/"+h+"?_a=audience_rule_id&_t="+b.browser_fingerprint_id});!l&&c.hasOwnProperty("branch_view_data")&&
(l=c.branch_view_data,f=nc(l,e));!l||f||g?O(e,"willNotShowJourney"):(Jb=l.id,e.renderQueue(function(){var a=v,c=B,d=e.A||{};d.data||(d.data={});var a=a?null:ta(V(e)),f=M(e.b)||{},g=f.hasOwnProperty("has_app")?f.has_app:!1;d.data=y(C(),d.data);d.data=y(qa(f||{}),d.data);d.data=a?y({link_click_id:a},d.data):d.data;d=y({open_app:c},d);d=y({has_app_websdk:g},d);m=d=w()?y({is_iframe:!0},d):d;mc(e.O,l,m,e.b,b.has_app,p,e)}))};var W={androidAppIndexingTagsPresent:!1,iosAppIndexingTagsPresent:!1,androidDetailsComplete:!1,iosDetailsComplete:!1},X={};function pc(a){var b;"android"===a&&W.androidDetailsComplete&&(b="android-app://"+X.androidPackageName+"/"+X.androidURL,b=qc(b),rc(b));"ios"===a&&W.iosDetailsComplete&&(b="ios-app://"+X.iosAppId+"/"+X.iosURL,b=qc(b),rc(b))}
function qc(a){var b={"~channel":"Firebase App Indexing","~feature":"Auto App Indexing",$canonical_url:u()};if("object"===typeof X.data)for(var c in X.data)X.data.hasOwnProperty(c)&&!b.hasOwnProperty(c)&&(b[c]=X.data[c]);return a+(-1<a.indexOf("?")?"&":"?")+"link_click_id=a-"+btoa(q(b))}function rc(a){var b=document.createElement("link");b.setAttribute("rel","alternate");b.setAttribute("href",a);document.head.appendChild(b)}
function sc(a){"android"===a&&"string"===typeof X.androidPackageName&&"string"===typeof X.androidURL&&(W.androidDetailsComplete=!0,pc("android"));"ios"===a&&"string"===typeof X.iosAppId&&"string"===typeof X.iosURL&&(W.iosDetailsComplete=!0,pc("ios"))}
function tc(a){for(var b=document.getElementsByTagName("meta"),c=0;c<b.length;c++){var d=b[c];"ios"===a&&"al:ios:app_store_id"===d.getAttribute("property")&&(X.iosAppId=d.getAttribute("content"));"ios"===a&&"al:ios:url"===d.getAttribute("property")&&(X.iosURL=d.getAttribute("content").replace("://","/"));"android"===a&&"al:android:package"===d.getAttribute("property")&&(X.androidPackageName=d.getAttribute("content"));"android"===a&&"al:android:url"===d.getAttribute("property")&&(X.androidURL=d.getAttribute("content").replace("://",
"/"))}sc(a)};var uc;
function Y(a,b,c){return function(){var d=this,e,h,g=arguments[arguments.length-1];a&&"function"===typeof g?(e=Array.prototype.slice.call(arguments,0,arguments.length-1)||[],h=g):(h=function(){},e=Array.prototype.slice.call(arguments));d.X(function(f){function g(b,c){try{if(b&&!a)throw b;1===a?h(b):2===a&&h(b,c)}finally{f()}}if(!c){if(1===d.j)return g(Error(t("Branch SDK initialization pending and a Branch method was called outside of the queue order")),null);if(2===d.j)return g(Error(t("Branch SDK initialization failed, so further methods cannot be called",d.h,
d.l)),null);if(0===d.j||!d.j)return g(Error(t("Branch SDK not initialized")),null)}e.unshift(g);b.apply(d,e)})}}function Z(){if(!(this instanceof Z))return uc||(uc=new Z),uc;this.X=ma();this.b=new hb(["session","cookie","pojo"]);this.O=new qb;this.g=[];this.R="web2.31.0";this.h=this.j=0;this.l=null}
Z.prototype.c=function(a,b,c){this.P&&(b.app_id=this.P);this.i&&(b.branch_key=this.i);(a.a&&a.a.session_id||a.f&&a.f.session_id)&&this.I&&(b.session_id=this.I);(a.a&&a.a.identity_id||a.f&&a.f.identity_id)&&this.v&&(b.identity_id=this.v);(a.a&&a.a.link_click_id||a.f&&a.f.link_click_id)&&this.V&&(b.link_click_id=this.V);(a.a&&a.a.sdk||a.f&&a.f.sdk)&&this.R&&(b.sdk=this.R);(a.a&&a.a.browser_fingerprint_id||a.f&&a.f.browser_fingerprint_id)&&this.D&&(b.browser_fingerprint_id=this.D);return wb(this.O,a,
b,this.b,function(a,b){c(a,b)})};function V(a){var b=M(a.b);return(b=b&&b.referring_link)?b:(a=a.b.get("click_id"))?"https://bnc.lt/c/"+a:null}function O(a,b,c){for(var d=0;d<a.g.length;d++)a.g[d].event&&a.g[d].event!==b||a.g[d].listener(b,c)}
Z.prototype.init=Y(2,function(a,b,c){function d(){var a,b;"undefined"!==typeof document.hidden?(a="hidden",b="visibilitychange"):"undefined"!==typeof document.mozHidden?(a="mozHidden",b="mozvisibilitychange"):"undefined"!==typeof document.msHidden?(a="msHidden",b="msvisibilitychange"):"undefined"!==typeof document.webkitHidden&&(a="webkitHidden",b="webkitvisibilitychange");b&&document.addEventListener(b,function(){document[a]||(h(null),"function"===typeof f.C&&f.C())},!1)}function e(d,e){e&&(e=g(e),
ob(f.b,e,v),f.j=3,e.data_parsed=e.data&&0!==e.data.length?n(e.data):{});if(d)return f.j=2,f.h||(f.h=1,f.l=d.message),a(d,e&&pa(e));var h=Ha(),l=G(c.metadata,"object")?c.metadata:null;l&&(l=Na(h.hosted_deeplink_data,l))&&0<Object.keys(l).length&&(h.hosted_deeplink_data=l);f.c(db,{event:"pageview",metadata:y({url:m,user_agent:navigator.userAgent,language:navigator.language,screen_width:screen.width||-1,screen_height:screen.height||-1},h||{}),initial_referrer:H(V(f))},function(d,g){d||"object"!==typeof g||
oc(b,e,g,c,f);try{a(d,e&&pa(e))}catch(Bc){}finally{f.renderFinalize()}})}function h(a){var b={sdk:"2.31.0",branch_key:f.i},c=M(f.b)||{},d=M(f.b,!0)||{};d.browser_fingerprint_id&&(b._t=d.browser_fingerprint_id);wa()||f.c(Pa,b,function(a,b){a&&(f.h=3,f.l=a.message);b&&(c.browser_fingerprint_id=b)});f.c(cb,{browser_fingerprint_id:c.browser_fingerprint_id},function(b,d){b&&(f.h=4,f.l=b.message);b||!d||c.has_app||(c.has_app=!0,pb(f.b,c),O(f,"didDownloadApp"));a&&a(null,c)})}function g(a){a.link_click_id&&
(f.V=a.link_click_id.toString());a.session_id&&(f.I=a.session_id.toString());a.identity_id&&(f.v=a.identity_id.toString());a.link&&(f.W=a.link);if(a.referring_link){var b=a.referring_link;a.referring_link=b?"http"!==b.substring(0,4)?"https://bnc.lt"+b:b:null}!a.click_id&&a.referring_link&&(a.click_id=ta(a.referring_link));f.D=a.browser_fingerprint_id;return a}var f=this;f.j=1;-1<b.indexOf("key_")?f.i=b:f.P=b;na=(c=c&&G(c,"object")?c:{})&&c.retries&&Number.isInteger(c.retries)?c.retries:na;oa=c&&c.retry_delay&&
Number.isInteger(c.retry_delay)?c.retry_delay:oa;r=c&&c.timeout&&Number.isInteger(c.timeout)?c.timeout:r;var l=M(f.b),m=c&&c.url||u(),p=(c&&"undefined"!==typeof c.branch_match_id&&null!==c.branch_match_id?c.branch_match_id:null)||xa()||ua(),v=!l||!l.identity_id;f.m=!!f.b.get("branch_view_enabled");if(l&&l.session_id&&!p)pb(f.b,{data:""}),pb(f.b,{referring_link:""}),d(),h(e);else{var l={sdk:"2.31.0",branch_key:f.i},B=M(f.b,!0)||{};B.browser_fingerprint_id&&(l._t=B.browser_fingerprint_id);wa()?f.c(Oa,
{link_identifier:p,browser_fingerprint_id:p||B.browser_fingerprint_id,alternative_browser_fingerprint_id:B.browser_fingerprint_id,options:c,initial_referrer:H(V(f))},function(a,b){a&&(f.h=2,f.l=a.message);a||"object"!==typeof b||(f.m=!!b.branch_view_enabled,f.b.set("branch_view_enabled",f.m),p&&(b.click_id=p));d();e(a,b)}):f.c(Pa,l,function(a,b){if(a)return f.h=3,f.l=a.message,e(a,null);f.c(Oa,{link_identifier:p,browser_fingerprint_id:p||b,alternative_browser_fingerprint_id:B.browser_fingerprint_id,
options:c,initial_referrer:H(V(f))},function(a,b){a&&(f.h=2,f.l=a.message);a||"object"!==typeof b||(f.m=!!b.branch_view_enabled,f.b.set("branch_view_enabled",f.m),p&&(b.click_id=p));d();e(a,b)})})}},!0);Z.prototype.renderQueue=Y(0,function(a,b){this.Y?b():(this.o=this.o||[],this.o.push(b));a(null,null)});Z.prototype.renderFinalize=Y(2,function(a){this.o&&0<this.o.length&&(this.o.forEach(function(a){a.call(this)}),delete this.o);this.Y=!0;a(null,null)});
Z.prototype.data=Y(2,function(a){var b=pa(M(this.b));b.referring_link=V(this);b.data_parsed=b.data&&0!==b.data.length?n(b.data):{};a(null,b)});Z.prototype.first=Y(2,function(a){a(null,pa(M(this.b,!0)))});Z.prototype.setIdentity=Y(2,function(a,b){var c=this;this.c(Wa,{identity:b},function(d,e){d&&a(d);e=e||{};c.v=e.identity_id?e.identity_id.toString():null;c.W=e.link;c.G=b;e.referring_data_parsed=e.referring_data?n(e.referring_data):null;pb(c.b,e);a(null,e)})});
Z.prototype.logout=Y(1,function(a){var b=this;this.c(Va,{},function(c,d){c&&a(c);d=d||{};d={data_parsed:null,data:null,referring_link:null,click_id:null,link_click_id:null,identity:null,session_id:d.session_id,identity_id:d.identity_id,link:d.link,device_fingerprint_id:b.ta||null};b.W=d.link;b.I=d.session_id;b.v=d.identity_id;b.G=d.identity;pb(b.b,d);a(null)})});
Z.prototype.track=Y(1,function(a,b,c,d){var e=this;c=c||{};d=d||{};if("pageview"===b){var h=Na(C(),c);h&&0<Object.keys(h).length&&(c.hosted_deeplink_data=h)}e.c(db,{event:b,metadata:y({url:u(),user_agent:navigator.userAgent,language:navigator.language},c),initial_referrer:H(V(e))},function(c,f){c||"object"!==typeof f||"pageview"!==b||oc(e.i,M(e.b),f,d,e);"function"===typeof a&&a.apply(this,arguments)})});
Z.prototype.logEvent=Y(1,function(a,b,c,d){b=G(b,"string")?b:null;c=G(c,"object")?c:null;-1<Ia.indexOf(b)?(d=G(d,"array")?d:null,c=Ka(c),this.c(fb,{name:b,user_data:q(Ma(this)),custom_data:q(c&&c.custom_data||{}),event_data:q(c&&c.event_data||{}),content_items:q(d||[])},function(b){return a(b||null)})):this.c(gb,{name:b,user_data:q(Ma(this)),custom_data:q(La(c)||{})},function(b){return a(b||null)})});Z.prototype.link=Y(2,function(a,b){this.c(ab,sa(b),function(b,d){a(b,d&&d.url)})});
Z.prototype.sendSMS=Y(1,function(a,b,c,d){function e(c){h.c(Ra,{link_url:c,phone:b},function(b){a(b||null)})}var h=this;if("function"===typeof d)d={};else if("undefined"===typeof d||null===d)d={};d.make_new_link=d.make_new_link||!1;c.channel&&"app banner"!==c.channel||(c.channel="sms");var g=V(h);g&&!d.make_new_link?e(ta(g)):h.c(ab,sa(c),function(b,c){if(b)return a(b);var d=c.url;/(bnc.lt\/|app\.link\/)/.test(d)||(d="https://bnc.lt/"+Ba(d));h.c(Qa,{link_url:d,click:"click"},function(b,c){if(b)return a(b);
e(c.click_id)})})});
Z.prototype.deepview=Y(1,function(a,b,c){var d=this;c||(c={});c.deepview_type="undefined"===typeof c.deepview_type?"deepview":"banner";b.data=y(C(),b.data);b=w()?y({is_iframe:!0},b):b;var e="https://bnc.lt/a/"+d.i,h=!0,g;for(g in b)b.hasOwnProperty(g)&&"data"!==g&&(h?(e+="?",h=!1):e+="&",e+=encodeURIComponent(g)+"="+encodeURIComponent(b[g]));b=sa(b);if(c.open_app||null===c.open_app||"undefined"===typeof c.open_app)b.open_app=!0;b.append_deeplink_path=!!c.append_deeplink_path;b.deepview_type=c.deepview_type;
(h=V(d))&&!c.make_new_link&&(b.link_click_id=ta(h));b.banner_options=c;d.C=ga(this.c,d,bb,b,function(b,c){if(b)return d.B=function(){window.top.location=e},a(b);"function"===typeof c&&(d.B=c);a(null)});d.C()});Z.prototype.deepviewCta=Y(1,function(a){if("undefined"===typeof this.B)throw Error("Cannot call Deepview CTA, please call branch.deepview() first.");window.event&&(window.event.preventDefault?window.event.preventDefault():window.event.returnValue=!1);O(this,"didDeepviewCTA");this.B();a()});
Z.prototype.referrals=Y(2,function(a){this.c(Xa,{},a)});Z.prototype.getCode=Y(2,function(a,b){b.type="credit";b.creation_source=b.creation_source||2;this.c(Sa,b,a)});Z.prototype.validateCode=Y(1,function(a,b){this.c(Ta,{code:b},a)});Z.prototype.applyCode=Y(1,function(a,b){this.c(Ua,{code:b},a)});Z.prototype.credits=Y(2,function(a){this.c(Za,{branch_key:this.i,identity:this.G},a)});Z.prototype.creditHistory=Y(2,function(a,b){this.c(Ya,b||{},a)});
Z.prototype.redeem=Y(1,function(a,b,c){this.c($a,{amount:b,bucket:c},function(b){a(b||null)})});Z.prototype.addListener=function(a,b){"function"===typeof a&&void 0===b&&(b=a,a=null);b&&this.g.push({listener:b,event:a||null})};Z.prototype.removeListener=function(a){a&&(this.g=this.g.filter(function(b){if(b.listener!==a)return b}))};function vc(a,b,c){c=c||{};try{a.A=n(q(c))}finally{a.A=a.A||{}}b()}Z.prototype.setBranchViewData=Y(1,function(a,b){vc.call(null,this,a,b)});
Z.prototype.closeJourney=Y(1,function(a){var b=this;b.renderQueue(function(){if(Wb&&Xb)O(b,"didCallJourneyClose",U),jc(Wb);else return a("Journey already dismissed.")});a()});
Z.prototype.banner=Y(1,function(a,b,c){c=c||{};vc.call(null,this,function(){},c);"undefined"===typeof b.showAgain&&"undefined"!==typeof b.forgetHide&&(b.showAgain=b.forgetHide);var d={icon:E(b.icon)||"",title:E(b.title)||"",description:E(b.description)||"",H:"number"===typeof b.reviewCount&&0<b.reviewCount?Math.floor(b.reviewCount):null,u:"number"===typeof b.rating&&5>=b.rating&&0<b.rating?Math.round(2*b.rating)/2:null,fa:E(b.openAppButtonText)||"View in app",ca:E(b.downloadAppButtonText)||"Download App",
ja:E(b.sendLinkText)||"Send Link",ha:E(b.phonePreviewText)||"(999) 999-9999",w:"undefined"===typeof b.iframe?!0:b.iframe,N:"undefined"===typeof b.showiOS?!0:b.showiOS,la:"undefined"===typeof b.showiPad?!0:b.showiPad,J:"undefined"===typeof b.showAndroid?!0:b.showAndroid,K:"undefined"===typeof b.showBlackberry?!0:b.showBlackberry,M:"undefined"===typeof b.showWindowsPhone?!0:b.showWindowsPhone,L:"undefined"===typeof b.showKindle?!0:b.showKindle,ka:"undefined"===typeof b.showDesktop?!0:b.showDesktop,
ba:!!b.disableHide,F:"number"===typeof b.forgetHide?b.forgetHide:!!b.forgetHide,ia:"undefined"===typeof b.respectDNT?!1:b.respectDNT,position:b.position||"top",$:b.customCSS||"",ea:"undefined"===typeof b.mobileSticky?!1:b.mobileSticky,aa:"undefined"===typeof b.desktopSticky?!0:b.desktopSticky,pa:b.buttonBorderColor||"",na:b.buttonBackgroundColor||"",ra:b.buttonFontColor||"",qa:b.buttonBorderColorHover||"",oa:b.buttonBackgroundColorHover||"",sa:b.buttonFontColorHover||"",da:!!b.make_new_link,ga:!!b.open_app,
T:!!b.immediate,Z:!!b.append_deeplink_path};"undefined"!==typeof b.showMobile&&(d.N=b.showMobile,d.J=b.showMobile,d.K=b.showMobile,d.M=b.showMobile,d.L=b.showMobile);c.data=y(C(),c.data);var e=this;e.renderQueue(function(){e.S=Ib(e,d,c,e.b)});a()});Z.prototype.closeBanner=Y(0,function(a){var b=this;b.renderQueue(function(){b.S&&(O(b,"willCloseBanner"),b.S(function(){O(b,"didCloseBanner")}))});a()});
Z.prototype.autoAppIndex=Y(1,function(a,b){b=b||{};var c=document.getElementsByTagName("link"),d=c.length;if(d)for(var e=0;e<d;e++){var h=c[e],g=h.href;g&&(g.includes("ios-app")&&(W.iosAppIndexingTagsPresent=!0,h.setAttribute("href",qc(g))),g.includes("android-app")&&(W.androidAppIndexingTagsPresent=!0,h.setAttribute("href",qc(g))))}X=b;W.androidAppIndexingTagsPresent||(sc("android"),W.androidDetailsComplete||tc("android"));W.iosAppIndexingTagsPresent||(sc("ios"),W.iosDetailsComplete||tc("ios"));
W.iosDetailsComplete||W.androidDetailsComplete?a(null):a("Firebase App Indexing tags were not added to your webpage. Please check your configuration.")});Z.prototype.trackCommerceEvent=Y(1,function(a,b,c,d){var e=this;e.renderQueue(function(){var h=Ga(b,c);if(h)return a(Error(h));e.c(eb,{event:b,metadata:y({url:document.URL,user_agent:navigator.userAgent,language:navigator.language},d||{}),initial_referrer:H(V(e)),commerce_data:c},function(b){a(b||null)})});a()});var wc=new Z;if(window.branch&&window.branch._q)for(var xc=window.branch._q,yc=0;yc<xc.length;yc++){var Ac=xc[yc];wc[Ac[0]].apply(wc,Ac[1])} true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return wc}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof exports&&(module.exports=wc);window&&(window.branch=wc);})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = __webpack_require__(100);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(9);

var _extends4 = _interopRequireDefault(_extends3);

var _extends2;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(416);

var _reactIntl = __webpack_require__(192);

var _glamor = __webpack_require__(415);

var _typography = __webpack_require__(1042);

var _AppStore = __webpack_require__(1205);

var _AppStore2 = _interopRequireDefault(_AppStore);

var _PlayStore = __webpack_require__(1206);

var _PlayStore2 = _interopRequireDefault(_PlayStore);

var _tagline_web_mobile_en = __webpack_require__(441);

var _tagline_web_mobile_en2 = _interopRequireDefault(_tagline_web_mobile_en);

var _tagline_web_mobile_it = __webpack_require__(442);

var _tagline_web_mobile_it2 = _interopRequireDefault(_tagline_web_mobile_it);

var _tagline_web_desktop_en = __webpack_require__(443);

var _tagline_web_desktop_en2 = _interopRequireDefault(_tagline_web_desktop_en);

var _tagline_web_desktop_it = __webpack_require__(444);

var _tagline_web_desktop_it2 = _interopRequireDefault(_tagline_web_desktop_it);

var _iphone2x = __webpack_require__(440);

var _iphone2x2 = _interopRequireDefault(_iphone2x);

var _android2x = __webpack_require__(439);

var _android2x2 = _interopRequireDefault(_android2x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itunesStoreLink = 'https://itunes.apple.com/gb/app/depop/id518684914?mt=8';
var playStoreLink = 'https://play.google.com/store/apps/details?id=com.depop&hl=en_GB';

var hide = { display: 'none' };
// const mediaDesktop = '@media (min-width: 701px)';
// const mediaMobile = '@media (max-width: 700px)';

// const yellow = { backgroundColor: 'yellow' };
// const purple = { backgroundColor: 'rebeccapurple' };

var mobileHidden = { '@media (max-width: 700px)': hide };
var desktopHidden = { '@media (min-width: 701px)': hide };
var wrapperStyle = (0, _glamor.css)({
  textAlign: 'center',
  marginBottom: '20px',
  '@media (min-width: 701px)': {
    display: 'flex'
  } });
var storeButtonStyle = (0, _glamor.css)({ display: 'inline-block', '&+&': { marginLeft: '15px' } });
var taglineMobileStyle = (0, _glamor.css)((0, _extends4.default)({ padding: '45px 20px' }, desktopHidden));
var taglineDesktopStyle = (0, _glamor.css)({ flexBasis: '75%' });
var leftSideDesktopStyle = (0, _glamor.css)((0, _extends4.default)({}, mobileHidden, (_extends2 = {
  flexBasis: '60%',
  paddingTop: '85px'
}, (0, _defineProperty3.default)(_extends2, 'paddingTop', '5vw'), (0, _defineProperty3.default)(_extends2, 'display', 'flex'), (0, _defineProperty3.default)(_extends2, 'flexDirection', 'column'), (0, _defineProperty3.default)(_extends2, 'textAlign', 'left'), (0, _defineProperty3.default)(_extends2, '@media (max-width: 1024px)', (0, _defineProperty3.default)({
  paddingTop: '65px'
}, 'paddingTop', '6.7vw')), _extends2)));
var buttonMobileStyle = (0, _glamor.css)((0, _extends4.default)({ marginBottom: '60px' }, desktopHidden));
var deviceWrapStyle = (0, _glamor.css)({ flexBasis: '40%', padding: '0px 6%' });
var imageStyle = (0, _glamor.css)({ maxWidth: '100%', width: '100%' });
var promoTextStyle = (0, _glamor.css)({
  padding: '30px 0',
  fontFamily: _typography.FAMILY_EXTENDED,
  fontSize: '16px',
  // fontSize: '1.25vw',
  color: '#262626',
  '@media (max-width: 1024px)': (0, _defineProperty3.default)({
    fontSize: '14px'
  }, 'fontSize', '1.6vw')
});

var messages = (0, _reactIntl.defineMessages)({
  lang: {
    'id': 'Language.ShortCode',
    'defaultMessage': 'en'
  },
  tagline: {
    'id': 'Landing.taglineText',
    'defaultMessage': 'Find something that means something'
  }
});

var getTaglines = function getTaglines(language) {
  switch (language) {
    case 'it':
      return {
        taglineMobileSrc: _tagline_web_mobile_it2.default,
        taglineDesktopSrc: _tagline_web_desktop_it2.default
      };
    case 'en':
    default:
      return {
        taglineMobileSrc: _tagline_web_mobile_en2.default,
        taglineDesktopSrc: _tagline_web_desktop_en2.default
      };
  }
};

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'Landing.promoText',
  defaultMessage: 'Buy, sell, and explore the most unique and inspiring things in the world.'
});

var _ref3 = (0, _jsx3.default)(_AppStore2.default, {});

var _ref4 = (0, _jsx3.default)(_PlayStore2.default, {});

var _ref5 = (0, _jsx3.default)(_AppStore2.default, {});

var _ref6 = (0, _jsx3.default)(_PlayStore2.default, {});

var HomeHeader = function () {
  function HomeHeader(props) {
    var overlays = props.overlays,
        userAgent = props.userAgent,
        intl = props.intl,
        action = props.action;

    var isiOS = userAgent.isiPad || userAgent.isiPhone || userAgent.isiPod;
    var isAndroid = userAgent.isAndroid;
    var isMobile = userAgent.isMobile;
    var phoneImageSrc = isAndroid ? _android2x2.default : _iphone2x2.default;
    var storeLink = isAndroid ? playStoreLink : itunesStoreLink;
    var channel = 'landingpage_' + (isMobile ? 'mobile' : 'desktop') + '_' + (isAndroid ? 'google' : 'apple') + '_b';

    var _ref = overlays.deeplink || { link: '' },
        link = _ref.link;

    var href = link ? link + '?channel=' + channel : storeLink;

    var _getTaglines = getTaglines(intl.formatMessage(messages.lang)),
        taglineMobileSrc = _getTaglines.taglineMobileSrc,
        taglineDesktopSrc = _getTaglines.taglineDesktopSrc;

    var onAppleClick = function onAppleClick() {
      return action('app store');
    };
    var onGoogleClick = function onGoogleClick() {
      return action('play store');
    };

    return (0, _jsx3.default)('div', {}, void 0, _react2.default.createElement(
      'div',
      wrapperStyle,
      _react2.default.createElement(
        'div',
        taglineMobileStyle,
        _react2.default.createElement('img', (0, _extends4.default)({}, imageStyle, { src: taglineMobileSrc, alt: intl.formatMessage(messages.tagline) }))
      ),
      _react2.default.createElement(
        'div',
        leftSideDesktopStyle,
        _react2.default.createElement(
          'div',
          taglineDesktopStyle,
          _react2.default.createElement('img', (0, _extends4.default)({}, imageStyle, { src: taglineDesktopSrc, alt: intl.formatMessage(messages.tagline) })),
          _react2.default.createElement(
            'div',
            promoTextStyle,
            _ref2
          )
        ),
        (0, _jsx3.default)('div', {}, void 0, _react2.default.createElement(
          'a',
          (0, _extends4.default)({}, storeButtonStyle, { onClick: onAppleClick, rel: 'noopener', href: itunesStoreLink }),
          _ref3
        ), _react2.default.createElement(
          'a',
          (0, _extends4.default)({}, storeButtonStyle, { onClick: onGoogleClick, rel: 'noopener', href: playStoreLink }),
          _ref4
        ))
      ),
      _react2.default.createElement(
        'div',
        buttonMobileStyle,
        isiOS ? _react2.default.createElement(
          'a',
          (0, _extends4.default)({}, storeButtonStyle, { onClick: onAppleClick, rel: 'noopener', href: href }),
          _ref5
        ) : '',
        isAndroid ? _react2.default.createElement(
          'a',
          (0, _extends4.default)({}, storeButtonStyle, { onClick: onGoogleClick, rel: 'noopener', href: href }),
          _ref6
        ) : ''
      ),
      _react2.default.createElement(
        'div',
        deviceWrapStyle,
        _react2.default.createElement('img', (0, _extends4.default)({}, imageStyle, { src: phoneImageSrc, alt: 'Depop app screen' }))
      )
    ));
  }

  return HomeHeader;
}();

var mapStateToProps = function mapStateToProps(_ref7) {
  var userAgent = _ref7.userAgent,
      overlays = _ref7.overlays;
  return {
    userAgent: userAgent,
    overlays: overlays
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactIntl.injectIntl)(HomeHeader));

/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactRedux = __webpack_require__(416);

var _navigation = __webpack_require__(424);

var _Footer = __webpack_require__(1287);

var _Footer2 = _interopRequireDefault(_Footer);

var _Header = __webpack_require__(1289);

var _Header2 = _interopRequireDefault(_Header);

var _DesktopOnly = __webpack_require__(1217);

var _DesktopOnly2 = _interopRequireDefault(_DesktopOnly);

var _LazyModal = __webpack_require__(1160);

var _LazyModal2 = _interopRequireDefault(_LazyModal);

var _Fixit = __webpack_require__(1297);

var _Fixit2 = _interopRequireDefault(_Fixit);

var _recompose = __webpack_require__(1044);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_DesktopOnly2.default, {}, void 0, (0, _jsx3.default)(_Footer2.default, {}));

var AppNavigation = function (_React$Component) {
  (0, _inherits3.default)(AppNavigation, _React$Component);

  function AppNavigation() {
    (0, _classCallCheck3.default)(this, AppNavigation);
    return (0, _possibleConstructorReturn3.default)(this, (AppNavigation.__proto__ || (0, _getPrototypeOf2.default)(AppNavigation)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppNavigation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewer = _props.viewer,
          hideHeader = _props.hideHeader,
          hideFooter = _props.hideFooter,
          closeLogin = _props.closeLogin,
          closeDownload = _props.closeDownload,
          _props$navigation = _props.navigation,
          isLoginOpen = _props$navigation.isLoginOpen,
          isDownloadOpen = _props$navigation.isDownloadOpen;


      return (0, _jsx3.default)('div', {}, void 0, !hideHeader ? (0, _jsx3.default)(_Fixit2.default, {}, void 0, function (isFixed) {
        return (0, _jsx3.default)(_Header2.default, {
          isFixed: isFixed,
          viewer: viewer
        });
      }) : null, (0, _jsx3.default)(_LazyModal2.default, {
        isOpened: isLoginOpen,
        onClose: closeLogin,
        load: function load() {
          return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1222)).then(function (module) {
            return module.default;
          });
        },
        render: function render(Login) {
          return (0, _jsx3.default)(Login, {
            closeModal: closeLogin
          });
        }
      }), (0, _jsx3.default)(_LazyModal2.default, {
        isOpened: isDownloadOpen,
        onClose: closeDownload,
        load: function load() {
          return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1303)).then(function (module) {
            return module.default;
          });
        },
        render: function render(DownloadModal) {
          return (0, _jsx3.default)(DownloadModal, {
            onClose: closeDownload
          });
        }
      }), !hideFooter && _ref);
    }
  }]);
  return AppNavigation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var userAgent = _ref2.userAgent,
      overlays = _ref2.overlays,
      navigation = _ref2.navigation;
  return {
    userAgent: userAgent,
    overlays: overlays,
    navigation: navigation
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeLogin: function closeLogin() {
      return dispatch((0, _navigation.closeLogin)());
    },
    closeDownload: function closeDownload() {
      return dispatch((0, _navigation.closeDownload)());
    }
  };
};

var connectedView = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AppNavigation);

exports.default = _reactRelay2.default.createContainer((0, _recompose.pure)(connectedView), {
  fragments: {
    viewer: function viewer() {
      return function (RQL_0) {
        return {
          children: [].concat.apply([], [{
            children: [{
              fieldName: 'publicId',
              kind: 'Field',
              metadata: {},
              type: 'Int'
            }, {
              fieldName: 'username',
              kind: 'Field',
              metadata: {},
              type: 'String'
            }, {
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }],
            fieldName: 'currentUser',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'User'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'AppNavigation_ViewerRelayQL',
          type: 'Viewer'
        };
      }(_Header2.default.getFragment('viewer'));
    }
  }
});

/***/ }),

/***/ 1287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

var _zIndex = __webpack_require__(1067);

var _FillHorizontal = __webpack_require__(1145);

var _FillHorizontal2 = _interopRequireDefault(_FillHorizontal);

var _FooterMenuItem = __webpack_require__(1288);

var _FooterMenuItem2 = _interopRequireDefault(_FooterMenuItem);

var _LocaleSwitcher = __webpack_require__(1216);

var _LocaleSwitcher2 = _interopRequireDefault(_LocaleSwitcher);

var _Container = __webpack_require__(1129);

var _Container2 = _interopRequireDefault(_Container);

var _AboutLink = __webpack_require__(1201);

var _AboutLink2 = _interopRequireDefault(_AboutLink);

var _JobsLink = __webpack_require__(1207);

var _JobsLink2 = _interopRequireDefault(_JobsLink);

var _EventsLink = __webpack_require__(1208);

var _EventsLink2 = _interopRequireDefault(_EventsLink);

var _PressLink = __webpack_require__(1209);

var _PressLink2 = _interopRequireDefault(_PressLink);

var _SpacesLink = __webpack_require__(1210);

var _SpacesLink2 = _interopRequireDefault(_SpacesLink);

var _SupportLink = __webpack_require__(1211);

var _SupportLink2 = _interopRequireDefault(_SupportLink);

var _InstagramLink = __webpack_require__(1212);

var _InstagramLink2 = _interopRequireDefault(_InstagramLink);

var _TwitterLink = __webpack_require__(1213);

var _TwitterLink2 = _interopRequireDefault(_TwitterLink);

var _FacebookLink = __webpack_require__(1214);

var _FacebookLink2 = _interopRequireDefault(_FacebookLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_Container2.default, {
  condensed: true
}, void 0, (0, _jsx3.default)(_FillHorizontal2.default, {}, void 0, (0, _jsx3.default)(_FooterMenuItem2.default, {}, void 0, (0, _jsx3.default)(_AboutLink2.default, {})), (0, _jsx3.default)(_FillHorizontal2.default.Separator, {
  size: 16
}), (0, _jsx3.default)(_FooterMenuItem2.default, {}, void 0, (0, _jsx3.default)(_JobsLink2.default, {})), (0, _jsx3.default)(_FillHorizontal2.default.Separator, {
  size: 16
}), (0, _jsx3.default)(_FooterMenuItem2.default, {}, void 0, (0, _jsx3.default)(_EventsLink2.default, {})), (0, _jsx3.default)(_FillHorizontal2.default.Separator, {
  size: 16
}), (0, _jsx3.default)(_FooterMenuItem2.default, {}, void 0, (0, _jsx3.default)(_SpacesLink2.default, {})), (0, _jsx3.default)(_FillHorizontal2.default.Separator, {
  size: 16
}), (0, _jsx3.default)(_FooterMenuItem2.default, {}, void 0, (0, _jsx3.default)(_SupportLink2.default, {})), (0, _jsx3.default)(_FillHorizontal2.default.Separator, {
  size: 16
}), (0, _jsx3.default)(_FooterMenuItem2.default, {}, void 0, (0, _jsx3.default)(_InstagramLink2.default, {})), (0, _jsx3.default)(_FillHorizontal2.default.Separator, {
  size: 16
}), (0, _jsx3.default)(_FooterMenuItem2.default, {}, void 0, (0, _jsx3.default)(_TwitterLink2.default, {})), (0, _jsx3.default)(_FillHorizontal2.default.Separator, {
  size: 16
}), (0, _jsx3.default)(_FooterMenuItem2.default, {}, void 0, (0, _jsx3.default)(_FacebookLink2.default, {})), (0, _jsx3.default)(_FillHorizontal2.default.Spacer, {
  size: 16
}), (0, _jsx3.default)(_LocaleSwitcher2.default, {})));

var Footer = function (_React$PureComponent) {
  (0, _inherits3.default)(Footer, _React$PureComponent);

  function Footer() {
    (0, _classCallCheck3.default)(this, Footer);
    return (0, _possibleConstructorReturn3.default)(this, (Footer.__proto__ || (0, _getPrototypeOf2.default)(Footer)).apply(this, arguments));
  }

  (0, _createClass3.default)(Footer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'nav',
        (0, _glamor.css)({
          display: 'block',
          position: 'fixed',
          bottom: 0,
          width: '100%',
          margin: 0,
          background: '#fff',
          zIndex: _zIndex.ZINDEX_NAVIGATION,
          borderTop: '1px solid rgba(238,238,238, 1)'
        }),
        _ref
      );
    }
  }]);
  return Footer;
}(_react2.default.PureComponent);

exports.default = Footer;

/***/ }),

/***/ 1288:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _typography = __webpack_require__(1042);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FooterMenuItem(_ref) {
  var children = _ref.children;

  return _react2.default.cloneElement(children, (0, _glamor.css)({
    display: 'block',
    fontSize: 16,
    lineHeight: '20px',
    color: 'inherit',
    textDecoration: 'none',
    fontFamily: _typography.FAMILY_STANDARD,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline'
    }
  }));
}

exports.default = FooterMenuItem;

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _glamor = __webpack_require__(415);

var _DesktopOnly = __webpack_require__(1217);

var _DesktopOnly2 = _interopRequireDefault(_DesktopOnly);

var _MobileOnly = __webpack_require__(1290);

var _MobileOnly2 = _interopRequireDefault(_MobileOnly);

var _zIndex = __webpack_require__(1067);

var _Container = __webpack_require__(1129);

var _Container2 = _interopRequireDefault(_Container);

var _DesktopHeader = __webpack_require__(1291);

var _DesktopHeader2 = _interopRequireDefault(_DesktopHeader);

var _MobileHeader = __webpack_require__(1295);

var _MobileHeader2 = _interopRequireDefault(_MobileHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function (_React$Component) {
  (0, _inherits3.default)(Header, _React$Component);

  function Header() {
    (0, _classCallCheck3.default)(this, Header);
    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
  }

  (0, _createClass3.default)(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewer = _props.viewer,
          isFixed = _props.isFixed;


      var opacity = isFixed ? 1 : 0;

      return _react2.default.createElement(
        'div',
        (0, _glamor.css)({
          backgroundColor: '#fff',
          position: 'relative',
          zIndex: _zIndex.ZINDEX_NAVIGATION,
          borderBottom: '1px solid rgba(238,238,238, ' + opacity + ')'
        }),
        (0, _jsx3.default)(_Container2.default, {}, void 0, (0, _jsx3.default)(_DesktopOnly2.default, {}, void 0, (0, _jsx3.default)(_DesktopHeader2.default, {
          user: viewer.currentUser
        })), (0, _jsx3.default)(_MobileOnly2.default, {}, void 0, (0, _jsx3.default)(_MobileHeader2.default, {
          user: viewer.currentUser
        })))
      );
    }
  }]);
  return Header;
}(_react2.default.Component);

exports.default = _reactRelay2.default.createContainer(Header, {
  fragments: {
    viewer: function viewer() {
      return function (RQL_0, RQL_1) {
        return {
          children: [{
            children: [].concat.apply([], [{
              fieldName: 'id',
              kind: 'Field',
              metadata: {
                isGenerated: true,
                isRequisite: true
              },
              type: 'ID'
            }, _reactRelay2.default.QL.__frag(RQL_0), _reactRelay2.default.QL.__frag(RQL_1)]),
            fieldName: 'currentUser',
            kind: 'Field',
            metadata: {
              canHaveSubselections: true,
              inferredRootCallName: 'node',
              inferredPrimaryKey: 'id'
            },
            type: 'User'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'Header_ViewerRelayQL',
          type: 'Viewer'
        };
      }(_DesktopHeader2.default.getFragment('user'), _MobileHeader2.default.getFragment('user'));
    }
  }
});

/***/ }),

/***/ 1290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MobileOnly;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MobileOnly(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    (0, _glamor.css)({
      display: 'block',
      '@media (min-width: 701px)': { display: 'none' }
    }),
    children
  );
}

/***/ }),

/***/ 1291:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactIntl = __webpack_require__(192);

var _glamor = __webpack_require__(415);

var _FillHorizontal = __webpack_require__(1145);

var _FillHorizontal2 = _interopRequireDefault(_FillHorizontal);

var _ShopLink = __webpack_require__(1146);

var _ShopLink2 = _interopRequireDefault(_ShopLink);

var _Logo = __webpack_require__(1159);

var _Logo2 = _interopRequireDefault(_Logo);

var _HeaderMenuItem = __webpack_require__(1292);

var _HeaderMenuItem2 = _interopRequireDefault(_HeaderMenuItem);

var _Link = __webpack_require__(1046);

var _Link2 = _interopRequireDefault(_Link);

var _Logout = __webpack_require__(1215);

var _Logout2 = _interopRequireDefault(_Logout);

var _SearchLink = __webpack_require__(1293);

var _SearchLink2 = _interopRequireDefault(_SearchLink);

var _DownloadLink = __webpack_require__(1218);

var _DownloadLink2 = _interopRequireDefault(_DownloadLink);

var _DownloadLinkWinAB = __webpack_require__(1294);

var _DownloadLinkWinAB2 = _interopRequireDefault(_DownloadLinkWinAB);

var _LoginLink = __webpack_require__(1202);

var _LoginLink2 = _interopRequireDefault(_LoginLink);

var _browserCookies = __webpack_require__(430);

var _browserCookies2 = _interopRequireDefault(_browserCookies);

var _tracking = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_Logo2.default, {});

var _ref2 = (0, _jsx3.default)(_FillHorizontal2.default.Spacer, {
  size: 24
});

var _ref3 = (0, _jsx3.default)(_HeaderMenuItem2.default, {
  expanded: true
}, void 0, (0, _jsx3.default)(_SearchLink2.default, {}));

var _ref4 = (0, _jsx3.default)(_FillHorizontal2.default.Separator, {
  size: 24
});

var _ref5 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.profileLabel',
  description: 'Profile Label',
  defaultMessage: 'Profile'
});

var _ref6 = (0, _jsx3.default)(_DownloadLinkWinAB2.default, {});

var _ref7 = (0, _jsx3.default)(_FillHorizontal2.default.Separator, {
  size: 24
});

var _ref8 = (0, _jsx3.default)(_Logout2.default, {});

var _ref9 = (0, _jsx3.default)(_LoginLink2.default, {});

var DesktopHeader = function (_React$Component) {
  (0, _inherits3.default)(DesktopHeader, _React$Component);

  function DesktopHeader() {
    (0, _classCallCheck3.default)(this, DesktopHeader);
    return (0, _possibleConstructorReturn3.default)(this, (DesktopHeader.__proto__ || (0, _getPrototypeOf2.default)(DesktopHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(DesktopHeader, [{
    key: 'scrollToTop',
    value: function scrollToTop() {
      return window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var user = this.props.user;

      var scrollToTop = this.scrollToTop;

      return (0, _jsx3.default)('nav', {}, void 0, (0, _jsx3.default)(_FillHorizontal2.default, {}, void 0, _react2.default.createElement(
        'div',
        (0, _glamor.css)({
          flexGrow: '0',
          flexShrink: '0',
          width: '90px'
        }),
        _react2.default.createElement(
          _Link2.default,
          (0, _extends3.default)({
            to: { pathname: '/' },
            onClick: scrollToTop
          }, (0, _glamor.css)({
            display: 'block',
            verticalAlign: 'bottom'
          })),
          _ref
        )
      ), _ref2, _ref3, _ref4, (0, _jsx3.default)(_HeaderMenuItem2.default, {
        expanded: true
      }, void 0, user ? (0, _jsx3.default)(_ShopLink2.default, {
        user: user
      }, void 0, _ref5) : _ref6 || (0, _jsx3.default)(_DownloadLink2.default, {
        onclick: function onclick() {
          return (0, _tracking.trackDownLoadAppHeader)({ source: 'desktop' });
        }
      })), _ref7, (0, _jsx3.default)(_HeaderMenuItem2.default, {
        expanded: true
      }, void 0, user ? _ref8 : _ref9)));
    }
  }]);
  return DesktopHeader;
}(_react2.default.Component);

exports.default = _reactRelay2.default.createContainer(DesktopHeader, {
  fragments: {
    user: function user() {
      return function (RQL_0) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'DesktopHeader_UserRelayQL',
          type: 'User'
        };
      }(_ShopLink2.default.getFragment('user'));
    }
  }
});

/***/ }),

/***/ 1292:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _typography = __webpack_require__(1042);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HeaderMenuItem(_ref) {
  var children = _ref.children,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === undefined ? false : _ref$expanded;

  return _react2.default.cloneElement(children, (0, _glamor.css)({
    display: 'block',
    fontSize: 16,
    lineHeight: '20px',
    color: 'inherit',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontFamily: expanded ? _typography.FAMILY_EXTENDED_BOLD : _typography.FAMILY_STANDARD_BOLD,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline'
    }
  }));
}

exports.default = HeaderMenuItem;

/***/ }),

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(124);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(416);

var _reactIntl = __webpack_require__(192);

var _navigation = __webpack_require__(424);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.searchLabel',
  description: 'Search Label',
  defaultMessage: 'Search'
});

var SearchLink = function SearchLink(_ref) {
  var openSearch = _ref.openSearch,
      props = (0, _objectWithoutProperties3.default)(_ref, ['openSearch']);
  return _react2.default.createElement(
    'a',
    (0, _extends3.default)({ onClick: openSearch }, props),
    _ref2
  );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openSearch: function openSearch() {
      return dispatch((0, _navigation.openSearch)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(SearchLink);

/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(124);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(416);

var _reactIntl = __webpack_require__(192);

var _propTypes = __webpack_require__(144);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HomeAB = __webpack_require__(1147);

var _DownloadLink = __webpack_require__(1218);

var _DownloadLink2 = _interopRequireDefault(_DownloadLink);

var _tracking = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadLinkWinAB = function (_React$Component) {
  (0, _inherits3.default)(DownloadLinkWinAB, _React$Component);

  function DownloadLinkWinAB() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DownloadLinkWinAB);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DownloadLinkWinAB.__proto__ || (0, _getPrototypeOf2.default)(DownloadLinkWinAB)).call.apply(_ref, [this].concat(args))), _this), _this.clickDownloadApp = function () {
      var overlays = _this.props.overlays;


      _this.winExperiment();
      (0, _tracking.trackDownLoadAppHeader)({ source: 'desktop' });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DownloadLinkWinAB, [{
    key: 'winExperiment',
    value: function winExperiment() {
      var overlays = this.props.overlays;
      var landingAB = overlays.landingAB;


      if (!landingAB) {
        return function () {
          return false;
        };
      }

      return (0, _HomeAB.emmitButtonClick)(landingAB, 'download app');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          overlays = _props.overlays,
          dispatch = _props.dispatch,
          props = (0, _objectWithoutProperties3.default)(_props, ['overlays', 'dispatch']);


      return _react2.default.createElement(_DownloadLink2.default, (0, _extends3.default)({ onclick: function onclick() {
          return _this2.clickDownloadApp();
        } }, props));
    }
  }]);
  return DownloadLinkWinAB;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
  var overlays = _ref2.overlays;
  return {
    overlays: overlays
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DownloadLinkWinAB);

/***/ }),

/***/ 1295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactIntl = __webpack_require__(192);

var _reactRedux = __webpack_require__(416);

var _glamor = __webpack_require__(415);

var _navigation = __webpack_require__(424);

var _FillHorizontal = __webpack_require__(1145);

var _FillHorizontal2 = _interopRequireDefault(_FillHorizontal);

var _ShopLink = __webpack_require__(1146);

var _ShopLink2 = _interopRequireDefault(_ShopLink);

var _Logo = __webpack_require__(1159);

var _Logo2 = _interopRequireDefault(_Logo);

var _MobileHeaderItem = __webpack_require__(1296);

var _MobileHeaderItem2 = _interopRequireDefault(_MobileHeaderItem);

var _Link = __webpack_require__(1046);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.menuLabel',
  description: 'Menu Label',
  defaultMessage: 'Menu'
});

var _ref2 = (0, _jsx3.default)(_Logo2.default, {});

var _ref3 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'app.searchLabel',
  description: 'Search Label',
  defaultMessage: 'Search'
});

var MobileHeader = function (_React$Component) {
  (0, _inherits3.default)(MobileHeader, _React$Component);

  function MobileHeader() {
    (0, _classCallCheck3.default)(this, MobileHeader);
    return (0, _possibleConstructorReturn3.default)(this, (MobileHeader.__proto__ || (0, _getPrototypeOf2.default)(MobileHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(MobileHeader, [{
    key: 'scrollToTop',
    value: function scrollToTop() {
      return window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          openSearch = _props.openSearch,
          openMobileNavigation = _props.openMobileNavigation;

      var scrollToTop = this.scrollToTop;

      return _react2.default.createElement(
        'nav',
        (0, _glamor.css)({
          zIndex: 10
        }),
        (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_MobileHeaderItem2.default, {}, void 0, (0, _jsx3.default)('a', {
          onClick: openMobileNavigation
        }, void 0, _ref)), _react2.default.createElement(
          'div',
          (0, _glamor.css)({
            flexGrow: '0',
            flexShrink: '0',
            width: '90px',
            display: 'inline-block',
            position: 'absolute',
            left: '50%',
            marginLeft: '-45px'
          }),
          _react2.default.createElement(
            _Link2.default,
            (0, _extends3.default)({
              to: { pathname: '/' },
              onClick: scrollToTop
            }, (0, _glamor.css)({ display: 'block', verticalAlign: 'bottom' })),
            _ref2
          )
        ), (0, _jsx3.default)(_MobileHeaderItem2.default, {
          float: 'right'
        }, void 0, (0, _jsx3.default)('a', {
          onClick: openSearch
        }, void 0, _ref3)))
      );
    }
  }]);
  return MobileHeader;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openMobileNavigation: function openMobileNavigation() {
      return dispatch((0, _navigation.openMobileNavigation)());
    },
    openSearch: function openSearch() {
      return dispatch((0, _navigation.openSearch)());
    }
  };
};

var connected = (0, _reactRedux.connect)(null, mapDispatchToProps);

exports.default = _reactRelay2.default.createContainer(connected(MobileHeader), {
  fragments: {
    user: function user() {
      return function (RQL_0) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isRequisite: true
            },
            type: 'ID'
          }, _reactRelay2.default.QL.__frag(RQL_0)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'MobileHeader_UserRelayQL',
          type: 'User'
        };
      }(_ShopLink2.default.getFragment('user'));
    }
  }
});

/***/ }),

/***/ 1296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _typography = __webpack_require__(1042);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MobileHeaderItem(_ref) {
  var children = _ref.children,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === undefined ? false : _ref$expanded,
      _ref$float = _ref.float,
      float = _ref$float === undefined ? 'none' : _ref$float;

  return _react2.default.cloneElement(children, (0, _glamor.css)({
    display: 'inline-block',
    fontSize: 16,
    float: float,
    lineHeight: '20px',
    color: 'inherit',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontFamily: expanded ? _typography.FAMILY_EXTENDED_BOLD : _typography.FAMILY_STANDARD_BOLD,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline'
    }
  }));
}

exports.default = MobileHeaderItem;

/***/ }),

/***/ 1297:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

var _zIndex = __webpack_require__(1067);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fixit = function (_React$Component) {
  (0, _inherits3.default)(Fixit, _React$Component);

  function Fixit(props) {
    (0, _classCallCheck3.default)(this, Fixit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Fixit.__proto__ || (0, _getPrototypeOf2.default)(Fixit)).call(this, props));

    _this._handleScroll = function () {
      window.requestAnimationFrame(function () {
        _this.setState({ scrollY: window.scrollY });
      });
    };

    _this.state = { scrollY: 0 };
    return _this;
  }

  (0, _createClass3.default)(Fixit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this._handleScroll);
      this._handleScroll();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this._handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var scrollY = this.state.scrollY;


      var originalStyles = (0, _glamor.css)({
        visibility: 'hidden',
        zIndex: -1,
        position: 'relative'
      });

      var isFixed = scrollY > 0;

      var styles = (0, _glamor.css)({
        position: 'fixed',
        zIndex: _zIndex.ZINDEX_NAVIGATION,
        top: 0,
        left: 0,
        right: 0
      });

      return _react2.default.createElement(
        'div',
        { ref: function ref(el) {
            return _this2._el = el;
          } },
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({ 'aria-hidden': true }, originalStyles),
          children(false, 0)
        ),
        _react2.default.createElement(
          'div',
          styles,
          children(isFixed)
        )
      );
    }
  }]);
  return Fixit;
}(_react2.default.Component);

exports.default = Fixit;

/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(416);

var _overlays = __webpack_require__(426);

var _deeplinks = __webpack_require__(1085);

var _HomeAB = __webpack_require__(1147);

var _contextWrappers = __webpack_require__(1123);

var _AppBanner = __webpack_require__(1307);

var _AppBanner2 = _interopRequireDefault(_AppBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeeplinkBanner = function (_React$Component) {
  (0, _inherits3.default)(DeeplinkBanner, _React$Component);

  function DeeplinkBanner(props) {
    (0, _classCallCheck3.default)(this, DeeplinkBanner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DeeplinkBanner.__proto__ || (0, _getPrototypeOf2.default)(DeeplinkBanner)).call(this, props));

    _this.state = { mounted: false };
    return _this;
  }

  (0, _createClass3.default)(DeeplinkBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ mounted: true });
    }
  }, {
    key: 'winExperiment',
    value: function winExperiment() {
      return (0, _HomeAB.emmitButtonClick)('open in app');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          userAgent = _props.userAgent,
          overlays = _props.overlays,
          onClose = _props.onClose,
          router = _props.router;
      var mounted = this.state.mounted;
      var isJourneyOn = overlays.isJourneyOn,
          open = overlays.open,
          deeplink = overlays.deeplink,
          landingAB = overlays.landingAB;

      var isLanding = router.isActive('/', true);
      // const isVariantB = (landingAB === 'B');
      // const isLandingBVariant = isLanding && isVariantB;
      var bannerShouldNotShow = isJourneyOn || !mounted || !(0, _deeplinks.isBannerPlatform)(userAgent.platform); // || isLandingBVariant || isShopGuest;
      var channel = isLanding ? 'landingpage_mobile_' + (userAgent.isAndroid ? 'google' : 'apple') + '_a' : undefined;

      if (bannerShouldNotShow) {
        return null;
      }

      return _react2.default.createElement(_AppBanner2.default, (0, _extends3.default)({ close: onClose, open: open, clickAction: this.winExperiment }, deeplink, { channel: channel }));
    }
  }]);
  return DeeplinkBanner;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var userAgent = _ref.userAgent,
      overlays = _ref.overlays;
  return {
    userAgent: userAgent,
    overlays: overlays
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch((0, _overlays.closeDeeplinkBanner)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _contextWrappers.withRouter)(DeeplinkBanner));

/***/ }),

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

var _zIndex = __webpack_require__(1067);

var _reactIntl = __webpack_require__(192);

var _Cross = __webpack_require__(1078);

var _Cross2 = _interopRequireDefault(_Cross);

var _colors = __webpack_require__(1043);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseButtonStyle = {
  display: 'flex',
  transition: 'bottom 300ms cubic-bezier(0.25, 0.1, 0.18, 1.4) 2s',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  left: '50%',
  width: '10em',
  marginLeft: '-5em',
  color: 'white',
  backgroundColor: _colors.RED,
  border: '1px solid',
  borderColor: _colors.RED,
  borderRadius: '30px',
  userSelect: 'none',
  outline: 'none',
  zIndex: _zIndex.ZINDEX_DEEPLINKS,
  '@media (min-width: 701px)': {
    display: 'none'
  },
  'body.branch-banner-is-active &': {
    display: 'none'
  }
};

var bannerLinkStyle = {
  display: 'block',
  padding: '10px 0',
  fontSize: '14px',
  textAlign: 'center',
  textDecoration: 'none',
  color: 'inherit',
  outline: 'none'
};

var closeBtnStyle = {
  display: 'block',
  width: '12px',
  height: '14px',
  marginRight: '13px',
  outline: 'none'
};

var _ref = (0, _jsx3.default)(_Cross2.default, {
  fill: 'white'
});

var _ref2 = (0, _jsx3.default)(_reactIntl.FormattedMessage, {
  id: 'AppBanner.openApp',
  description: 'Call to action on app banner, MUST BE SMALL',
  defaultMessage: 'Open in app'
});

var AppBanner = function (_React$Component) {
  (0, _inherits3.default)(AppBanner, _React$Component);

  function AppBanner() {
    (0, _classCallCheck3.default)(this, AppBanner);
    return (0, _possibleConstructorReturn3.default)(this, (AppBanner.__proto__ || (0, _getPrototypeOf2.default)(AppBanner)).apply(this, arguments));
  }

  (0, _createClass3.default)(AppBanner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          link = _props.link,
          open = _props.open,
          close = _props.close,
          clickAction = _props.clickAction,
          channel = _props.channel;

      var deeplinkPath = !!this.props.path;
      var showBtn = link && open && deeplinkPath;
      var href = link + '?channel=' + (channel || 'app%20banner');

      var buttonStyle = (0, _extends3.default)({}, baseButtonStyle, {
        bottom: showBtn ? '20px' : '-140px'
      });

      return _react2.default.createElement(
        'div',
        (0, _glamor.css)(buttonStyle),
        _react2.default.createElement(
          'a',
          (0, _extends3.default)({
            href: 'javascript:;',
            onClick: close
          }, (0, _glamor.css)(closeBtnStyle)),
          _ref
        ),
        _react2.default.createElement(
          'a',
          (0, _extends3.default)({}, (0, _glamor.css)(bannerLinkStyle), {
            onClick: clickAction,
            rel: 'noopener',
            href: href }),
          _ref2
        )
      );
    }
  }]);
  return AppBanner;
}(_react2.default.Component);

exports.default = AppBanner;

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(416);

var _glamor = __webpack_require__(415);

var _reactIntl = __webpack_require__(192);

var _colors = __webpack_require__(1043);

var _zIndex = __webpack_require__(1067);

var _typography = __webpack_require__(1042);

var _Cross = __webpack_require__(1078);

var _Cross2 = _interopRequireDefault(_Cross);

var _Container = __webpack_require__(1129);

var _Container2 = _interopRequireDefault(_Container);

var _overlays = __webpack_require__(426);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// CookieBanner
var mapStateToProps = function mapStateToProps(_ref) {
  var overlays = _ref.overlays;

  var cookiesAccepted = overlays.cookiesAccepted || false;
  return {
    cookiesAccepted: cookiesAccepted
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeBanner: function closeBanner() {
      return dispatch((0, _overlays.closeCookieBanner)());
    }
  };
};

var messages = (0, _reactIntl.defineMessages)({
  cookiesLinkText: {
    'id': 'CookieBanner.linkText',
    'defaultMessage': 'cookies'
  },
  cookiesLinkURL: {
    'id': 'CookieBanner.linkURL',
    'defaultMessage': 'https://depop.zendesk.com/hc/en-gb/articles/115004385847-Cookie-Policy'
  }
});

var defaultBannerMessage = 'Welcome to Depop! By visiting our site you accept the use of {link} which improve the quality of your visit.';

var bannerStyle = {
  position: 'relative',
  zIndex: _zIndex.ZINDEX_COOKIE_BANNER,
  width: '100%',
  backgroundColor: '#f3f3f3',
  color: _colors.BLACK,
  textAlign: 'left',
  padding: 15,
  '@media (min-width: 701px)': {
    textAlign: 'center',
    bottom: '36px',
    padding: '15px 30px 15px 54px'
  }
};

var buttonStyle = (0, _glamor.css)({
  width: 24,
  height: 24,
  padding: 4,
  color: 'black',
  cursor: 'pointer',
  ':hover': {
    color: 'white'
  }
});

var placementWrapStyle = {
  display: 'table',
  width: '100%'
};

var placementStyle = (0, _glamor.css)({
  display: 'table-cell',
  verticalAlign: 'middle'
});

var linkStyle = (0, _glamor.css)({
  color: _colors.BLACK
});

var _ref2 = (0, _jsx3.default)(_Cross2.default, {});

var CookieBanner = function (_React$Component) {
  (0, _inherits3.default)(CookieBanner, _React$Component);

  function CookieBanner() {
    (0, _classCallCheck3.default)(this, CookieBanner);
    return (0, _possibleConstructorReturn3.default)(this, (CookieBanner.__proto__ || (0, _getPrototypeOf2.default)(CookieBanner)).apply(this, arguments));
  }

  (0, _createClass3.default)(CookieBanner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          intl = _props.intl,
          closeBanner = _props.closeBanner,
          cookiesAccepted = _props.cookiesAccepted;

      var currentBannerStyle = (0, _glamor.merge)(bannerStyle, { display: cookiesAccepted ? 'none' : 'block' });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ role: 'alert' }, (0, _glamor.css)(currentBannerStyle)),
        _react2.default.createElement(
          'div',
          (0, _glamor.css)(placementWrapStyle),
          _react2.default.createElement(
            'div',
            (0, _glamor.css)(placementStyle),
            (0, _jsx3.default)(_reactIntl.FormattedMessage, {
              id: 'CookieBanner.message',
              defaultMessage: defaultBannerMessage,
              values: {
                link: _react2.default.createElement(
                  'a',
                  (0, _extends3.default)({}, (0, _glamor.merge)(linkStyle), {
                    href: intl.formatMessage(messages.cookiesLinkURL),
                    rel: 'noopener',
                    target: '_blank' }),
                  intl.formatMessage(messages.cookiesLinkText)
                )
              }
            })
          ),
          _react2.default.createElement(
            'a',
            (0, _extends3.default)({}, (0, _glamor.merge)(buttonStyle, placementStyle), {
              href: 'javascript:;',
              onClick: closeBanner }),
            _ref2
          )
        )
      );
    }
  }]);
  return CookieBanner;
}(_react2.default.Component);

var connectedView = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CookieBanner);

exports.default = (0, _reactIntl.injectIntl)(connectedView);

/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function(root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.4.1';


	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol : "$",		// default currency symbol is '$'
			format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
			decimal : ".",		// decimal point separator
			thousand : ",",		// thousands separator
			precision : 2,		// decimal places
			grouping : 3		// digit grouping (not implemented yet)
		},
		number: {
			precision : 0,		// default precision on numbers is 0
			grouping : 3,		// digit grouping (not implemented yet)
			thousand : ",",
			decimal : "."
		}
	};


	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
		nativeIsArray = Array.isArray,
		toString = Object.prototype.toString;

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js
	 */
	function isString(obj) {
		return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
	}

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js, delegates to ECMA5's native Array.isArray
	 */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
	 * Tests whether supplied parameter is a true object
	 */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
	 * Extends an object with a defaults object, similar to underscore's _.defaults
	 *
	 * Used for abstracting parameter handling from API methods
	 */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
	 * Implementation of `Array.map()` for iteration loops
	 *
	 * Returns a new Array as a result of calling `iterator` on each array value.
	 * Defers to native Array.map if available
	 */
	function map(obj, iterator, context) {
		var results = [], i, j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++ ) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val)? base : val;
	}


	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values (or a function returning
	 * either a string or object)
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if ( typeof format === "function" ) format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if ( isString( format ) && format.match("%v") ) {

			// Create and return positive, negative and zero formats:
			return {
				pos : format,
				neg : format.replace("-", "").replace("%v", "-%v"),
				zero : format
			};

		// If no format, or object is missing valid positive value, use defaults:
		} else if ( !format || !format.pos || !format.pos.match("%v") ) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
				pos : defaults,
				neg : defaults.replace("%v", "-%v"),
				zero : defaults
			};

		}
		// Otherwise, assume format was fine:
		return format;
	}


	/* --- API Methods --- */

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * Alias: `accounting.parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 */
	var unformat = lib.unformat = lib.parse = function(value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function(val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		 // Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
			unformatted = parseFloat(
				("" + value)
				.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
				.replace(regex, '')         // strip out any cruft
				.replace(decimal, '.')      // make sure decimal point is standard
			);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};


	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
	 * problems for accounting- and finance-related software.
	 */
	var toFixed = lib.toFixed = function(value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};


	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 * Alias: `accounting.format()`
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 * 2nd parameter `precision` can be an object matching `settings.number`
	 */
	var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(precision) ? precision : {
					precision : precision,
					thousand : thousand,
					decimal : decimal
				}),
				lib.settings.number
			),

			// Clean up precision
			usePrecision = checkPrecision(opts.precision),

			// Do some calc:
			negative = number < 0 ? "-" : "",
			base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
			mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};


	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, "$", 2, ",", ".", "%s%v")
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 * Second param can be an object matching `settings.currency` which is the easiest way.
	 *
	 * To do: tidy up the parameters
	 */
	var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val){
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero):
			formats = checkCurrencyFormat(opts.format),

			// Choose which format to use for this value:
			useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};


	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 * Second parameter can be an object containing keys that match the params
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 */
	lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero), only need pos for now:
			formats = checkCurrencyFormat(opts.format),

			// Whether to pad at start of string or after currency symbol:
			padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

			// Store value for the length of the longest string in the column:
			maxLength = 0,

			// Format the list according to options, store the length of the longest string:
			formatted = map(list, function(val, i) {
				if (isArray(val)) {
					// Recursively format columns if list is a multi-dimensional array:
					return lib.formatColumn(val, opts);
				} else {
					// Clean up the value
					val = unformat(val);

					// Choose which format to use for this value (pos, neg or zero):
					var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

						// Format this value, push into formatted list and save the length:
						fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

					if (fVal.length > maxLength) maxLength = fVal.length;
					return fVal;
				}
			});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function(val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
			}
			return val;
		});
	};


	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else if (typeof define === 'function' && define.amd) {
		// Return the library as an AMD module:
		define([], function() {
			return lib;
		});
	} else {
		// Use accounting.noConflict to restore `accounting` back to its original value.
		// Returns a reference to the library's `accounting` object;
		// e.g. `var numbers = accounting.noConflict();`
		lib.noConflict = (function(oldAccounting) {
			return function() {
				// Reset the value of the root's `accounting` variable:
				root.accounting = oldAccounting;
				// Delete the noConflict method:
				lib.noConflict = undefined;
				// Return reference to the library to re-assign it:
				return lib;
			};
		})(root.accounting);

		// Declare `fx` on the root (global/window) object:
		root['accounting'] = lib;
	}

	// Root will be `window` in browser or `global` on the server:
}(this));


/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _list = __webpack_require__(1179);

var _isProductViewable = __webpack_require__(1231);

var _isProductViewable2 = _interopRequireDefault(_isProductViewable);

var _ProductListItem = __webpack_require__(1232);

var _ProductListItem2 = _interopRequireDefault(_ProductListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductList = function (_React$PureComponent) {
  (0, _inherits3.default)(ProductList, _React$PureComponent);

  function ProductList() {
    (0, _classCallCheck3.default)(this, ProductList);
    return (0, _possibleConstructorReturn3.default)(this, (ProductList.__proto__ || (0, _getPrototypeOf2.default)(ProductList)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProductList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          listName = _props.listName,
          products = _props.products,
          _props$compact = _props.compact,
          compact = _props$compact === undefined ? false : _props$compact,
          from = _props.from;


      var filteredProducts = products.filter(function (product) {
        return (0, _isProductViewable2.default)(product);
      });

      return (0, _jsx3.default)(_list.ListGrid, {
        compact: compact
      }, void 0, filteredProducts.map(function (product, iterator) {
        return (0, _jsx3.default)(_ProductListItem2.default, {
          from: from,
          product: product,
          listName: listName,
          productListIndex: iterator
        }, product.id);
      }));
    }
  }]);
  return ProductList;
}(_react2.default.PureComponent);

exports.default = _reactRelay2.default.createContainer(ProductList, {
  fragments: {
    products: function products() {
      return function (RQL_0) {
        return {
          children: [].concat.apply([], [{
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isRequisite: true
            },
            type: 'ID'
          }, {
            fieldName: 'publicId',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'slug',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'saleStatus',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'description',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'dateUpdated',
            kind: 'Field',
            metadata: {},
            type: 'Date'
          }, _reactRelay2.default.QL.__frag(RQL_0)]),
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {
            plural: true
          },
          name: 'ProductList_ProductsRelayQL',
          type: 'Product'
        };
      }(_ProductListItem2.default.getFragment('product'));
    }
  }
});

/***/ }),

/***/ 1388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = ListVertical;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ListVertical(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'ul',
    (0, _glamor.style)({ listStyleType: 'none' }),
    children.map(function (child) {
      return (0, _jsx3.default)('li', {}, child.key, child);
    })
  );
}

/***/ }),

/***/ 1389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__(1044);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ListGrid(_ref) {
  var children = _ref.children,
      _ref$compact = _ref.compact,
      compact = _ref$compact === undefined ? false : _ref$compact;

  if (compact) {
    return _react2.default.createElement(
      'ul',
      (0, _extends3.default)({}, (0, _glamor.css)({
        margin: '0 -0.5vw',
        padding: '0',
        listStyle: 'none',
        overflow: 'auto'
      }), (0, _glamor.after)({ content: "''", display: 'table', clear: 'both' })),
      children.map(function (child) {
        return _react2.default.createElement(
          'li',
          (0, _extends3.default)({
            key: child.key
          }, (0, _glamor.css)({
            display: 'block',
            padding: '0.5vw',
            float: 'left',
            width: 'calc(100% / 3)',
            overflow: 'hidden'
          })),
          child
        );
      })
    );
  }

  return _react2.default.createElement(
    'ul',
    (0, _extends3.default)({}, (0, _glamor.css)({
      margin: '0 -0.5vw',
      padding: 0,
      listStyle: 'none',
      overflow: 'auto'
    }), (0, _glamor.media)('(min-width: 700px)', { margin: '0 -1vw' }), (0, _glamor.media)('(min-width: 1000px)', { margin: '0 -1.2vw' }), (0, _glamor.after)({ content: "''", display: 'table', clear: 'both' })),
    children.map(function (child) {
      return _react2.default.createElement(
        'li',
        (0, _extends3.default)({
          key: child.key
        }, (0, _glamor.css)({
          overflow: 'hidden'
        }), (0, _glamor.css)({
          display: 'block',
          padding: '0.5vw',
          float: 'left',
          width: 'calc(100% / 3)'
        }), (0, _glamor.media)('(min-width: 700px)', {
          padding: '0.5vw 1vw',
          width: 'calc(100% / 4)'
        }), (0, _glamor.media)('(min-width: 1000px)', {
          padding: '0.5vw 1.2vw',
          width: 'calc(100% / 6)'
        }), (0, _glamor.media)('(min-width: 1701px)', {
          padding: '0.5vw 1.2vw',
          width: 'calc(100% / 8)'
        })),
        child
      );
    })
  );
}

exports.default = (0, _recompose.pure)(ListGrid);

/***/ }),

/***/ 1390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(124);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.buildProductLocation = buildProductLocation;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__(63);

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _reactRouter = __webpack_require__(64);

var _recompose = __webpack_require__(1044);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildProductLocation(slug, id, from, listIndex) {
  return {
    pathname: '/products/' + slug,
    state: {
      productId: id,
      from: from,
      listIndex: listIndex
    }
  };
}

var ProductLink = function ProductLink(_ref) {
  var product = _ref.product,
      from = _ref.from,
      relay = _ref.relay,
      listIndex = _ref.listIndex,
      props = (0, _objectWithoutProperties3.default)(_ref, ['product', 'from', 'relay', 'listIndex']);
  return _react2.default.createElement(_reactRouter.Link, (0, _extends3.default)({ to: buildProductLocation(product.slug, product.publicId, from, listIndex) }, props));
};

exports.default = _reactRelay2.default.createContainer((0, _recompose.pure)(ProductLink), {
  fragments: {
    product: function product() {
      return function () {
        return {
          children: [{
            fieldName: 'publicId',
            kind: 'Field',
            metadata: {},
            type: 'Int'
          }, {
            fieldName: 'slug',
            kind: 'Field',
            metadata: {},
            type: 'String'
          }, {
            fieldName: 'id',
            kind: 'Field',
            metadata: {
              isGenerated: true,
              isRequisite: true
            },
            type: 'ID'
          }],
          id: _reactRelay2.default.QL.__id(),
          kind: 'Fragment',
          metadata: {},
          name: 'ProductLink_ProductRelayQL',
          type: 'Product'
        };
      }();
    }
  }
});

/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsx2 = __webpack_require__(71);

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = (0, _jsx3.default)('defs', {}, void 0, (0, _jsx3.default)('filter', {
  id: 'a',
  y: '-5%',
  filterUnits: 'objectBoundingBox'
}, void 0, (0, _jsx3.default)('feOffset', {
  dy: '1',
  'in': 'SourceAlpha',
  result: 'shadowOffsetOuter1'
}), (0, _jsx3.default)('feGaussianBlur', {
  'in': 'shadowOffsetOuter1',
  result: 'shadowBlurOuter1',
  stdDeviation: '.5'
}), (0, _jsx3.default)('feColorMatrix', {
  'in': 'shadowBlurOuter1',
  result: 'shadowMatrixOuter1',
  values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
}), (0, _jsx3.default)('feMerge', {}, void 0, (0, _jsx3.default)('feMergeNode', {
  'in': 'shadowMatrixOuter1'
}), (0, _jsx3.default)('feMergeNode', {
  'in': 'SourceGraphic'
}))));

var _ref2 = (0, _jsx3.default)('g', {
  fill: '#FFF',
  fillRule: 'evenodd',
  filter: 'url(#a)',
  transform: 'translate(0 -4)'
}, void 0, (0, _jsx3.default)('path', {
  fillRule: 'nonzero',
  d: 'M18.595 5.018a.805.805 0 0 0-.807-.034l-3.308 1.73V6.56c0-1.414-1.111-2.56-2.481-2.56H3.48C2.111 4 1 5.146 1 6.56v6.88C1 14.854 2.11 16 3.481 16h8.528c1.37 0 2.481-1.146 2.481-2.56v-.154l3.309 1.73a.805.805 0 0 0 .807-.034.86.86 0 0 0 .394-.727v-8.51a.859.859 0 0 0-.405-.727zm-5.759 8.422a.84.84 0 0 1-.827.853H3.48a.84.84 0 0 1-.827-.853V6.56a.84.84 0 0 1 .827-.853h8.528a.84.84 0 0 1 .827.853v6.88zm4.5-.577L14.49 11.37V8.628l2.845-1.494v5.73z'
}), (0, _jsx3.default)('path', {
  stroke: '#FFF',
  strokeWidth: '.75',
  d: 'M3.027 4.901h9.588l.925.933v2.158l4.846-2.158v8.406L13.54 11.95v2.289l-.925.962H3.772l-1.877-.962V6.133z'
}));

exports.default = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({}, (0, _glamor.css)({ display: 'block', width: props.width || 20, height: props.height || 14 }), { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '14', viewBox: '0 0 20 14' }),
    _ref,
    _ref2
  );
};

/***/ }),

/***/ 1397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(278);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(143);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(18);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(19);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _scrollparent = __webpack_require__(1230);

var _scrollparent2 = _interopRequireDefault(_scrollparent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfiniteScroll = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(InfiniteScroll, _React$Component);

  function InfiniteScroll(props) {
    (0, _classCallCheck3.default)(this, InfiniteScroll);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InfiniteScroll.__proto__ || (0, _getPrototypeOf2.default)(InfiniteScroll)).call(this, props));

    _this.scrollListener = _this.scrollListener.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.attachScrollListener();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.attachScrollListener();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          element = _props.element,
          hasMore = _props.hasMore,
          loader = _props.loader,
          style = _props.style,
          disablePaging = _props.disablePaging;


      var ref = function ref(node) {
        _this2.scrollComponent = node;
      };

      var showLoader = hasMore && !disablePaging;

      return _react2.default.createElement(element, { style: style, ref: ref }, children, showLoader && (loader || this._defaultLoader));
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;
      var disablePaging = this.props.disablePaging;

      var offset = void 0;
      if (this.props.useWindow) {
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateTopPosition(el) + el.offsetHeight - scrollTop - window.innerHeight;
        }
      } else {
        if (this.props.isReverse) {
          offset = (0, _scrollparent2.default)(el.parentNode).scrollTop;
        } else {
          var parent = (0, _scrollparent2.default)(el);
          offset = el.scrollHeight - parent.scrollTop - parent.clientHeight;
        }
      }

      if (offset < Number(this.props.threshold)) {
        this.detachScrollListener();
        if (typeof this.props.loadMore === 'function') {
          if (disablePaging) {
            return;
          }
          this.props.loadMore(this.pageLoaded += 1);
        }
      }
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      if (!this.props.hasMore) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow == false) {
        scrollEl = (0, _scrollparent2.default)(this.scrollComponent);
      }

      scrollEl.addEventListener('scroll', this.scrollListener);
      scrollEl.addEventListener('resize', this.scrollListener);

      if (this.props.initialLoad) {
        this.scrollListener();
      }
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = (0, _scrollparent2.default)(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener);
      scrollEl.removeEventListener('resize', this.scrollListener);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
    }
  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this._defaultLoader = loader;
    }
  }]);
  return InfiniteScroll;
}(_react2.default.Component), _class.defaultProps = {
  element: 'div',
  hasMore: false,
  disablePaging: false,
  initialLoad: true,
  pageStart: 0,
  threshold: 250,
  useWindow: true,
  isReverse: false
}, _temp);
exports.default = InfiniteScroll;

/***/ }),

/***/ 1398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(415);

var _colors = __webpack_require__(1043);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bounce = (0, _glamor.keyframes)('bounce', {
  // optional name
  '0%': { transform: 'translateX(0)' },
  '50%': { transform: 'translateX(2rem)' },
  '100%': { transform: 'translateX(0)' }
});

exports.default = function () {
  return _react2.default.createElement(
    'div',
    (0, _glamor.style)({
      position: 'relative',
      width: '3rem',
      height: '3rem',
      margin: '20px auto',
      overflow: 'hidden'
    }),
    _react2.default.createElement('div', (0, _glamor.style)({
      animationName: bounce,
      animationDuration: '1s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'ease-in-out',
      background: _colors.RED,
      width: '1rem',
      height: '1rem',
      position: 'absolute',
      top: '1rem',
      left: 0,
      borderRadius: '50%'
    }))
  );
};

/***/ })

});


// WEBPACK FOOTER //
// 0.ba439ff8926ceb6ab741.js